window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();
/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ General ================*/
// Inspiration: https://www.w3.org/TR/wai-aria-practices/examples/accordion/js/accordion.js
// feature: data-allow-toggle
// Allow for each toggle to both open and close its section. Makes it possible for all sections to be closed. Assumes only one section may be open.

// feature: data-allow-multiple
// Allow for multiple accordion sections to be expanded at the same time. Assumes data-allow-toggle otherwise the toggle on open sections would be disabled.
// __________

// Ex:
// Parent
// <div id="accordionGroup" data-accordion>
// <div id="accordionGroup" data-accordion data-allow-multiple>
// <div id="accordionGroup" data-accordion data-allow-toggle></div>
//  Question
// <div data-accordion-trigger aria-expanded="true / false" aria-controls="#faq-group-{{- id -}}-{{- forloop.index -}}">
// Answer
// <div id="faq-group-{{- id -}}-{{- forloop.index -}}" data-accordion-panel>


theme.accordion = (function () {
    'use strict';

    var selectors = {
        root   : "[data-accordion]",
        trigger: "[data-accordion-trigger]",
        panel  : "[data-accordion-panel]",
        show_all_questions_mobile   : "[data-show-all-questions-mobile]"
    }

    var features = {
        allow_multiple : "[data-allow-multiple]",
        allow_toggle   : "[data-allow-toggle]"

    }

    var data = {
        target_id: 'aria-controls'
    }

    var states = {
        expanded: {
            attr_name: 'aria-expanded',
            attr_values : {
                yes: "true",
                no:  "false"
            }
        },
        disabled: {
            attr_name: 'aria-disabled',
            attr_values : {
                yes: "true",
                no:  "false"
            }
        }
    }

    $(selectors.root).each(function () {
        var $accordion = $(this);
        init($accordion);
    });

    function init ($accordion) {

        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
            isMobile = true;
        }

        var allowsMultiple = $accordion.is(features.allow_multiple);
        var options = {
            allowsMultiple: allowsMultiple,
            allowToggle: (allowsMultiple) ? allowsMultiple : $accordion.is(features.allow_toggle)
        }

        $accordion.on("click", selectors.trigger, function (e) {
            if (document.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').length > 0) {
              var openAccordion = document.querySelector('[data-accordion-trigger][aria-expanded="true"]');
              if (openAccordion != this) {
                // openAccordion.nextElementSibling.style.display = 'none';
                // openAccordion.setAttribute('aria-expanded', 'false');
              }
            }
            e.preventDefault();
            trigger($(this), $accordion, options);
        });

        $accordion.on("click", selectors.show_all_questions_mobile, function (e) {
            e.preventDefault();
            $accordion.toggleClass('show_all_questions');
        });

        // if (isMobile) {
        //   $accordion.find(selectors.trigger).each(function(index, item) {
        //     if (window.location.href.indexOf('/collections/') > -1) {
        //         $(item).click();
        //     }
        //   });
        // }

        $accordion.on('keydown', function (e) {
            handleKeyboard(event, $(this), options);
        });

        if (!options.allowToggle) {
            // Get the first expanded/ active accordion
            var $expanded = $accordion.find('[aria-expanded="true"]').first();

            // If an expanded/ active accordion is found, disable
            if ($expanded.length) {
                $expanded.setAttribute(states.disabled.attr_name, states.disabled.attr_values.yes);
            }
        } else {
            // Get all unexpanded accordion panels
            var $unexpanded = $accordion.find('[aria-expanded="false"]');
            $unexpanded.each(function () {
                var panelId = $(this).attr('aria-controls');
                hidePanel ($(panelId))
            })
        }
    }

    function trigger ($trigger, $accordion, options) {
        var settings = {
            allowsMultiple: options.allowsMultiple,
            allowToggle   : options.allowToggle
        };

        var $targetPanel = $($trigger.attr(data.target_id));

        var isExpanded = $trigger.is("[" + states.expanded.attr_name + "='" + states.expanded.attr_values.yes + "']");
        var $accordionActiveTriggers = $accordion.find("[" + states.expanded.attr_name + "='" + states.expanded.attr_values.yes + "']");
        var $accordionActivePanels = $accordion.find(selectors.panel);

        if (!settings.allowsMultiple && $accordionActiveTriggers.length > 0) {
            // Set the expanded state on the triggering element
            // Hide the accordion sections, using aria-controls to specify the desired section

            // When toggling is not allowed, clean up disabled state
            if (!settings.allowToggle) {
                $accordionActiveTriggers.removeAttr(states.disabled.attr_name);
            }
        }

        if (!isExpanded) {
            // Set the expanded state on the triggering element
            $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.yes);
            // Hide the accordion sections, using aria-controls to specify the desired section
            reveilPanel($targetPanel);

            // If toggling is not allowed, set disabled state on trigger
            if (!settings.allowToggle) {
                $trigger.attr(states.disabled.attr_name, states.disabled.attr_values.yes);
            }
        }
        else if (settings.allowToggle && isExpanded) {
            // Set the expanded state on the triggering element
            $trigger.attr(states.expanded.attr_name, states.expanded.attr_values.no);
            // Hide the accordion sections, using aria-controls to specify the desired section
            hidePanel($targetPanel);
        }
    }

    function reveilPanel ($panel) {
        $panel.slideDown();// .removeClass('hide');
    }

    function hidePanel ($panel) {
        $panel.slideUp(); //.addClass('hide');
    }

    function handleKeyboard (event, $accordion, options) {}
})();

theme.tabs = new function () {
    var selectors = {
        container   : ".tab",
        buttons_bar : ".tab__buttons",
        buttons     : ".tab__buttons__single",
        content     : ".tab__content"
    };

    var modifierClasses = {
        // active_button  : "tab__buttons--overlay-active",
        active_button  : "tab__buttons__single--active",
        active_content : "tab__content--active"
    }

    function tabs () {
        var $tabs = $(selectors.container);
        if (!$tabs.length) return;

        // init tabs
        $tabs.each(function () {
            init($(this));
        });

        return this;
    }

    function init($tab) {
        // Get active tab button
        var $activeButton  = false;
        var $tabButtons    = $tab.find(selectors.buttons);
        var $activeButtons = $tabButtons.is("." + modifierClasses.active_button);

        // if no tab buttons exist, exit.
        if (!$tabButtons.length) return;

        // if active buttons found: select first, else, assign first button as active
        if ($activeButtons.length)
            $activeButton = $activeButtons.first();
        else
            $activeButton = $tabButtons.first();

        // setup listners
        $tab.on('click', selectors.buttons, function () {
            var $button = $(this);
            if ($button.hasClass(modifierClasses.active_button))
                return;

            return open($button);
        });

        open($activeButton);

        // check length
        if ($(selectors.buttons_bar).length > $(window).length)
            $(selectors.buttons_bar).addClass(modifierClasses.active_button);
    }

    function open($activeButton) {
        var $tab      = $activeButton.closest(selectors.container);
        var $buttons  = $tab.find(selectors.buttons);
        var $contents = $tab.find(selectors.content);

        // Rest buttons / content
        $buttons.attr("tabindex", -1);

        $buttons.removeClass(modifierClasses.active_button);
        $contents
            .removeClass(modifierClasses.active_content)
            .hide();

        // Select buttons / content
        var contentId = $activeButton.attr('aria-controls');
        var $activeContent = $('#' + contentId);
        $activeButton.addClass(modifierClasses.active_button);
        $activeContent
            .addClass(modifierClasses.active_content)
            .fadeIn(300);

        $activeButton.attr("tabindex", 0);
    }

    return tabs;
}

theme.Filters = (function() {
    var constants = {
      SORT_BY: 'sort_by'
    };

    var selectors = {
      mainContent    : '#MainCollectionContent',
      sortSelection  : '#SortBy',
      filterTag      : '[data-filter-tag]'
    };

    var data = {
      sortBy: 'data-default-sortby'
    };

    var _sectionSettings = {};

    function Filters(container) {
      var $container = (this.$container = $(container));
      this._sectionSettings = $container.data("sectionSettings") || {};

      this.initSort();
      this.initFilters();
    }

    Filters.prototype.initSort = function () {
      this.defaultSort = this._sectionSettings.sortBy;
      this.$sortSelect = $(selectors.sortSelection, this.$container);
      this.$sortSelect.on('change', this._onSortChange.bind(this));
    }

    Filters.prototype.initFilters = function () {
        this.$container.on('click', selectors.filterTag, this._onFilterChange.bind(this));
    }

    Filters.prototype._onFilterChange = function() {
        // var filter = this._getFilterValue();

        // // remove the 'page' parameter to go to the first page of results
        // var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

        // // only add the search parameters to the url if they exist
        // search = search !== '' ? '?' + search : '';

        // document.location.href = filter + search + selectors.mainContent;

        window.location.href = this._buildUrl();
    };

    Filters.prototype._buildFiltersUrlPart = function () {
        var filtersUrlPart = '';
        this.$container.find(selectors.filterTag).each (function () {
            if (!$(this).is(':checked')) return;

            var tagHandle = $(this).val();
            if (filtersUrlPart == '')
                filtersUrlPart = tagHandle;
            else
                filtersUrlPart += '+' + tagHandle;
        });

        return filtersUrlPart;
    };

    Filters.prototype._onSortChange = function() {
        // var sort = this._sortQuery();
        // var url = window.location.href.replace(window.location.search, '');
        // var queryStringValue = slate.utils.getParameterByName('q');
        // var query = queryStringValue !== null ? queryStringValue : '';

        // if (sort.length) {
        //     var urlStripped = url.replace(window.location.hash, '');
        //     query = query !== '' ? '?q=' + query + '&' : '?';

        //     window.location.href =
        //     urlStripped + query + sort + selectors.mainContent;
        // } else {
        //     // clean up our url if the sort value is blank for default
        //     window.location.href = url;
        // }

        window.location.href = this._buildUrl();
    };

    Filters.prototype._getSortValue = function() {
        return this.$sortSelect.val() || this.defaultSort;
    };

    Filters.prototype._sortQuery = function() {
        var sort = this._getSortValue();
        var query = '';

        if (sort !== this.defaultSort) {
            query = constants.SORT_BY + '=' + sort;
        }

        return query;
    };

    Filters.prototype._buildUrl = function() {
        var baseUrl = this._sectionSettings.collectionUrl;
        var filters = this._buildFiltersUrlPart();
        var sort = this._sortQuery();

        return baseUrl + (filters === ''?'':'/'+filters) + (sort === ''?'':'?'+sort) + selectors.mainContent;
    };

    return Filters;
  })();
/**
 *  Helper for the lazysizes plugin
 * */
theme.lazyloading_helper = (function() {
    var isVerbal = true;

    var config = {
      lazyLoadedEvent: 'lazybeforeunveil',
      lazyLoadingCarousel: '.carousel--lazy',
      lazyLoading__effectClass: 'lazy-effect',
      lazyLoading__effectEndClass: 'lazy-effect--end',
      lazyLoading__loadingClass: '.lazyload',
      lazyLoading__loadedClass: 'lazyloaded'
    };

    remove_skeleton_mutations();
    setTimeout(remove_skeleton_pooling, 1000);
    setInterval(remove_skeleton_pooling, 2500);
    document.addEventListener(config.lazyLoadedEvent, function(e){
        try {
            var $target = $(e.target);
            if (!$target.length) return;

            // check if it's a background image and lazyload it.
            var bg_src = $target.data("bg") || "";
            if (bg_src && bg_src.trim() != "")
                onBGLoaded ($target, bg_src);

            // check if the target is an image and if it has a skelaton parent & remove it
            // remove_skeleton($target);

            // check if the target is part of a carousel
            var $lazy_carousel = $target.closest(config.lazyLoadingCarousel);
            if ($lazy_carousel.length)
                lazyload_carousel ($lazy_carousel);
        } catch (e) {
            logger('error handing lazyloaded image');
            logger(e);
        }
    });

    $(config.lazyLoading__loadingClass).each(function () {
        var $target = $(this);
        var isImage = $target.is('img');

        // var $parentWithEffect = $target.closest('.' + config.lazyLoading__effectClass);
        // if (!$parentWithEffect.length) return;

        if (!isImage) {
            // $parentWithEffect.removeClass(config.lazyLoading__effectClass);
            return;
        }

        // $target.css('opacity', 0);

        var onLoaded = function () {
            onImageLoaded($target);
        }

        if(jQuery().imagesLoaded) {
            $target.imagesLoaded( onLoaded);
        } else {
            $target[0].onload = onLoaded;
        }
    });

    function onImageLoaded ($img) {
        // logger('Remove skeleton of an image');
        var $parentWithEffect = $img.closest('.' + config.lazyLoading__effectClass);
        if ($parentWithEffect.length) $parentWithEffect.addClass(config.lazyLoading__effectEndClass);

        // $img.addClass(config.lazyLoading__effectEndClass);
        // $img.animate({
        //     opacity: 1
        // }, 300, function() {
        //     // Animation complete.
        // });
    }

    /**
     *  Lazy loads BG images
     * */
    function onBGLoaded ($bg, src) {
        try {
            logger('Lazy loading a background, src: ' + src);
            $bg.css("background-image", "url(" + src + ")");

            // remove effect class (if it exists)
            // $parentWithEffect.removeClass(config.lazyLoading__effectClass);
        } catch (e) {
            logger('error lazyloading bg');
            logger(e);
        }
    }

    /**
     *  Update carousel when all images are lazyloaded.
     * */
    function lazyload_carousel ($carousel) {
        try {
            logger('Lazy loading a carousel');
            var $unloaded = $carousel.find(config.lazyLoading__loadingClass);

            logger('$unloaded.length: ' + $unloaded.length);
            if ($unloaded.length > 1) {
                return;
            }

            logger('reload carousel cells');
            $carousel.flickity('reloadCells');
        } catch (e) {
            logger('error error while lazyloading carousel');
            logger(e);
        }
    }

    /**
     *  Lazy loads BG images
     * */
    function remove_skeleton_mutations () {
        // config object
        var mutaionsConfig = {
            attributes: true,
            attributeOldValue: true,
            // attributeFilter: ['class'],
            childList: true,
            subtree: true
        };

        // subscriber function
        // .lazy-effect.lazyloaded
        // .lazy-effect .lazyloaded
        function subscriber(mutations) {
            mutations.forEach(function(mutation) {
                var $target = $(mutation.target);
                if (!$target.hasClass(config.lazyLoading__loadedClass) && $target.find('.' + config.lazyLoading__loadedClass).length == 0) return;
                onImageLoaded($target);
            });
        }

        // instantiating observer
        var observer = new MutationObserver(subscriber);

        // observing target
        $('.' + config.lazyLoading__effectClass).each(function () {
            observer.observe($(this)[0], mutaionsConfig);
        })
    }

    function remove_skeleton_pooling () {
        $('.' + config.lazyLoading__effectClass).each(function () {
            var $target = $(this);
            if (!$target.hasClass(config.lazyLoading__loadedClass) && $target.find('.' +  config.lazyLoading__loadedClass).length == 0) return;
            onImageLoaded($target);
        });
    }

    function logger(log) {
        if(!isVerbal) return;
        if (!window.__THEME_DEBUG) return;
        console.debug(log);
    }
})();

// Youtube video controller
theme.Youtube_videos = new function () {
    // Add these tiny css rules http://www.funkertech.com/windows/w6/sass/bootstrap/_responsive-embed.scss
    // ==> ".embed-responsive" to parent with: ".embed-responsive-16by9" or ".embed-responsive-4by3"
    // ==> ".embed-responsive-item" to video placeholder

    // Should also add custom CSS rules to show/hide cover images or any other elements based on the status data selector
    // ==> ex, .embed-responsive[data-activity-status="playing"], .embed-responsive[data-activity-status="ended"]

    var self = this;

    self.initiated = false;
    self.players = [];
    self.array_videos = [];
    self.lastVideoPlay = null;

    self.selectors = {
        VIDEO : "[data-youtube-id]",
        VIDEOLINK : "[data-popup-video-link]",
        PARENT : ".embed-responsive",
        TRIGGER : ".embed-video-trigger"
    };

    self.data_selectors = {
        INITIATED : 'initiated',
        YOUTUEB_ID : 'youtubeId',
        STATUS : 'activity-status'
    };

    // TODO: revoir.
    $('[data-video-close]').on('click', function() {
        try {
            self.players[self.lastVideoPlay].player.pauseVideo();
        } catch(err){
        }
    })

    function youtube_videos () {
        // Only init if there are youtube placeholders on the page
        if (!$(self.selectors.VIDEO).length) return;

        // Attach cover click events
        $('body').on("click", self.selectors.TRIGGER, function (e) {
            e.preventDefault();
            var current_id = $(this).attr("class").split(' ')[0];
            self.play_video($(this).closest(self.selectors.PARENT), current_id);
        })
        $('body').on("click", self.selectors.VIDEOLINK, function (e) {
            e.preventDefault();
            var current_id = $(this).attr("class").split(' ')[0];
            self.play_video($(this).closest(self.selectors.PARENT), current_id);
        })

        // only load script if the widget was not initiated beforehand.
        if (!self.initiated) {
            // add youtube script
            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            // wait for youtube activation
            window.onYouTubeIframeAPIReady = self.activation_listner;
        }
    }

    self.play_video = function ($parent, youtubeId) {
        try {

            self.array_videos.some(function(video, index) {
              if (video[1] != youtubeId) return false;

              var videoDomId = $parent.find(self.selectors.VIDEO).attr("id");
              if (self.players[videoDomId] != undefined) {
                  if (videoDomId != self.lastVideoPlay && self.lastVideoPlay != null) { // We can run only one video at a time, if another is being played => pause it.
                      //self.players[self.lastVideoPlay].player.pauseVideo();
                  }
                  self.players[videoDomId].player.playVideo();
                  self.lastVideoPlay = videoDomId;
              } else {
                  self.initPlayer(video[0], video[1], video[2], video[3], index);
                  var videoDomId = $parent.find(self.selectors.VIDEO).attr("id");
              }

              return true;
            });
        } catch (e) {
        }
    }

    self.activation_listner = function () {
        self.initiated = true;
        self.iterate();
    }

    self.iterate = function () {
        $(self.selectors.VIDEO).each(function () {
            var videoHolder = $(this);
            if (videoHolder.data(self.data_selectors.INITIATED)) return;

            var youtubeId = videoHolder.data(self.data_selectors.YOUTUEB_ID);

            var domId = videoHolder.prop('id');
            if (!domId) {
              var random = Math.floor(Math.random() * 60000) + 1000;
              domId = 'youtube-placeholder-' + youtubeId + '-' + random;
              videoHolder.attr('id', domId);
            }

            var showControles = videoHolder.data('controls') || 0;
            var autoplay = videoHolder.data('autoplay') || 0;
            var fullscreenAllowed = videoHolder.data('fs') || 0;
            var releventVideos = videoHolder.data('rel') || 0;
            var loop = videoHolder.data('loop') || 0;
            var mute = videoHolder.data('mute') || 0;

            self.array_videos.push([domId, youtubeId, {
                height: '676',
                width: '640',
                showinfo: 0,
                rel: releventVideos || 0,
                fs: fullscreenAllowed || 0,

                // Afficher les controles de la video en option (data attribute)
                controls: showControles || 0,

                // AutoPlay en option (data attribute), il faut ajouter mute: 1 car navigateur ne permet plus de lancer des videos avec son.
                autoplay: autoplay || 0,
                mute: mute || 0,
                showinfo: 0,
                modestbranding: 0,

                // Permettre de lire la video indéfiniment en option (data attribute)
                loop: loop || 0,

                enablejsapi: 1
            }, false ]);

            if (autoplay == 1) {
                self.play_video($("#" + videoHolder.attr('id')).closest(self.selectors.PARENT), youtubeId);
            }
        });
    }

    self.initPlayer = function (domId, videoId, options, isActive, index) {
        if (isActive) return;

        var settings = {
            videoId: videoId,
            events: {
                'onReady': function (event) {
                  self.onPlayerReady(event, index);
                },
                'onStateChange': self.onPlayerStateChange
            }
        };

        settings.playerVars = options;
        var player = new YT.Player(domId, settings);

        var updatedSetting = options || {};
        updatedSetting.player = player;
        self.players[domId] = options || {};

        var videoHolder = $(this);
        videoHolder.data(self.data_selectors.INITIATED, true);
    }

    self.onPlayerReady = function (event, index) {
        var player = event.target;
        var vidDomId = event.target.h.id;
        var playerSettings = self.players[vidDomId];

        if (vidDomId != self.lastVideoPlay && self.lastVideoPlay != null) {
            self.players[self.lastVideoPlay].player.pauseVideo();
        }

        // Mark the current video as active and all the others as inactive.
        for (var i=0; i < self.array_videos.length; i++) {
          var status = false;
          if (i == index) status = true;
          self.array_videos[i][3] = status;
        }

        self.lastVideoPlay = vidDomId;
        player.playVideo();
    }

    self.onPlayerStateChange = function (event) {
        var player = event.target;
        var parent = event.target.h.parentElement;
        var playerId = event.target.l.id;
        var playerSettings = self.players[playerId];

        if (event.data == YT.PlayerState.ENDED) {
            parent.setAttribute('activity-status', 'ended');
        } else if (event.data == YT.PlayerState.PLAYING) {
            parent.setAttribute('activity-status', 'playing');
        } else if (event.data == YT.PlayerState.PAUSED) {
            parent.setAttribute('activity-status', 'paused');
        } else if (event.data == YT.PlayerState.BUFFERING) {
            parent.setAttribute('activity-status', 'buffering');
        } else if (event.data == YT.PlayerState.CUED) {
            parent.setAttribute('activity-status', 'cued');
        } else if (event.data == YT.PlayerState.UNSTARTED) {
            player.playVideo();
        }
    }

    return youtube_videos;
}

var youtubeController = new theme.Youtube_videos();



$(document).ready(function(){
  sizeTheVideo();
  $(window).resize(function(){
    sizeTheVideo();
  });
});


function sizeTheVideo() {
  // - 1.78 is the aspect ratio of the video
  // - This will work if your video is 1920 x 1080
  // - To find this value divide the video's native width by the height eg 1920/1080 = 1.78
  if (window.innerWidth > 640) {
    var aspectRatio = 1.6;
  } else {
    var aspectRatio = 1.78;
  }

    var video = $('[data-video-container] iframe');
    var videoHeight = video.outerHeight();
    var newWidth = videoHeight*aspectRatio;
		var halfNewWidth = newWidth/2;

  //Define the new width and centrally align the iframe
  video.css({"width":newWidth+"px","left":"50%","margin-left":"-"+halfNewWidth+"px"});
}

/**************************
  Custom select
***************************/

theme.searchHighlight = new function() {

  function searchHighlight() {

    // init default settings
    var settings = {
      select: '[data-search-box]',
      accordion : "[data-accordion]",
      trigger: "[data-accordion-trigger]",
      panel  : "[data-accordion-panel]",
      accordionInside   : "[data-inside-accordion]",
      triggerInside : "[data-inside-accordion-trigger]",
      panelInside  : "[data-inside-accordion-panel]",
      noResultMessage  : "[data-no-result-search]"
    };

    // If searchbox is available on the page
    $(settings.select).on("input",function(e){
       searchContent(self, $(this));
    });



    // help: http://stackoverflow.com/a/14031522 & http://stackoverflow.com/a/23266812
    // Also, this function makes use of the library mark.js to heighligh search results.
    function searchContent(context, $searchbox) {

      var $accordion = $(settings.accordion).find(settings.panel);
      var $accordionInside = $(settings.accordionInside).find(settings.panelInside);
      var parent = $searchbox.closest('#shopify-section-mega-section__faq'); // get faq dom root.
      var searchPhrase = $searchbox.val().trim().toLowerCase(); // get search term

      if($searchbox.data("lastval") === searchPhrase) // if search term is identical to the previous one, do nothing.
        return
      $searchbox.data("lastval",searchPhrase); // set the previous search term
      clearTimeout(context.timerid);
      context.timerid = setTimeout(function() {
        $(settings.noResultMessage).removeClass('active');
        $accordion.slideUp();
        $accordionInside.slideUp();
        $(settings.trigger).attr("aria-expanded", "false");
        $(settings.triggerInside).attr("aria-expanded", "false");
        parent.find('.faq-group').show(); // show questions/ answers.
        parent.unmark(); // unset the yellow background of search terms

        if (searchPhrase.trim() === '') // if search term is empty, do nothing.
          return
          var found = false;
       parent.find('.faq-group__question, .faq-group__answer, .faq-group__question-inside, .faq-group__answer-inside').each(function() {
          var s = $(this).text().toLowerCase();
          if (s.indexOf(searchPhrase) > -1) {
            $(this).slideDown();
            $(this).find(settings.accordion).slideDown();
            var $trigger = $(this).find(settings.trigger);
            var $triggerInside = $(this).find(settings.triggerInside);
            $trigger.attr("aria-expanded", "true");
            $triggerInside.attr("aria-expanded", "true");
            var $pannelInside = $(this).find(settings.panelInside);
            $pannelInside.mark(searchPhrase);
            found = true;
          }
        });
        if (!found) {
          $(settings.noResultMessage).addClass('active');
        }
      },500);
    };

  }
  return searchHighlight;
}

var searchHighlight = new theme.searchHighlight();

/**************************
  Echantillons tabs and progress bar
***************************/



theme.echantillonsTabs = new function() {

  function echantillonsTabs() {

    // init default settings
    var settings = {
      button: '[data-echantillons-tab-index]',
      buttonIndex: 'data-echantillons-tab-index',
      tab : "[data-echantillons-tab]",
      checkbox : "[data-echantillons-checkbox]",
      input : "[data-echantillon-check-input]",
      checkboxCustom : "[data-echantillons-checkbox-custom]",
      progressBar : "[data-echantillons-progress-bar]",
      email : "[data-echantillons-email]",
      buttonStep1: "[data-echantillons-step-1-button]",
      buttonStep2: "[data-echantillons-step-2-button]",
      variantSelector: "[data-echantillon-variant-id]",
      variantData: "data-echantillon-variant-id",
      eventCategory: "[data-event-category]",
      eventCategoryData: "data-event-category",
      handleData: "data-echantillon-handle"

    };
    var checkedLenght = 0;
    var emailIsNotEmpty = false;
    var eventCategory = $(settings.eventCategory).attr(settings.eventCategoryData);
    var start = new Date().getTime();
    var awnsers = [];
    var items = [];

    $('.echantillons__tabcontent_quizz-select').on('change', function() {
      $(this).css('color','#0d3c32');
    });

    //Check if step 1 is completed to disabled button
    $(settings.input).on("keyup keydown change",function(event) {
        var empty = false;
        $(settings.input).each(function() {
          if ($(this).val().length == 0) {
              empty = true;
          }
        });
        if (empty) {
            $(settings.buttonStep1).attr('disabled', 'disabled');
            $(settings.buttonStep1).addClass('button--disabled');
        } else {
            $(settings.buttonStep1).attr('disabled', false);
            $(settings.buttonStep1).removeClass('button--disabled');
        }
    });

    if ($('.echantillons__product_list').length > 0) {

      var isMobile = false; //initiate as false
      // device detection
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
          isMobile = true;
      }

      setTimeout(function(){
        $('[data-echantillons-checkbox]').click();
      }, 500);
      if (isMobile) {
        setTimeout(function(){
          var $carousel = $('.echantillons__product_list').flickity({
            prevNextButtons: false,
            groupCells: 1,
            pageDots: true,
            autoPlay: 2500,
            wrapAround: true
          });
          $carousel.flickity('resize');
        }, 800);
      }
    }

    //Step 1 button click
    $(settings.buttonStep1).click(function(){

      try {
        var eventAction = 'submit step 1';
        var end = new Date().getTime();
        var eventLabel = end - start;
        start = new Date().getTime();
        // if(ga) ga('send', 'event', eventCategory, eventAction, eventLabel);

        $(settings.input).each(function(){
          const handle = $(this).attr(settings.handleData);
          const value = $(this).val();
          awnsers[handle] = value;
        });

        $(settings.button).removeClass('current');
        $(settings.tab).removeClass('current');
        $("#tab_echantillons_2").addClass('current');
        $(".echantillons__tab_2").addClass('current');
        $(settings.progressBar).val(66);

      } catch (error) {
        // console.error(error);
        // console.log(eventCategory);
        // console.log(eventAction);
        // console.log(eventLabel);
      }
    })

    //Step 3 button click
    $(settings.buttonStep2).click(function(){

      try {
        var eventAction = 'submit step 3';
        var end = new Date().getTime();
        var eventLabel = end - start;
        start = new Date().getTime();
        // if(ga) ga('send', 'event', eventCategory, eventAction, eventLabel);

        var email_klaviyo = $(settings.email).val();
        var cookie = 'quizz_email='+ email_klaviyo;
        document.cookie = cookie;
        var kObject = {};
        kObject['$email'] = email_klaviyo;
        for(var key in awnsers){
          kObject[key] = awnsers[key];
        }
        // console.log('Kobject', kObject);
        _learnq.push(['identify', kObject]);
        _learnq.push(['track', eventCategory, awnsers]);
		items = [];

        // Slap GTM event
        var gtmProducts = [];
        var productList = 'accueil';
        if(window.location.href.indexOf('products') !== -1) productList = 'suggestion produit';
        else if(window.location.href.indexOf('collection') !== -1) productList = 'category';
        else {
          productList = (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
        }


        $(settings.variantSelector).each(function(){
          if ($(this).hasClass('product__choice--active')) {
            const variant_id = $(this).attr(settings.variantData);
            items.push({id: variant_id, quantity: 1});

            var gtmProduct = {
                quantity: 1,
                conditionnement: $(this).parents('[data-product-echantillon-card]').find('[data-variant-option-name="Conditionnement"]').val(),
                taille: $(this).parents('[data-product-echantillon-card]').find('[data-variant-option-name="Taille"]').val(),
                addToCartType: 'Ajout au panier d\'un achat simple',
                id: $(this).parents('[data-product-echantillon-card]').attr('data-product-id'),
                name: $(this).parents('[data-product-echantillon-card]').attr('data-product-name'),
                price: $(this).parents('[data-product-echantillon-card]').attr('data-product-price'),
                type: $(this).parents('[data-product-echantillon-card]').attr('data-product-type'),
                list:productList,
                espece:$(this).parents('[data-product-echantillon-card]').attr('data-product-espece'),
                stock:$(this).parents('[data-product-echantillon-card]').attr('data-product-stock'),
                discount:$(this).parents('[data-product-echantillon-card]').attr('data-product-discount')
            };

            if($(this).parents('[data-product-echantillon-card]').attr('data-product-review')) {
               gtmProduct.review = $(this).attr('data-product-review');
            }
            if($(this).parents('[data-product-echantillon-card]').attr('data-product-note')) {
              gtmProduct.note = $(this).attr('data-product-note');
            }

            gtmProducts.push(gtmProduct);
          }
        });

        CartJS.addItems(items);

        // $(window).bind('triggerGtmAtc', function(){
        //     console.log('Trigger ATC 2');
        //     var params = {
        //         cartId : CartJS.getCart().cart.token,
        //         cartItem : CartJS.getCart().cart.item_count
        //     }
        //     gtmAddToCart(params, [gtmProduct])
        //     $(window).unbind('triggerGtmAtc');
        // })

      } catch (error) {
        // console.error(error);
        // console.log(eventCategory);
        // console.log(eventAction);
        // console.log(eventLabel);
      }
    })

    //Steps tabs click we can return only in back
    $(settings.button).click(function(){
      var tab_id = $(this).attr(settings.buttonIndex);

      if (tab_id == 'tab_echantillons_1') {
        $(settings.progressBar).val(33);
        $(settings.button).removeClass('current');
        $(settings.tab).removeClass('current');

        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
      } else if (tab_id == 'tab_echantillons_2') {
        if (!$(".echantillons__tab_1").hasClass('current')) {
          $(settings.button).removeClass('current');
          $(settings.tab).removeClass('current');

          $(this).addClass('current');
          $("#"+tab_id).addClass('current');
          $(settings.progressBar).val(66);
          $(settings.checkbox).each(function(){
            $(this).prop( "checked", false );
            $(settings.buttonStep2).attr('disabled', 'disabled');
            $(settings.buttonStep2).addClass('button--disabled');
          })
          checkedLenght = 0;
        }
      } else {
        return false;
      }

    })

    //Checkbox step 2
    $(settings.checkbox).each(function(){
      $(this).before('<div class="product__choice-outbox custom-checkbox" data-echantillons-checkbox-custom><div class="product__choice-inbox"></div></div>');
      if($(this).is(':checked')) {
        $(this).parent('.product-card__checkbox__echantillon').addClass('product__choice--active');
      } else{
         $(this).parent('.product-card__checkbox__echantillon').removeClass('product__choice--active');
      }
    });

    $('body').on('change', '.product-card__checkbox__echantillon--hidden', function(){
      if($(this).is(':checked')){
        $(this).parent('.product-card__checkbox__echantillon').addClass('product__choice--active');
        checkedLenght = checkedLenght + 1;
      } else {
        if (checkedLenght > 0) {
          $(this).parent('.product-card__checkbox__echantillon').removeClass('product__choice--active');
          checkedLenght = checkedLenght - 1;
         }
      }
      goStep3();
    });


    //email Step 2
    $(settings.email).on("keyup keydown change",function(event){
        if ($(this).val().length == 0) {
            emailIsNotEmpty = false;
        } else {
            emailIsNotEmpty = true;
        }
        goStep3();
    });

    function goStep3() {
      if (checkedLenght >= 2) {
        $(settings.checkbox).each(function(){
            if(!$(this).is(':checked')){
                $(this).attr("disabled", true);
            }
          });
      } else {
        $(settings.checkbox).each(function(){
          $(this).removeAttr("disabled");
        });
      }
      if (checkedLenght >= 1 && emailIsNotEmpty) {
        try {
          var eventAction = 'submit step 2';
          var end = new Date().getTime();
          var eventLabel = end - start;
          start = new Date().getTime();

          // if(ga) ga('send', 'event', eventCategory, eventAction, eventLabel);

          $(settings.buttonStep2).attr('disabled', false);
          $(settings.buttonStep2).removeClass('button--disabled');
          $(settings.progressBar).val(100);
          $(".echantillons__tab_2").addClass('passed');
          $(".echantillons__tab_3").addClass('current');
        } catch (error) {
          console.error(error);
        }
      } else {
        $(settings.buttonStep2).attr('disabled', 'disabled');
        $(settings.buttonStep2).addClass('button--disabled');
        $(settings.progressBar).val(66);
        $(".echantillons__tab_2").removeClass('passed');
        $(".echantillons__tab_3").removeClass('current');
      }
    }
  }
  return echantillonsTabs;

}

var echantillonsTabs = new theme.echantillonsTabs();

//inspiration
//https://www.trimardeau.com/article/obfuscation-lien-seo

theme.obflinks = new function () {
    var selectors = {
        link   : "[data-obflink]"
    };


    function obflinks () {
        var obflinks = $(selectors.link);
        if (!obflinks.length) return;

        obflinks.each(function () {
            init($(this));
        });

        return this;
    }

    function init($obflink) {

      var encode = btoa($obflink.data('obflink'));
      $obflink.data('obflink', encode);

      $obflink.on('click', function () {
        var link = atob($(this).data('obflink'))
        if (link === "/account") {
          var portal = (window.FK_ACCOUNT && window.FK_ACCOUNT.portalUrl) || "/pages/account";
          window.location = portal;
        } else {
          window.location = link;
        }
      });
    }

    return obflinks;
}
var obflinks = new theme.obflinks();
/*================ Sections ================*/
/**
* Product Template Script
* ------------------------------------------------------------------------------
* A file that contains scripts highly couple code to the Product template.
*
* @namespace product
*/

function parsePurchaseLimit(value) {
    if (value === undefined || value === null || value === '') return null;
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n;
}

function findCatalogProductByVariantId(variantId) {
    if (typeof all_products === 'undefined' || !all_products) return null;
    var needle = String(variantId);
    for (var k = 0; k < all_products.length; k++) {
        var variants = all_products[k].variants || [];
        for (var v = 0; v < variants.length; v++) {
            if (variants[v].variant && String(variants[v].variant.id) === needle) return all_products[k];
        }
    }
    return null;
}

function cartQuantityForVariantIds(items, variantIds) {
    var qty = 0;
    if (!items || !variantIds || !variantIds.length) return 0;
    for (var i = 0; i < items.length; i++) {
        var id = items[i].variant_id != null ? items[i].variant_id : items[i].id;
        var idStr = String(id);
        for (var j = 0; j < variantIds.length; j++) {
            if (String(variantIds[j]) === idStr) {
                qty += items[i].quantity || 0;
                break;
            }
        }
    }
    return qty;
}

function scopeFromCatalogRecord(record, variantId) {
    var variants = record.variants || [];
    var allIds = [];
    var limited = [];
    for (var i = 0; i < variants.length; i++) {
        if (!variants[i].variant) continue;
        var id = variants[i].variant.id;
        allIds.push(id);
        var lo = parsePurchaseLimit(variants[i].metafields && variants[i].metafields.limited_order);
        if (lo !== null) limited.push({ id: id, limit: lo });
    }

    var own = null;
    for (var j = 0; j < limited.length; j++) {
        if (String(limited[j].id) === String(variantId)) own = limited[j].limit;
    }

    var productLimit = parsePurchaseLimit(record.metafields && record.metafields.limited_order);
    if (productLimit !== null) {
        return { limit: productLimit, variantIds: allIds, variantLimit: own };
    }

    if (limited.length >= 2) {
        var shared = limited[0].limit;
        var same = true;
        for (var s = 1; s < limited.length; s++) {
            if (limited[s].limit !== shared) {
                same = false;
                break;
            }
        }
        if (same) {
            var ids = [];
            for (var t = 0; t < limited.length; t++) ids.push(limited[t].id);
            return { limit: shared, variantIds: ids, variantLimit: own };
        }
    }

    if (own === null) return null;
    return { limit: own, variantIds: [variantId], variantLimit: own };
}

function scopeFromProductDom(variantId) {
    var nodes = document.querySelectorAll('[data-product-purchase-limit][data-product-purchase-variant-ids]');
    var needle = String(variantId);
    for (var i = 0; i < nodes.length; i++) {
        var ids = (nodes[i].getAttribute('data-product-purchase-variant-ids') || '').split(',');
        var found = false;
        var cleanIds = [];
        for (var j = 0; j < ids.length; j++) {
            var clean = String(ids[j] || '').trim();
            if (!clean) continue;
            cleanIds.push(clean);
            if (clean === needle) found = true;
        }
        if (!found) continue;
        var limit = parsePurchaseLimit(nodes[i].getAttribute('data-product-purchase-limit'));
        if (limit === null) return null;
        return { limit: limit, variantIds: cleanIds, variantLimit: limit };
    }
    return null;
}

function getPurchaseLimitScope(variantId) {
    var record = findCatalogProductByVariantId(variantId);
    if (record) {
        var fromCatalog = scopeFromCatalogRecord(record, variantId);
        if (fromCatalog && fromCatalog.variantIds.length > 1) return fromCatalog;
        var fromDom = scopeFromProductDom(variantId);
        if (fromDom && fromDom.variantIds.length > 1) return fromDom;
        return fromCatalog;
    }
    return scopeFromProductDom(variantId);
}

function resolveAllowedAddQuantity(variantId, requestedQty, items, fallbackLimit) {
    var scope = getPurchaseLimitScope(variantId);
    if (!scope) {
        if (fallbackLimit == null || isNaN(fallbackLimit)) {
            return { quantity: requestedQty, blocked: false, limit: null };
        }
        scope = { limit: fallbackLimit, variantIds: [variantId], variantLimit: fallbackLimit };
    }

    var productQty = cartQuantityForVariantIds(items, scope.variantIds);
    var productAllowed = Math.max(0, scope.limit - productQty);
    var allowed = productAllowed;
    var messageLimit = scope.limit;

    if (scope.variantLimit !== null && scope.variantIds.length > 1) {
        var variantQty = cartQuantityForVariantIds(items, [variantId]);
        var variantAllowed = Math.max(0, scope.variantLimit - variantQty);
        if (variantAllowed < productAllowed) messageLimit = scope.variantLimit;
        allowed = Math.min(productAllowed, variantAllowed);
    }

    if (allowed === 0) {
        return { quantity: 0, blocked: true, limit: messageLimit };
    }
    return {
        quantity: Math.min(requestedQty, allowed),
        blocked: false,
        limit: messageLimit
    };
}

function purchaseLimitBlocksLineUpdate(items, variantId, nextLineQty, currentLineQty) {
    var scope = getPurchaseLimitScope(variantId);
    if (!scope) return false;
    var next = parseInt(nextLineQty, 10);
    if (isNaN(next)) return false;
    var current = parseInt(currentLineQty, 10) || 0;
    var productQty = cartQuantityForVariantIds(items, scope.variantIds) - current + next;
    if (productQty > scope.limit) return true;
    if (scope.variantLimit !== null) {
        var variantQty = cartQuantityForVariantIds(items, [variantId]) - current + next;
        if (variantQty > scope.variantLimit) return true;
    }
    return false;
}

function withPurchaseLimit(variantId, quantity, onAllowed, onBlocked) {
    if (typeof resolveAllowedAddQuantity !== 'function') {
        onAllowed(quantity);
        return;
    }
    fetch('/cart.json', { credentials: 'same-origin' })
        .then(function(response) { return response.json(); })
        .then(function(cart) {
            var decision = resolveAllowedAddQuantity(variantId, quantity, (cart && cart.items) || [], null);
            if (decision.blocked) {
                if (typeof onBlocked === 'function') onBlocked(decision);
                return;
            }
            onAllowed(decision.quantity);
        })
        .catch(function() {
            onAllowed(quantity);
        });
}

theme.Product = new function() {

    var selectors = {
        productSectionSelector : '[data-product-container]',
        thumbnailSelector : '[data-product-thumbnail]',
        thumbnailTeesterMobile : '.product__slide-image-teester-trigger-mobile',
        thumbnailAttribute : 'data-product-thumbnail',
        sliderSelector : '[data-product-slider]',
        sliderAttribute : 'data-product-slider',
        subscriptionTooltiptext : '.product-subscription__tooltiptext',
        addToCartTooltiptext : '.product-add-to-cart__tooltiptext',
        frequencySelector : '[data-frequency-selector]',
        intervalUnitTypeSelector : '[data-interval-unit-type]',
        intervalUnitTypeAttribute : 'data-interval-unit-type',
        subscriptionActiveSelector : '[data-subscription-activate]',
        oneshotActiveSelector : '[data-oneshot-activate]',
        optionActiveClass : 'product__choice--active',
        optionDisableClass : 'product__choice--disable',
        addToCartSelector : '[data-add-to-cart]',
        addToCartDualSelector : '[data-add-to-cart-dual]',
        oneshotUnitPrice : '[data-oneshot-unit-price]',
        oneshotUnitPriceRrp : '[data-oneshot-unit-price-rrp]',
        subscriptionUnitPrice : '[data-subscription-unit-price]',
        subscriptionWeightPrice : '[data-subscription-weight-price]',
        oneshotWeightPrice : '[data-oneshot-weight-price]',
        oneshotQtyPrice : '[data-oneshot-quantity-price]',
        oneshotQtyPriceRrp : '[data-oneshot-quantity-price-rrp]',
        subscriptionQtyPrice : '[data-subscription-quantity-price]',
        subscriptionFrequencyContainer : '[data-frequency-container]',

        oneshotVariantAttribute : 'data-oneshot-variant-id',
        variantSubscriptionPriceAttribute : 'data-subscription-price',
        variantOneshotPriceAttribute : 'data-oneshot-price',
        variantOneshotPriceRrpAttribute : 'data-oneshot-price-rrp',
        variantOptionSelector:'[data-variant-option]',
        plusButton : '[data-product-plus]',
        minusButton : '[data-product-minus]',
        maximumAttribute : 'data-product-maximum',
        optionSelector : '[data-option-selector]',
        optionIndex : 'data-option-index',
        productSelect : '[data-product-select]',
        productSelect2 : '[data-product-2-select]',
        productQty : '[data-product-quantity]',
        orderPrice : '[data-order-price]',
        featuredImageAttribute : 'data-featured-image-id',

        openQuickview : '[data-open-quickview]',
        closeQuickview : '[data-close-quickview]',
        quickviewIdAttr : 'data-product-id',
        quickviewHandleAttribute : 'data-product-handle',
        quickviewSubsciptionAttribute : '[data-open-quickview-subscription]',
        quickviewSelector : '[data-quickview]',
        quickviewContainerSelector : '[data-quickview-container]',
        productQuickviewSelector : '[data-quickview-product]',
        productTeester : '[data-teester-product]',
        productTeesterData : 'data-teester-product',
        productTeesterPlayerReviews : '[data-teester-player-reviews]',
        nonScrollClass : 'non-scroll'

    };

    /**
    * Product section constructor. Runs on page load as well as Theme Editor
    * `section:load` events.
    * @param {string} container - selector for the section container DOM element
    */
    function Product(container) {
        $(function(){
          var $productSection = $(selectors.productSectionSelector)

            if($productSection.length > 0){
                filterSelectElements($productSection);
            }

            $(window).on('productLoaded', function(){
                var $productSection = $(selectors.productSectionSelector)
                if($productSection.length > 0){
                    initProductHandlers($productSection);
                    updateUnitPrices($productSection);
                    updateAddToCartVisibility($productSection);
                }
                initCardsHandlers();

                // Check url A/B test
                const queryString = window.location.search;
                if(queryString.indexOf('subscription=false') == -1){
                    //$('[data-subscription-activate]').click();
                }
            })

        });
    };

    // Make updateOthersSubscriptions available globally for landing pages
    // This needs to be defined outside initProductHandlers so it's available on all pages
    window.updateOthersSubscriptions = function(newFrequency) {
      return new Promise(async (resolve, reject) => {
        try {
          // Helper function to get product data
          async function getProductForSubscription(handle) {
            return await fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
              }
            }).then(response => {
              return response.json();
            }).catch((error) => {
              console.error('Error fetching product:', error);
              return null;
            });
          }
          
          var _cart = await (await fetch(`/cart.json`)).json();
          var subscriptions = [];
    
          for (let i = 0; i < _cart.items.length; i++) {
            var element = _cart.items[i];
            if (element.properties && element.properties.hasOwnProperty('_shipping_interval_frequency')) {
              subscriptions.push(
                {
                  "subscription_index": i + 1,
                  "subscription_key": element.key,
                  "subscription_variant_id": element.variant_id,
                  "subscription_handle": element.handle,
                  "subscription_quantity": element.quantity
                }
              );
            }
          }
    
          for (let index = 0; index < subscriptions.length; index++) {
            var handle = subscriptions[index].subscription_handle;
            var product = await getProductForSubscription(handle);
    
            if (product && product.selling_plan_groups && product.selling_plan_groups[0] && product.selling_plan_groups[0].selling_plans) {
              var sellingPlans = product.selling_plan_groups[0].selling_plans;
              for (let j = 0; j < sellingPlans.length; j++) {
                if (sellingPlans[j].name.indexOf('Livraison tous les ' + newFrequency + ' jours') > -1) {
                  var data = {
                    'properties': {
                      '_shipping_interval_frequency': newFrequency,
                      '_shipping_interval_unit_type': "Days"
                    },
                    'selling_plan': sellingPlans[j].id,
                    //'line': subscriptions[index].subscription_index,
                    'id': subscriptions[index].subscription_key,
                    'quantity': subscriptions[index].subscription_quantity
                  };
    
                  const result = await fetch("/cart/change.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "Accept": "application/json"
                    },
                    body: JSON.stringify(data)
                  });
                  await result.json();
                }
              }
            }
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    };
    
    // Also make getProductForSubscription available globally
    window.getProductForSubscription = async function(handle) {
      return await fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      }).then(response => {
        return response.json();
      }).catch((error) => {
        console.error('Error fetching product:', error);
        return null;
      });
    };

    function initProductHandlers($productSection) {
        function getSelectedVariantLimit() {
            var $selectedVariantOption = $(selectors.productSelect + ' option:selected', $productSection);
            var selectedLimit = parseInt($selectedVariantOption.attr('data-quantity-max'), 10);
            var limit = 25;
            if (!Number.isNaN(selectedLimit)) {
              limit = selectedLimit;
            } else {
              var maxAttr = $(selectors.plusButton, $productSection).attr(selectors.maximumAttribute);
              if (maxAttr) {
                var parsedMax = parseInt(maxAttr, 10);
                if (!Number.isNaN(parsedMax)) {
                  limit = parsedMax;
                } else {
                  try {
                    var maxVariantList = JSON.parse(maxAttr);
                    var variantId = $selectedVariantOption.attr(selectors.oneshotVariantAttribute);
                    if (Array.isArray(maxVariantList)) {
                      for (var idx = 0; idx < maxVariantList.length; idx++) {
                        if (maxVariantList[idx].variant_id == variantId) {
                          limit = parseInt(maxVariantList[idx].quantity_max, 10) || 25;
                          break;
                        }
                      }
                    }
                  } catch (e) {}
                }
              }
            }

            var productCap = parsePurchaseLimit($productSection.attr('data-product-purchase-limit'));
            if (productCap !== null) return Math.min(limit, productCap);
            return limit;
        }

        function showRevampQtyLimitError(limit) {
            var maxLabel = parseInt(limit, 10);
            if (Number.isNaN(maxLabel)) maxLabel = 3;
            var $el = $('[data-qty-limit-error]', $productSection);
            if (!$el.length) {
              $el = $productSection.closest('[data-pdp-revamp]').find('[data-qty-limit-error]');
            }
            if (!$el.length) return;

            var unitLabel = maxLabel === 1 ? 'unité' : 'unités';
            $el
              .text('Limité à ' + maxLabel + ' ' + unitLabel + ' par commande')
              .removeAttr('hidden');

            clearTimeout($el.data('hideTimer'));
            var hideTimer = setTimeout(function() {
              $el.attr('hidden', '');
            }, 5000);
            $el.data('hideTimer', hideTimer);
        }

        function showLimitedOrderTooltip($trigger, limit) {
            // PDP revamp: Figma inline message below purchase options (not ATC tooltip)
            if ($('[data-pdp-revamp]').length && $('[data-qty-limit-error]').length) {
              showRevampQtyLimitError(limit);
              return;
            }

            var msg = 'Vous ne pouvez pas ajouter plus de ' + limit;
            var $tooltip = $trigger.find(selectors.addToCartTooltiptext);

            // Fallback to any add-to-cart tooltip in this product section.
            if (!$tooltip.length) {
              $tooltip = $(selectors.addToCartSelector, $productSection).find(selectors.addToCartTooltiptext).first();
            }

            if ($tooltip.length) {
              $tooltip.text(msg).removeAttr('hidden');
              setTimeout(function() { $tooltip.attr('hidden', '').text(''); }, 5000);
            }
        }

        function showQuantityLimitTooltip(limit) {
            if ($('[data-pdp-revamp]').length && $('[data-qty-limit-error]').length) {
              showRevampQtyLimitError(limit);
              return;
            }

            var $qtyTooltip = $(selectors.plusButton + ' + .product__tooltiptext', $productSection);
            var maxLabel = parseInt(limit, 10);
            if (Number.isNaN(maxLabel)) maxLabel = 3;
            var hasQtyTooltip = $qtyTooltip.length > 0;

            if (hasQtyTooltip) {
              $qtyTooltip.find('.text').html('Vous ne pouvez pas ajouter plus de ' + maxLabel);
              $qtyTooltip.addClass('active');
              setTimeout(function() {
                $qtyTooltip.removeClass('active');
              }, 5000);
            }

            // Also show on add-to-cart CTA tooltip as a robust fallback for PDP layouts
            // where quantity tooltip can be visually suppressed.
            var $visibleAtc = $(selectors.addToCartSelector + ':visible', $productSection).first();
            if ($visibleAtc.length) {
              showLimitedOrderTooltip($visibleAtc, maxLabel);
            } else {
              var $firstAtc = $(selectors.addToCartSelector, $productSection).first();
              if ($firstAtc.length) showLimitedOrderTooltip($firstAtc, maxLabel);
            }
        }

        function hideQuantityLimitTooltip() {
            $(selectors.plusButton + ' + .product__tooltiptext', $productSection).removeClass('active');
            $(selectors.addToCartSelector, $productSection)
              .find(selectors.addToCartTooltiptext)
              .attr('hidden', '')
              .text('');
        }

        function syncQuantityLimitUi(showTooltip) {
            var qty = parseInt($(selectors.productQty, $productSection).html(), 10) || 1;
            var max = getSelectedVariantLimit();

            if (qty > max) {
              qty = max;
              $(selectors.productQty, $productSection).html(max);
              updateQuantityPrices($productSection);
              updateButtonPrice($productSection);
            }

            if (qty >= max) {
              $(selectors.plusButton, $productSection).addClass('product__qty-btn-disabled');
              if (showTooltip) showQuantityLimitTooltip(max);
            } else {
              $(selectors.plusButton, $productSection).removeClass('product__qty-btn-disabled');
              hideQuantityLimitTooltip();
            }
        }

        // Show/hide add-to-cart when variant (and its availability) changes
        $(selectors.productSelect, $productSection).on('change', function() {
            updateAddToCartVisibility($productSection);
        });

        // Init onscroll
        $(window).on("scroll", function() {
			if($(window).width() > 900){
				if($(window).scrollTop() < ($(window).height() / 2))$('[data-product-footer]').removeClass('product-footer__container--active');
				else $('[data-product-footer]').addClass('product-footer__container--active');
			}else{
				if($(window).scrollTop() < ($(window).height() * 2))$('[data-product-footer]').removeClass('product-footer__container--active');
				else $('[data-product-footer]').addClass('product-footer__container--active');
			}
		});

        if ( matchMedia('screen and (min-width: 768px)').matches ) {
            $('.product__slide-teester').remove();
        } else {

        }


        // product véto

        var veto_encart = document.querySelector('.product__encart-veto');

        if (veto_encart) {
          var veto_encart_text = veto_encart.querySelector('.product__encart-veto__text');
          veto_encart.addEventListener('click', () => {
            veto_encart.classList.toggle('active');
            if (veto_encart.classList.contains('active')) {
              veto_encart_text.style.maxHeight = veto_encart_text.scrollHeight + 20 + 'px';
              veto_encart_text.style.height = veto_encart_text.scrollHeight + 20 + 'px';
            } else {
              veto_encart_text.style.maxHeight = 0;
            }
          })
        }

        const detailsButtons = document.querySelectorAll('.product-details__button');
        const detailsContent = document.querySelectorAll('.product-details__content');
        const mobileMediaQuery = window.matchMedia('(max-width: 768px)'); // Media query pour détection mobile
        const isMobile = mobileMediaQuery.matches; // Détection mobile basée sur la largeur de l'écran

        // Fonction pour vérifier si on est sur mobile
        function isMobileViewport() {
          return mobileMediaQuery.matches;
        }

        // Fonction pour supprimer toutes les classes "active"
        function clearActiveClasses() {
          document.querySelectorAll('.product-details__button.active').forEach(button => button.classList.remove('active'));
          document.querySelectorAll('.product-details__content.active').forEach(content => content.classList.remove('active'));
        }

        // Fonction pour garantir qu'un seul accordion soit ouvert sur desktop
        function enforceSingleActiveDesktop() {
          const activeButtons = document.querySelectorAll('.product-details__button.active');
          if (activeButtons.length > 1) {
            // Garder seulement le premier actif, fermer les autres
            for (let i = 1; i < activeButtons.length; i++) {
              const button = activeButtons[i];
              const index = Array.from(detailsButtons).indexOf(button);
              button.classList.remove('active');
              if (detailsContent[index]) {
                detailsContent[index].classList.remove('active');
              }
            }
          }
        }

        // Si sur mobile, supprimer les classes actives initiales
        // Commented out to respect the close_first_item setting from the schema
        // if (isMobile) {
        //   clearActiveClasses();
        // }

        // Only call enforceSingleActiveDesktop if we're not on mobile
        try {
          if (typeof isMobileViewport === 'function' && !isMobileViewport()) {
            if (typeof enforceSingleActiveDesktop === 'function') {
              enforceSingleActiveDesktop();
            }
          }
        } catch (error) {
          console.error('Error in isMobileViewport check:', error);
        }

        const handleViewportChange = (event) => {
          if (!event.matches) {
            if (typeof enforceSingleActiveDesktop === 'function') {
              enforceSingleActiveDesktop();
            }
          }
        };

        if (typeof mobileMediaQuery.addEventListener === 'function') {
          mobileMediaQuery.addEventListener('change', handleViewportChange);
        } else if (typeof mobileMediaQuery.addListener === 'function') {
          mobileMediaQuery.addListener(handleViewportChange);
        }

        // Ajouter les événements aux boutons
        const isPdpRevamp = !!document.querySelector('[data-pdp-revamp]');
        detailsButtons.forEach((button, index) => {
          button.addEventListener('click', () => {
            const isActive = button.classList.contains('active');
            const isMobileView = isMobileViewport();

            // FKLN-427 revamp: exclusive accordion everywhere
            // Legacy templates: exclusive on desktop, multi-open on mobile
            if (isPdpRevamp || !isMobileView) {
              detailsButtons.forEach((btn, idx) => {
                if (btn === button) {
                  btn.classList.toggle('active', !isActive);
                  if (detailsContent[idx]) {
                    detailsContent[idx].classList.toggle('active', !isActive);
                  }
                } else {
                  btn.classList.remove('active');
                  if (detailsContent[idx]) {
                    detailsContent[idx].classList.remove('active');
                  }
                }
              });
            } else {
              button.classList.toggle('active', !isActive);
              if (detailsContent[index]) {
                detailsContent[index].classList.toggle('active', !isActive);
              }
            }

            if (!isActive) {
              window.dispatchEvent(new Event('resize'));
              if (isPdpRevamp) {
                var drawerLabel = button.getAttribute('data-drawer-label') || button.textContent.trim();
                window.dispatchEvent(new CustomEvent('hb_navigation_click', {
                  detail: {
                    type: 'pdp_drawer',
                    name: 'drawer_open',
                    click_text: drawerLabel,
                    click_link: '/'
                  }
                }));
              }
            }
          });
        });

        // Init slider
        var mobileSlider = false;
        var flickitySettings = JSON.parse($(selectors.sliderSelector , $productSection).attr(selectors.sliderAttribute));
        if ( matchMedia('screen and (min-width: 768px)').matches ) {

        }else{
            flickitySettings.pageDots = true;
        }

        var $carousel = $(selectors.sliderSelector, $productSection).flickity(flickitySettings);
        if (isPdpRevamp) {
          $carousel.on('change.flickity', function(event, index) {
            window.dispatchEvent(new CustomEvent('hb_navigation_click', {
              detail: {
                type: 'pdp_gallery',
                name: 'product_visual_interaction',
                click_text: String(index + 1),
                click_link: '/'
              }
            }));
          });
        }
        $(selectors.thumbnailSelector, $productSection).click(function(){

            if ($(this).hasClass('product__thumbnail-teester-container') && $(window).width() > 800) {
                window.onTeesterReady = (window.onTeesterReady || []);
                window.onTeesterReady.push((SDK) => {
                    var TEESTER_PLAYER_KEY = "121ab140-15e8-4a6d-9430-0214e69c1838";
                    var TEESTER_TRACKING_KEY = "1a800fa1-58a1-4f6a-a729-8048bbedc34d";
                    var PRODUCT_REFERENCE = $(selectors.productTeester).attr(selectors.productTeesterData);


                    const modal = SDK.init({
                        type: 'player-modal',
                        args: {
                           key: TEESTER_PLAYER_KEY,
                           product: PRODUCT_REFERENCE
                        }
                    });
                })
            } else {
                var index = $(this).attr(selectors.thumbnailAttribute);
                $carousel.flickity( 'select', index );
                $(selectors.thumbnailSelector, $productSection).each(function(){
                    $(this).removeClass('product__thumbnail-border--active');
                });
                $(this).addClass('product__thumbnail-border--active');
            }
        });

        $(selectors.thumbnailTeesterMobile, $productSection).click(function(){

            if ($(window).width() < 800) {
                window.onTeesterReady = (window.onTeesterReady || []);
                window.onTeesterReady.push((SDK) => {
                    var TEESTER_PLAYER_KEY = "121ab140-15e8-4a6d-9430-0214e69c1838";
                    var TEESTER_TRACKING_KEY = "1a800fa1-58a1-4f6a-a729-8048bbedc34d";
                    var PRODUCT_REFERENCE = $(selectors.productTeester).attr(selectors.productTeesterData);
                    const modal = SDK.init({
                        type: 'player-modal',
                        args: {
                           key: TEESTER_PLAYER_KEY,
                           product: PRODUCT_REFERENCE
                        }
                    });
                })
            }
        });


        $carousel.on('select.flickity', function() {
            var flkty = $carousel.data('flickity');
            $(selectors.thumbnailSelector, $productSection).each(function(){
                $(this).removeClass('product__thumbnail-border--active');
            });
            $('[data-product-thumbnail=' + flkty.selectedIndex + ']', $productSection).addClass('product__thumbnail-border--active');
        });


        $(selectors.subscriptionActiveSelector, $productSection).click(function(){
            if($(this).hasClass(selectors.optionDisableClass)) return ;
            $(this).addClass(selectors.optionActiveClass);
            $(selectors.oneshotActiveSelector, $productSection).removeClass(selectors.optionActiveClass);
            $(selectors.subscriptionFrequencyContainer).show();
            $(selectors.addToCartSelector).addClass('green-background');
            updateButtonPrice();
            var addToCartType = 'Ajout au panier d\'un abonnement';
            var productType = 'Abonnement';
            var quantity = $(selectors.productQty, $productSection).html();

            var gtmProduct = {
                quantity : quantity,
                conditionnement : $(this).parents('[data-product-container]').find('[data-variant-option-name="Conditionnement"]').val(),
                taille : $(this).parents('[data-product-container]').find('[data-variant-option-name="Taille"]').val(),
                addToCartType : addToCartType,
                id : $(this).parents('[data-product-container]').attr('data-product-id'),
                name : $(this).parents('[data-product-container]').attr('data-product-name'),
                price : $(this).parents('[data-product-container]').attr('data-product-price'),
                type : $(this).parents('[data-product-container]').attr('data-product-type'),
                productType : productType,
                list: (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
                espece:$(this).parents('[data-product-container]').attr('data-product-espece'),
                stock:$(this).parents('[data-product-container]').attr('data-product-stock'),
                discount:$(this).parents('[data-product-container]').attr('data-product-discount'),
            };
            if($(this).parents('[data-product-container]').attr('data-product-review')) gtmProduct.review = $(this).parents('[data-product-container]').attr('data-product-review');
            if($(this).parents('[data-product-container]').attr('data-product-note')) gtmProduct.note = $(this).parents('[data-product-container]').attr('data-product-note');

            // $(window).bind('triggerGtmAtc', function(){
            //     $(window).unbind('triggerGtmAtc');
            //     var params = {
            //         cartId : CartJS.cart.token,
            //         cartItem : CartJS.cart.item_count,
            //         cartTotal: CartJS.cart.total_price
            //     }
            //     console.log('Gtm product in bind ', gtmProduct);
            //     gtmAddToCart(params, [gtmProduct])
            // })
        });
        $(selectors.oneshotActiveSelector, $productSection).click(function(){
            $(this).addClass(selectors.optionActiveClass);
            $(selectors.subscriptionActiveSelector, $productSection).removeClass(selectors.optionActiveClass);
            $(selectors.subscriptionFrequencyContainer).hide();
            $(selectors.addToCartSelector).removeClass('green-background');
            updateButtonPrice();
        });
        setTimeout(() => {
          if (document.querySelector('[data-product-select] [data-option-1="15 kg"]') != null && document.querySelector('[data-product-select] [data-option-1="15 kg"]') != undefined) {
            if (document.querySelector('[data-product-select] [data-option-1="15 kg"]').hasAttribute('disabled')) {
              document.querySelector('.product__option.first #Grande').setAttribute('disabled', 'disabled');
            }
          }
        }, 100);

        // Change quantity
        $(selectors.plusButton, $productSection).click(function(){
            var qty = $(selectors.productQty, $productSection).html();
            var max = getSelectedVariantLimit();
            // var selectedVariant = document.querySelector('[data-product-select]').value;
            // console.log('selectedVariant : ',selectedVariant);
            // var subscriptionLink = document.querySelector('.product-subscription-link').getAttribute('href').split('?')[0];
            // var subscriptionLinkParams = document.querySelector('.product-subscription-link').getAttribute('href').split('?')[1];
            // var urlParams = new URLSearchParams(subscriptionLinkParams);
            // console.log(subscriptionLink);
            // console.log("urlParams");
            // console.log(urlParams);
            // var subscriptionType = urlParams.get('type');
            // var selectedVariant = urlParams.get('variant');
            // var subscriptionCategorie = urlParams.get('categorie');
            // urlParams.set('type', subscriptionType);
            // urlParams.set('categorie', subscriptionCategorie);
            // urlParams.set('variant', selectedVariant);


            //
            if(qty < max) {
              qty++;
              // urlParams.set('quantity', qty);
              // var newSubscriptionLink = subscriptionLink + "?" + urlParams;
              // console.log(newSubscriptionLink);
              // document.querySelector('.product-subscription-link').setAttribute('href', newSubscriptionLink);
            } else {
              qty = max;
            }

            if (qty >= max) {
              $(selectors.plusButton, $productSection).addClass('product__qty-btn-disabled');
              showQuantityLimitTooltip(max);
            } else {
              $(selectors.plusButton, $productSection).removeClass('product__qty-btn-disabled');
            }

            $(selectors.productQty, $productSection).html(qty);
            updateQuantityPrices($productSection);
            updateButtonPrice($productSection);
        });

        $(selectors.plusButton + ' + .product__tooltiptext .close', $productSection).click(function(){
          $(selectors.plusButton + ' + .product__tooltiptext', $productSection).removeClass('active');
        })
        $(selectors.minusButton, $productSection).click(function(){
            var qty = $(selectors.productQty, $productSection).html();
            if(qty > 1) {
              qty--;
              // var selectedVariant = document.querySelector('[data-product-select]').value;
              // console.log('selectedVariant : ',selectedVariant);
              // var subscriptionLink = document.querySelector('.product-subscription-link').getAttribute('href').split('?')[0];
              // var subscriptionLinkParams = document.querySelector('.product-subscription-link').getAttribute('href').split('?')[1];
              // var urlParams = new URLSearchParams(subscriptionLinkParams);
              // console.log(subscriptionLink);
              // console.log("urlParams");
              // console.log(urlParams);
              // var subscriptionType = urlParams.get('type');
              // var selectedVariant = urlParams.get('variant');
              // var subscriptionCategorie = urlParams.get('categorie');
              // urlParams.set('type', subscriptionType);
              // urlParams.set('categorie', subscriptionCategorie);
              // urlParams.set('variant', selectedVariant);
              // urlParams.set('quantity', qty);
              // var newSubscriptionLink = subscriptionLink + "?" + urlParams;
              // console.log(newSubscriptionLink);
              // document.querySelector('.product-subscription-link').setAttribute('href', newSubscriptionLink);
            }
            $(selectors.productQty, $productSection).html(qty);
            updateQuantityPrices($productSection);
            updateButtonPrice($productSection);
            syncQuantityLimitUi(false);
        });

        var productOptions = document.querySelectorAll('.product__option-radio-buttons:not(.has-poids)');
        for (let i = 0; i < productOptions.length; i++) {
            productOptions[i].addEventListener('change', function(){
                if (this.querySelector('select') != null) {
                  this.querySelector('select').value = this.querySelector('input:checked').value;
                }
                if (this.querySelector('input:checked').classList.contains('echantillons')) {
                  document.querySelector('[data-subscription-activate]').style.display = 'none';
                  document.querySelector('.product__buy-options--subscription').style.display = 'none';
                  document.querySelector("#one-time").checked = true;
                } else {
                  if (document.querySelector('[data-subscription-activate]') != null) {
                    document.querySelector('[data-subscription-activate]').style.display = 'flex';
                  }
                  if (document.querySelector('.product__buy-options--subscription') != null) {
                    document.querySelector('.product__buy-options--subscription').style.display = 'block';
                  }
                }

        // $(selectors.optionSelector, $productSection).on('change', function(){
            // Taille and Type are not a strict matrix: the same weight is stored
            // under slightly different strings (2,5kg / 2.5 kg / 2.5  kg).
            var optionName = '';
            var changedSelect = this.querySelector('select');
            if (changedSelect) {
                optionName = changedSelect.getAttribute('data-variant-option-name') || '';
            }
            var isLooseOption = optionIsLoose(optionName, $productSection);
            var looseIndex = changedSelect ? changedSelect.getAttribute('data-option-index') : '';
            var looseValue = changedSelect ? changedSelect.value : '';

            $(selectors.plusButton, $productSection).removeClass('product__qty-btn-disabled');

            var options = [];
            $(selectors.optionSelector, $productSection).each(function(index){
                options[index] = $(this).val();
            });

            var $matched = findMatchingVariant($productSection, options);
            if ((!$matched || !$matched.length) && isLooseOption && looseValue) {
                $matched = findLooseVariant($productSection, looseIndex, looseValue, options);
            }

            if ($matched && $matched.length) {
                syncVariantOptionControls($productSection, $matched);
                $matched.prop('selected', true);
            }
            filterSelectElements($productSection);
            updateUnitPrices($productSection);
            updateQuantityPrices($productSection);
            updateButtonPrice($productSection);
            updateAddToCartVisibility($productSection);

            var selectedVariant = document.querySelector('[data-product-select]').value;
            $('[data-product-quantity]').text('1');
            updateQuantityPrices($productSection);
            updateButtonPrice($productSection);
            // var subscriptionLink = document.querySelector('.product-subscription-link').getAttribute('href').split('?')[0];
            // var subscriptionLinkParams = document.querySelector('.product-subscription-link').getAttribute('href').split('?')[1];
            // var urlParams = new URLSearchParams(subscriptionLinkParams);
            // console.log(subscriptionLink);
            // console.log("urlParams");
            // console.log(urlParams);
            // var subscriptionQuantity = urlParams.get('quantity');
            // var subscriptionType = urlParams.get('type');
            // var subscriptionCategorie = urlParams.get('categorie');
            // urlParams.set('type', subscriptionType);
            // urlParams.set('categorie', subscriptionCategorie);
            // urlParams.set('variant', selectedVariant);
            // urlParams.set('quantity', subscriptionQuantity);
            // var newSubscriptionLink = subscriptionLink + "?" + urlParams;
            // console.log(newSubscriptionLink);
            // document.querySelector('.product-subscription-link').setAttribute('href', newSubscriptionLink);

            // Cap qty / disable "+" for the new variant's limited_order, but never
            // surface the limit message on a mere variant switch (qty is reset to 1).
            hideQuantityLimitTooltip();
            syncQuantityLimitUi(false);
            if (document.querySelector('[data-product-select] [data-option-1="15 kg"]') != null && document.querySelector('[data-product-select] [data-option-1="15 kg"]') != undefined) {
              if (document.querySelector('[data-product-select] [data-option-1="15 kg"]').hasAttribute('disabled')) {
                document.querySelector('.product__option.first #Grande').setAttribute('disabled', 'disabled');
              }
            }

        });
      // })

    }
        // Add to cart
        $(selectors.addToCartSelector).click(async function(){
            // var isSubscription = $((selectors.subscriptionActiveSelector + '.' + selectors.optionActiveClass), $productSection).length;
            var addCart = {};
            var variant_id = null;
            var quantity = parseInt($(selectors.productQty, $productSection).html(), 10) || 1;
        
            
            variant_id = $(selectors.productSelect + ' option:selected', $productSection).attr(selectors.oneshotVariantAttribute);

            // Cap quantity so the cart total for this product does not exceed limited_order
            var maxAttr = $(selectors.plusButton, $productSection).attr(selectors.maximumAttribute);
            if (maxAttr) {
              try {
                var cartRes = await fetch('/cart.json');
                var cartData = await cartRes.json();
                var decision = resolveAllowedAddQuantity(variant_id, quantity, cartData.items || [], getSelectedVariantLimit());
                if (decision.blocked) {
                  showLimitedOrderTooltip($(this), decision.limit);
                  return;
                }
                quantity = decision.quantity;
              } catch (e) {}
            }

            CartJS.addItem(variant_id, quantity, addCart);

            setTimeout(() => {
              $('[data-product-quantity]').text('1');
              updateQuantityPrices($productSection);
            updateButtonPrice($productSection);
            }, 1000);

            var productList = 'accueil';
            if(window.location.href.indexOf('products') !== -1) productList = 'suggestion produit';
            else if(window.location.href.indexOf('collection') !== -1) productList = 'category';
            else productList = (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

            var addToCartType = 'Ajout au panier d\'un achat unique';
            var productType = 'Achat unique';
            // if(isSubscription){
            //    addToCartType = 'Ajout au panier d\'un abonnement';
            //    productType = 'Abonnement';
            // }

            var gtmProduct = {
                quantity : quantity,
                conditionnement : $(this).parents('[data-product-container]').find('[data-variant-option-name="Conditionnement"]').val(),
                taille : $(this).parents('[data-product-container]').find('[data-variant-option-name="Taille"]').val(),
                addToCartType : addToCartType,
                id : $(this).parents('[data-product-container]').attr('data-product-id'),
                name : $(this).parents('[data-product-container]').attr('data-product-name'),
                price : $(this).parents('[data-product-container]').attr('data-product-price'),
                type : $(this).parents('[data-product-container]').attr('data-product-type'),
                productType : productType,
                list:productList,
                espece:$(this).parents('[data-product-container]').attr('data-product-espece'),
                stock:$(this).parents('[data-product-container]').attr('data-product-stock'),
                discount:$(this).parents('[data-product-container]').attr('data-product-discount'),
            };
            if($(this).parents('[data-product-container]').attr('data-product-review')) gtmProduct.review = $(this).parents('[data-product-container]').attr('data-product-review');
            if($(this).parents('[data-product-container]').attr('data-product-note')) gtmProduct.note = $(this).parents('[data-product-container]').attr('data-product-note');

            // $(window).bind('triggerGtmAtc', function(){
            //     $(window).unbind('triggerGtmAtc');
            //     var params = {
            //         cartId : CartJS.cart.token,
            //         cartItem : CartJS.cart.item_count,
            //         cartTotal: CartJS.cart.total_price
            //     }
            //     console.log('Gtm product in bind ', gtmProduct);
            //     gtmAddToCart(params, [gtmProduct])
            // })

            // Trigger snowplow event (quantity, isSubscriptionProduct, subscription)

            addToCartSnowplow(quantity, false, false);

            klaviyoAddedToCart($(this).parents('[data-product-container]').attr('data-product-price'));

        });

        // ADD TO CART SNOWPLOW EVENT

        function addToCartSnowplow(quantity, isSubscriptionProduct, subscription) {

          let detail = {
            sku: document.querySelector('#pdp-selector').getAttribute('data-product-sku'),
            handle: document.querySelector('#pdp-selector').getAttribute('data-product-handle'),
            quantity: parseInt(quantity),
            subscription: isSubscriptionProduct,
            inventory_status: subscription ? 'subscription' : 'oneoff',
            creative: document.querySelector('#pdp-selector').getAttribute('data-ref')
          };
      
          let hb_event = new CustomEvent("hb_add_to_cart", { detail: detail });

          window.dispatchEvent(hb_event);
        }
        
        // Use the global updateOthersSubscriptions function if available, otherwise create local one
        function updateOthersSubscriptions(newFrequency) {
          // If global function exists, use it
          if (window.updateOthersSubscriptions && typeof window.updateOthersSubscriptions === 'function') {
            return window.updateOthersSubscriptions(newFrequency);
          }
          
          // Otherwise use local implementation
          return new Promise(async (resolve, reject) => {
            try {
              var _cart = await (await fetch(`/cart.json`)).json();
              var subscriptions = [];
        
              for (let i = 0; i < _cart.items.length; i++) {
                var element = _cart.items[i];
                if (element.properties && element.properties.hasOwnProperty('_shipping_interval_frequency')) {
                  subscriptions.push(
                    {
                      "subscription_index": i + 1,
                      "subscription_key": element.key,
                      "subscription_variant_id": element.variant_id,
                      "subscription_handle": element.handle,
                      "subscription_quantity": element.quantity
                    }
                  );
                }
              }
        
              for (let index = 0; index < subscriptions.length; index++) {
                var handle = subscriptions[index].subscription_handle;
                var product = await getProduct(handle);
        
                if (product && product.selling_plan_groups && product.selling_plan_groups[0] && product.selling_plan_groups[0].selling_plans) {
                  var sellingPlans = product.selling_plan_groups[0].selling_plans;
                  for (let j = 0; j < sellingPlans.length; j++) {
                    if (sellingPlans[j].name.indexOf('Livraison tous les ' + newFrequency + ' jours') > -1) {
                      var data = {
                        'properties': {
                          '_shipping_interval_frequency': newFrequency,
                          '_shipping_interval_unit_type': "Days"
                        },
                        'selling_plan': sellingPlans[j].id,
                        //'line': subscriptions[index].subscription_index,
                        'id': subscriptions[index].subscription_key,
                        'quantity': subscriptions[index].subscription_quantity
                      };
        
                      await changeItemById(data);
                    }
                  }
                }
              }
              resolve();
            } catch (error) {
              reject(error);
            }
          });
        }
        
        async function changeItem(data) {
          const result = await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              },
              body: JSON.stringify(data)
          });
        }
        
        function changeItemById(data) {
          return changeItem(data);
        }
        
        async function getProduct(handle) {
          return await fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
          }).then(response => {
            return response.json();
          }).catch((error) => {
            console.error('Error:', error);
          });
        }

        $(selectors.subscriptionActiveSelector).click(async function(){

          const selector = $(selectors.frequencySelector + '#frequence')[0];
          const variantId = $(selectors.productSelect).val();
          const quantity = $(selectors.productQty, $productSection).html();
          const selling_plan_id = $(selector).find('option:selected').attr('selling_plan_id');
          if (selector.value == 'label') {
            const $revampRoot = $('[data-pdp-revamp]');
            if ($revampRoot.length) {
              // Match collection quickview: highlight frequency select, no button tooltip
              const freqWrap = $revampRoot.find('.product-subscription-frequence, .frequency-selector').get(0);
              if (freqWrap) {
                freqWrap.classList.add('is-error');
                freqWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
              if (selector && typeof selector.focus === 'function') selector.focus();
            } else {
              $(selectors.subscriptionTooltiptext).removeAttr('hidden');
              setTimeout(() => {
                $(selectors.subscriptionTooltiptext).attr('hidden', '');
              }, 2000);
            }
          } else {
            var quantityToAdd = parseInt(quantity, 10) || 1;
            var maxAttr = $(selectors.plusButton, $productSection).attr(selectors.maximumAttribute);
            if (maxAttr) {
              try {
                var cartRes = await fetch('/cart.json');
                var cartData = await cartRes.json();
                var decision = resolveAllowedAddQuantity(variantId, quantityToAdd, cartData.items || [], getSelectedVariantLimit());
                if (decision.blocked) {
                  showLimitedOrderTooltip($(this), decision.limit);
                  return;
                }
                quantityToAdd = decision.quantity;
              } catch (e) {}
            }
            const items = [
              { 
                id: variantId,
                quantity: quantityToAdd,
                selling_plan: selling_plan_id,
                properties: {
                  "_shipping_interval_frequency": selector.value,
                  "_shipping_interval_unit_type": "Days",
                }
              }
            ];
            await updateOthersSubscriptions(selector.value);

            // Trigger snowplow event (quantity, isSubscriptionProduct, subscription)

            addToCartSnowplow(quantityToAdd, true, true);
    
            CartJS.addItems(items, {
              success: async () => {},
              error: (jqXHR, textStatus, errorThrown) => {
                // Handle error
              }
            });
          }
        })

        // Add to cart dual
        $(selectors.addToCartDualSelector).click(function(){
            var isSubscription = $((selectors.subscriptionActiveSelector + '.' + selectors.optionActiveClass), $productSection).length;
            var addCart = {};
            var addCart_2 = {};
            var variant_id = null;
            var variant_id_2 = null;
            var quantity = $(selectors.productQty, $productSection).html();
            if(isSubscription) {
                variant_id = $(selectors.productSelect + ' option:selected', $productSection).attr(selectors.oneshotVariantAttribute);
                variant_id_2 = $(selectors.productSelect2 + ' option:selected', $productSection).attr(selectors.oneshotVariantAttribute);
				addCart["_shipping_interval_frequency"] = $(selectors.frequencySelector, $productSection).val();
                addCart["selling_plan"] = $('[data-frequency-selector] option:selected').attr('selling_plan_id');
			    addCart["_shipping_interval_unit_type"] = $(selectors.intervalUnitTypeSelector, $productSection).attr(selectors.intervalUnitTypeAttribute);
				addCart_2["_shipping_interval_frequency"] = $(selectors.frequencySelector, $productSection).val();
                addCart_2["selling_plan"] = $('[data-frequency-selector] option:selected').attr('selling_plan_id');
				addCart_2["_shipping_interval_unit_type"] = $(selectors.intervalUnitTypeSelector, $productSection).attr(selectors.intervalUnitTypeAttribute);
            } else{
                variant_id = $(selectors.productSelect + ' option:selected', $productSection).attr(selectors.oneshotVariantAttribute);
                variant_id_2 = $(selectors.productSelect2 + ' option:selected', $productSection).attr(selectors.oneshotVariantAttribute);
            }

            var items = [
              {
                id: variant_id,
                quantity: quantity,
                properties: addCart
              },
              {
                id: variant_id_2,
                quantity: quantity,
                properties: addCart_2
              }
            ];

            CartJS.addItems(items);

            var productList = 'accueil';
            if(window.location.href.indexOf('products') !== -1) productList = 'suggestion produit';
            else if(window.location.href.indexOf('collection') !== -1) productList = 'category';
            else productList = (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

            var addToCartType = 'Ajout au panier d\'un achat unique';
            var productType = 'Achat unique';
            if(isSubscription){
                addToCartType = 'Ajout au panier d\'un abonnement';
                productType = 'Abonnement';
            }

            var gtmProduct = {
                quantity : quantity,
                conditionnement : $(this).parents('[data-product-container]').find('[data-variant-option-name="Conditionnement"]').val(),
                taille : $(this).parents('[data-product-container]').find('[data-variant-option-name="Taille"]').val(),
                addToCartType : addToCartType,
                id : $(this).parents('[data-product-container]').attr('data-product-id'),
                name : $(this).parents('[data-product-container]').attr('data-product-name'),
                price : $(this).parents('[data-product-container]').attr('data-product-price'),
                type : $(this).parents('[data-product-container]').attr('data-product-type'),
                productType : productType,
                list:productList,
                espece:$(this).parents('[data-product-container]').attr('data-product-espece'),
                stock:$(this).parents('[data-product-container]').attr('data-product-stock'),
                discount:$(this).parents('[data-product-container]').attr('data-product-discount'),
            };
            if($(this).parents('[data-product-container]').attr('data-product-review')) gtmProduct.review = $(this).parents('[data-product-container]').attr('data-product-review');
            if($(this).parents('[data-product-container]').attr('data-product-note')) gtmProduct.note = $(this).parents('[data-product-container]').attr('data-product-note');

            $(window).bind('triggerGtmAtc', function(){
                $(window).unbind('triggerGtmAtc');
                var params = {
                    cartId : CartJS.cart.token,
                    cartItem : CartJS.cart.item_count,
                    cartTotal: CartJS.cart.total_price
                }
                gtmAddToCart(params, [gtmProduct])
            })

            klaviyoAddedToCart($(this).parents('[data-product-container]').attr('data-product-price'))

        });


    // Teester
    window.onTeesterReady = (window.onTeesterReady || []);
    window.onTeesterReady.push((SDK) => {

        var TEESTER_PLAYER_KEY = "121ab140-15e8-4a6d-9430-0214e69c1838";
        var TEESTER_TRACKING_KEY = "1a800fa1-58a1-4f6a-a729-8048bbedc34d";
        var PRODUCT_REFERENCE = $(selectors.productTeester).attr(selectors.productTeesterData);

        SDK.customIntegration();

        SDK.checkVideoAvailability(TEESTER_PLAYER_KEY, PRODUCT_REFERENCE, (value) => {
            // Si pas de vidéo on supprime la div et la thumbnail
            if (!value) {
                $('.product__thumbnail-teester-container').remove();
                $('.product__slide-teester').remove();
                $(selectors.productTeesterPlayerReviews).remove();
                $('.product__anchor-teester').remove();
                $('#teester-reviews').removeClass('reviews-product__teester-container');
                $(selectors.sliderSelector, $productSection).flickity(flickitySettings);
            } else {

                const player = SDK.init({
                    type: 'player',
                    args: {
                       key: TEESTER_PLAYER_KEY,
                       product: PRODUCT_REFERENCE
                    }
                }, document.querySelector(selectors.productTeesterPlayerReviews));

                //Sur desktop on supprime la slide
                if($(window).width() > 800) {
                    $('.product__slide-teester').remove();
                }

                const trackProduct = SDK.init({
                    type: 'tracking',
                    args: {
                        key: TEESTER_TRACKING_KEY,
                        product: PRODUCT_REFERENCE,
                        event: 'PRODUCT_PAGE_VIEW'
                    }
                });

                function iOSversion() {
                    if (/iP(hone|od|ad)/.test(navigator.platform)) {
                        // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
                        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
                    }
                }

                ver = iOSversion();

                if (ver[0] < 15) {
                    $('.product__slide-teester-player').css('paddingBottom', '56.25%');
                }

            }
        });
    });

    };
    function updateSliderImage($productSection){
        var $selectedElt = $((selectors.productSelect + ' option:selected'), $productSection);
        var featured_image_id = $selectedElt.attr(selectors.featuredImageAttribute);
        if(featured_image_id){
            var $carousel = $(selectors.sliderSelector, $productSection).flickity();
            $carousel.flickity('selectCell', '[data-image-id="' + featured_image_id + '"]');
        }
    }
    function normalizeVariantOptionValue(value) {
        return String(value == null ? '' : value)
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase()
            .replace(/,/g, '.')
            .replace(/(\d+(?:\.\d+)?)\s*kg\b/g, '$1 kg');
    }

    function variantOptionSelectionMatches($variant, options, normalize) {
        for (var i = 0; i < options.length; i++) {
            var selected = options[i];
            if (selected == null || selected === '') continue;
            var variantValue = $variant.attr('data-option-' + (i + 1));
            if (variantValue == null) return false;
            if (normalize) {
                if (normalizeVariantOptionValue(variantValue) !== normalizeVariantOptionValue(selected)) return false;
            } else if (variantValue !== selected) {
                return false;
            }
        }
        return true;
    }

    function findMatchingVariant($productSection, options) {
        var $variants = $(selectors.productSelect + ' option', $productSection);
        var exact = null;
        var normalized = null;
        $variants.each(function() {
            var $variant = $(this);
            if (!exact && variantOptionSelectionMatches($variant, options, false)) {
                exact = $variant;
            }
            if (!normalized && $variant.attr('data-variant-available') !== 'false' && variantOptionSelectionMatches($variant, options, true)) {
                normalized = $variant;
            }
        });
        return exact || normalized;
    }

    function optionNameIsFormat(name) {
        return name.indexOf('Format') !== -1 || name.indexOf('Conditionnement') !== -1;
    }

    function sectionHasFormatOption($section) {
        var found = false;
        $section.find('[data-variant-option-name]').each(function() {
            var name = $(this).attr('data-variant-option-name') || '';
            if (optionNameIsFormat(name)) found = true;
        });
        return found;
    }

    function optionIsLoose(name, $section) {
        if (!name || optionNameIsFormat(name)) return false;
        if (name.indexOf('Taille') !== -1 || name.indexOf('Type') !== -1) return true;
        return sectionHasFormatOption($section);
    }

    function findVariantByOptionIndex($productSection, optionIndex, optionValue) {
        var match = null;
        $(selectors.productSelect + ' option', $productSection).each(function() {
            var $variant = $(this);
            if ($variant.attr('data-variant-available') === 'false') return;
            if ($variant.attr('data-option-' + optionIndex) === optionValue) {
                match = $variant;
                return false;
            }
        });
        return match;
    }

    function findLooseVariant($productSection, optionIndex, optionValue, options) {
        var match = null;
        $(selectors.productSelect + ' option', $productSection).each(function() {
            var $variant = $(this);
            if ($variant.attr('data-variant-available') === 'false') return;
            if ($variant.attr('data-option-' + optionIndex) !== optionValue) return;
            var othersMatch = true;
            for (var i = 0; i < options.length; i++) {
                if (String(i + 1) === String(optionIndex)) continue;
                var selected = options[i];
                if (selected == null || selected === '') continue;
                var variantValue = $variant.attr('data-option-' + (i + 1));
                if (normalizeVariantOptionValue(variantValue) !== normalizeVariantOptionValue(selected)) {
                    othersMatch = false;
                    break;
                }
            }
            if (othersMatch) {
                match = $variant;
                return false;
            }
        });
        return match || findVariantByOptionIndex($productSection, optionIndex, optionValue);
    }

    function syncVariantOptionControls($productSection, $variant) {
        $(selectors.optionSelector, $productSection).each(function() {
            var index = $(this).attr('data-option-index');
            var variantValue = $variant.attr('data-option-' + index);
            if (variantValue == null || variantValue === '') return;
            this.value = variantValue;
            var group = this.closest('.product__option-radio-buttons');
            if (!group) return;
            group.querySelectorAll('input[type="radio"]').forEach(function(input) {
                input.checked = input.value === variantValue;
            });
        });
    }

    // Hide nonexistent select variants
    function filterSelectElements($productSection) {
        var $selectedElt = $((selectors.productSelect + ' option:selected'), $productSection);

        $('[data-variant-option]', $productSection).each(function(){

            var optionValue = $(this).attr('value');
            $('[data-variant-option][value="' + optionValue + '"]').each(function(){
                $(this).removeAttr('disabled');
                $(this).removeAttr('hidden');

                $('.product__option-radio-buttons:not(.has-poids) input[value="'+ optionValue +'"]').removeAttr('disabled');
                $('.product__option-radio-buttons:not(.has-poids) input[value="'+ optionValue +'"] + label').removeAttr('hidden');
            })
            $(this).show();
        });

        $('[data-variant-option]', $productSection).each(function(){
            var optionIndex = $(this).parents('[data-option-selector]').attr('data-option-index');
            var value = $(this).val();
            var exist = false;
            var available = true;
            var firstQuery = '[data-option-' + optionIndex + '="' + value + '"]';
            var baseQueryElt = '';
            var queryElt = '';

            for(var i = 1; i < 4; i++) {
                if(i == optionIndex) continue;
                var selectedValue = $selectedElt.attr('data-option-' + i);
                if(!selectedValue) continue;
                baseQueryElt = firstQuery + '[data-option-' + i + '="' + selectedValue + '"] ';
                for(var y = 1; y < 4; y++){
                    if(y == i) continue;
                    var selectedValue = $selectedElt.attr('data-option-' + y);
                    if(!selectedValue) continue;
                    queryElt = baseQueryElt;
                    if(y != optionIndex) queryElt += baseQueryElt + '[data-option-' + y + '="' + selectedValue + '"]';
                    if($(queryElt, $productSection).length > 0){
                        exist = true;
                        // if($(queryElt).attr('data-variant-available') == 'false') available = false;
                    }
                }
            }
            // Cas où 1 seule option
            if($('[data-option-2]', $productSection).length == 0){
                if($('[data-option-1="' + value + '"]', $productSection).length){
                    exist = true;
                    // if($('[data-option-1="' + value + '"]').attr('data-variant-available') == 'false'){
                    //     available = false;
                    // }
                }
            }

            // Cas où plusieur options mais un non disponible
            if($('[data-option-2]', $productSection).length != 0){
                var nonAvailableOption = $('[data-variant-available="false"]');
                if(nonAvailableOption.length == 1 || nonAvailableOption.length == 2) {
                    $('[data-variant-available="false"]').each(function(){
                        var variantFalse = $(this).attr('data-option-2');
                        // $('[data-variant-option][value='+variantFalse+']').attr('disabled', true);
                        // $('[data-variant-option][value='+variantFalse+']').attr('hidden', true);
                    });
                }
            }


            var variantOptionName = $(this).parents('[data-variant-option-name]').attr('data-variant-option-name') || '';
            if(optionIsLoose(variantOptionName, $productSection)){
                var isTailleAvailable = true;
                var tailleValue = $(this).val();
                $('[data-option-1="' + tailleValue + '"]').each(function(){
                    if($(this).attr('data-variant-available') == 'false'){
                        isTailleAvailable = false;
                    }
                });
                //console.log(tailleValue);
                if(!isTailleAvailable){
                    var optionValue = $(this).attr('value');
                    //console.log('Option value ', optionValue);
                    if (tailleValue == "Grande") {
                      document.querySelector('.product__option-radio-buttons:not(.has-poids) input#Grande').setAttribute('disabled', "disabled")
                    }
                    $('[data-variant-option][value="' + optionValue + '"]').each(function(){
                        $(this).attr('disabled', true);
                        $(this).attr('hidden', true);

                        $('.product__option-radio-buttons:not(.has-poids) input[value="'+ optionValue +'"]').attr('disabled', true);
                        $('.product__option-radio-buttons:not(.has-poids) input[value="'+ optionValue +'"] + label').attr('hidden', true);
                    })
                }
            }else{
                if(!exist){
                    var optionValue = $(this).attr('value');
                    $('[data-variant-option][value="' + optionValue + '"]').each(function(){
                        $(this).attr('disabled', true);
                        $(this).attr('hidden', true);

                        $('.product__option-radio-buttons:not(.has-poids) input[value="'+ optionValue +'"]').attr('disabled', true);
                        $('.product__option-radio-buttons:not(.has-poids) input[value="'+ optionValue +'"] + label').attr('hidden', true);
                    })
                }
                if(!available){
                    var optionValue = $(this).attr('value');
                    $('[data-variant-option][value="' + optionValue + '"]').each(function(){
                        $(this).attr('disabled', true);

                        $('.product__option-radio-buttons:not(.has-poids) input[value="'+ optionValue +'"]').attr('disabled', true);
                    })
                }
            }
        });
    };

	

    function updateUnitPrices($productSection){
        var $selectedElt = $((selectors.productSelect + ' option:selected'), $productSection);
        var subscription_price = parseFloat($selectedElt.attr(selectors.variantSubscriptionPriceAttribute)) / 100;
        var oneshot_price = parseFloat($selectedElt.attr(selectors.variantOneshotPriceAttribute)) / 100;
        var oneshot_price_rrp = parseFloat($selectedElt.attr(selectors.variantOneshotPriceRrpAttribute)) / 100;
        if(!subscription_price || subscription_price == 'NaN'){
            $(selectors.oneshotActiveSelector, $productSection).click();
            $(selectors.subscriptionActiveSelector, $productSection).addClass(selectors.optionDisableClass);
        }else{
            $(selectors.subscriptionActiveSelector, $productSection).removeClass(selectors.optionDisableClass);
            $(selectors.subscriptionUnitPrice, $productSection).html(subscription_price.toFixed(2).replace('.', ','));
        }
        $(selectors.oneshotUnitPrice, $productSection).html(oneshot_price.toFixed(2).replace('.', ','));

        if ($(selectors.oneshotUnitPriceRrp, $productSection).length) {
          if (parseFloat($selectedElt.attr(selectors.variantOneshotPriceRrpAttribute))) {
            $(selectors.oneshotUnitPriceRrp, $productSection).html(oneshot_price_rrp.toFixed(2).replace('.', ','));
          }
          else {
            $(selectors.oneshotUnitPriceRrp, $productSection).html('');
          }
        }

        // console.log('Selected elt ', $selectedElt);
        if($selectedElt.attr('data-option-1') && $selectedElt.attr('data-option-1').indexOf('kg') !== -1){
            var weight = parseFloat($selectedElt.attr('data-option-1').replace(' kg', '').replace('kg', ''));
            // console.log('Weight', weight);
            var weightSubscription = ($selectedElt.attr('data-subscription-price') / weight / 100 ).toFixed(2);
            var weightOneshot = ($selectedElt.attr('data-oneshot-price') / weight / 100).toFixed(2);
            // console.log('weightSubscription ', weightSubscription);
            // console.log('weightOneshot ', weightOneshot);
            $(selectors.subscriptionWeightPrice).html(weightSubscription.replace('.',','))
            $(selectors.oneshotWeightPrice).html(weightOneshot.replace('.',','))
        }
        // TODO
    };

    function updateQuantityPrices($productSection){
        var quantity = $(selectors.productQty, $productSection).html();
        var totalOneshot = quantity * parseFloat($(selectors.oneshotUnitPrice, $productSection).html().replace(/,/, '.'));
        $(selectors.oneshotQtyPrice, $productSection).html(totalOneshot.toFixed(2).replace('.', ','));
        $('[data-calculateur-price-one-shot]').html(totalOneshot.toFixed(2).replace('.', ','));

        if ($(selectors.oneshotUnitPriceRrp, $productSection).length) {
          if ($(selectors.oneshotUnitPriceRrp, $productSection).html()) {
            var totalOneshotRrp = quantity * parseFloat($(selectors.oneshotUnitPriceRrp, $productSection).html().replace(/,/, '.'));
            $(selectors.oneshotQtyPriceRrp, $productSection).html(totalOneshotRrp.toFixed(2).replace('.', ','));
          }
          else{
            $(selectors.oneshotQtyPriceRrp, $productSection).html('');
          }
        }

        if($(selectors.subscriptionActiveSelector, $productSection).length){
            // console.log(parseFloat($(selectors.oneshotQtyPrice, $productSection).html()) - parseFloat($(selectors.subscriptionUnitPrice, $productSection).html()))
            // console.log(parseFloat($(selectors.oneshotQtyPrice, $productSection).html()), ' , ', parseFloat($(selectors.subscriptionUnitPrice, $productSection).html()))
            var totalSubscription = quantity * parseFloat($(selectors.subscriptionUnitPrice, $productSection).html().replace(/,/, '.'));
            var discountSubscription = totalOneshot.toFixed(2) - totalSubscription.toFixed(2);
            $(selectors.subscriptionQtyPrice, $productSection).html(discountSubscription.toFixed(2).toString().replace('.', ','));
            $('[data-calculateur-price-subscribe]').html(totalSubscription.toFixed(2).replace('.', ','));
        }

    }
    function updateButtonPrice($productSection){
        var isSubscription = $((selectors.subscriptionActiveSelector + '.' + selectors.optionActiveClass), $productSection).length;
        var total = 0;
        var quantity = $(selectors.productQty, $productSection).html();
        if(isSubscription) total = quantity * parseFloat($(selectors.subscriptionUnitPrice, $productSection).html().replace(/,/, '.'));
        else total =  quantity * parseFloat($(selectors.oneshotUnitPrice, $productSection).html().replace(/,/, '.'));
        // console.log('Total product page', total);
        $(selectors.orderPrice, $productSection).html(total.toFixed(2).replace('.', ','));
        $('[data-product-footer] ' + selectors.orderPrice).html(total.toFixed(2).replace('.', ','));
    };

    function updateAddToCartVisibility($productSection) {
        var $selectedOption = $(selectors.productSelect + ' option:selected', $productSection);
        var available = $selectedOption.attr('data-variant-available') === 'true';
        var $addToCartBtn = $(selectors.addToCartSelector, $productSection);
        if (available) {
            $addToCartBtn.removeClass('hide');
        } else {
            $addToCartBtn.addClass('hide');
        }
    }

    function initCardsHandlers(){
        var quickviewIsOpen;
        $(function(){
            $(selectors.openQuickview).click(function(){
                var product_handle = $(this).attr(selectors.quickviewHandleAttribute);
                var subsciptionAttribute = $(this).is(selectors.quickviewSubsciptionAttribute);
                if (subsciptionAttribute) {
                  openQuickview(product_handle, true);
                } else {
                  openQuickview(product_handle, false);
                }
                // console.log('Open quickview ', product_handle);
                clearQuickviews();
            });
            $(window).on('initQuickviewHandle', function(){
              setTimeout(function(){
                if (window.matchMedia("(min-width: 500px)").matches) {
                  $(selectors.openQuickview).click(function(){
                      var product_handle = $(this).attr(selectors.quickviewHandleAttribute);
                      clearQuickviews();
                      openQuickview(product_handle, false);
                  });
                }
              }, 1500);
            });
            $(window).on('clearQuickviews', function(){
                clearQuickviews();
            });
        });
    };
    function initQuickviewHandlers(){
        $(selectors.quickviewSelector).click(function(event) {
            if ($(event.target).closest(selectors.productQuickviewSelector).get(0) == null ) {
                clearQuickviews();
            }
        });
        $(selectors.closeQuickview).click(function(){
            clearQuickviews();
        });
        $('[data-product-thumbnails]').removeClass('hide');
    }
    function clearQuickviews(){
        $(selectors.quickviewContainerSelector).each(function(){
            $(this).empty();
        });
        $('body').removeClass(selectors.nonScrollClass);
    };
    function openQuickview(product_handle, hasSubsciptionAttribute) {
        $(window).trigger('closeSearch');
        $.get('/products/' + product_handle + '?view=quickview', function( data ) {
            $('body').addClass(selectors.nonScrollClass);
            $(selectors.quickviewContainerSelector).html(data.split('getter-start')[1].split('getter-stop')[0]);
            var $quickviewSection = $(selectors.productQuickviewSelector);
            initProductHandlers($quickviewSection);
            filterSelectElements($quickviewSection);
            updateUnitPrices($quickviewSection);
            initQuickviewHandlers();
            if (hasSubsciptionAttribute) {
              $(selectors.quickviewSelector).addClass('quickview-only-subscription');
              $(selectors.subscriptionActiveSelector).click();
              $(selectors.addToCartSelector).html();
            }
        });
    };
    $(window).on('openPopupCalculateur', function(){
      var $calculateurSection = $('[data-calculateur-container]');
      filterSelectElements($calculateurSection);

    });
    $(window).on('changeVariantCalculateur', function(){
      var $calculateurSection = $('[data-calculateur-container]');
      filterSelectElements($calculateurSection);
    });

    let arrowWidth = 40;

    $.fn.resizeselect = function(settings) {
      return this.each(function() {

        $(this).change(function(){
          let $this = $(this);

          // get font-weight, font-size, and font-family
          let style = window.getComputedStyle(this)
          let { fontWeight, fontSize, fontFamily } = style

          // create test element
          let text = $this.find("option:selected").text();
          let $test = $("<span>").html(text).css({
            "font-size": fontSize,
            "font-weight": fontWeight,
            "font-family": fontFamily,
            "visibility": "hidden", // prevents FOUC
            "display": "block",
            "width": "fit-content"
          });

          // add to body, get width, and get out
          $test.appendTo($this.parent());
          let width = $test.width();
          $test.remove();

          // set select width
          $this.width(width + arrowWidth);

          // run on start
        }).change();

      });
    };
    // run by default
    $("select[data-variant-option-name='Conditionnement']").resizeselect();


    return Product;
};
var Product = new theme.Product();

/** header **/

theme.header = new function() {
	var settings = {};

	function header(headerSettings) {

		// init default settings
		var defaultSettings = {
			bodySelector : "body",
			doubleClick:'[data-double-link]',
			nonScrollClass : "non-scroll",
			headerId : "shopify-section-header",
			headerSelector : '.header',
			headerTransparent : 'header--transparent',
			toggleSideNav : '[data-header-toggle]',
			openSideNavSelector : '[data-header-open]',
			closeSideNavSelector : '[data-header-close]',
			toggleSideSearch : '[data-search-toggle]',
			closeSideSearchSelector : '[data-search-close]',
			sideNavSelector : '[data-header-side-nav]',
			sideSearchSelector : '[data-header-side-search]',
			openSideNavClass : 'active',
			openSideSearchClass : 'active--search',
			lightClass : 'light',
			headerNotLight : 'not-light',
			headerNotLightSearch : 'not-light--search',
			anchorContainer : '[data-anchor-container]',
			anchorLink : '[data-anchor-link]',
			anchorSlideTo : '[data-anchor-slideto]',
			anchorHeaderContainer : '[data-anchor-header]'
		};

		// merge settings
		settings = $.extend({}, defaultSettings, headerSettings);
		if ($(defaultSettings.bodySelector).attr('id') != 'mon-compte-abonne' && $(defaultSettings.bodySelector).attr('id') != 'trouvez-la-recette-ideale-pour-votre-animal') {
			//if ($(settings.headerSelector).hasClass('header--transparent')) {
			checkHeaderStatus();
			var lastScrollTop = 0;
      var root = document.documentElement;
      // if (document.location.href.includes('/blogs/') || !document.location.href.includes('-guide')){ 
        $(window).scroll(function() {

          var scrollTop = $(this).scrollTop();
          
          if (scrollTop < lastScrollTop) {
            // Scrolling up
            if (!/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) && !document.querySelector('.article_link_back')) {
                if ($('#shopify-section-header').length > 0) {
                    $('#' + settings.headerId).addClass('sticky-header');
                    root.style.setProperty('--header-height', $('#shopify-section-header')[0].offsetHeight + 'px');
                }
            } else if (/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) && document.querySelector('.article_link_back')) {
                // Mobile-specific logic (if any)
            } else {
                if ($('#shopify-section-header').length > 0) {
                    $('#' + settings.headerId).addClass('sticky-header');
                    root.style.setProperty('--header-height', $('#shopify-section-header')[0].offsetHeight + 'px');
                }
            }
          } else {
              // Scrolling down
              $('#' + settings.headerId).removeClass('sticky-header');
              root.style.setProperty('--header-height', 0 + 'px');
          }
          
          lastScrollTop = scrollTop;
        });
			//}
		}

    var isMobile = false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
        isMobile = true;
    }

    if (isMobile) {
      if ($(defaultSettings.bodySelector).attr('id') == 'trouvez-la-recette-ideale-pour-votre-animal') {
        //if ($(settings.headerSelector).hasClass('header--transparent')) {
        checkHeaderStatus();
        var lastScrollTop = 0;
        let root = document.documentElement;

        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
            
            if (scrollTop < lastScrollTop) {
                // Scrolling up
                if (!/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) && !document.querySelector('.article_link_back')) {
                  $('#' + settings.headerId).addClass('sticky-header');
                  root.style.setProperty('--header-height', $('#shopify-section-header')[0].offsetHeight + 'px');
                } else if (/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) && document.querySelector('.article_link_back')) {
                } else {
                  $('#' + settings.headerId).addClass('sticky-header');
                  root.style.setProperty('--header-height', $('#shopify-section-header')[0].offsetHeight + 'px');
                }
            } else {
                // Scrolling down
                $('#' + settings.headerId).removeClass('sticky-header');
                root.style.setProperty('--header-height', 0 + "px");
            }
            
            lastScrollTop = scrollTop;
        });
        //}
      }
    }

		$(settings.doubleClick).dblclick(function(){
			var url = $(this).attr('data-double-link');
			if(url) window.location.href = url;
		});

		$('[data-menu-double]').click(function(e){
			var $self = $(this)
			e.preventDefault();
			if($(this).parent().hasClass('header__menu-item--clicked')){
				if (!$(this).hasClass('unset-link')) {
					var url = $(this).attr('href');
					if(url) window.location.href = url;
					return;
				}
			}
			$('[data-menu-double]').each(function(){
				$(settings.doubleClick).dblclick(function(){
					var url = $(this).attr('data-double-link');
					if(url) window.location.href = url;
				});
				$(this).parent().removeClass('header__menu-item--clicked')
			});
			$(this).parent().addClass('header__menu-item--clicked');
			$(document).click(function(event) {
			  $target = $(event.target);
			  if(!$target.closest('[data-menu-double]').length){
					$('[data-menu-double]').each(function(){
						$(this).parent().removeClass('header__menu-item--clicked')
					});
			  }

			});
		});
		$('[data-menu-double]:not(.unset-link)').dblclick(function(e){
			var url = $(this).attr('href');
			if(url) window.location.href = url;
		});

		// $(window).on('load resize orientationchange', function() {

		// 	$('.promotion-code-bar').each(function(){
		// 	var $carousel = $(this);
		// 	/* Initializes a slick carousel only on mobile screens */
		// 	// slick on mobile
		// 	if ($(window).width() > 1024) {
		// 		if ($carousel.hasClass('slick-initialized')) {
		// 		$carousel.slick('unslick');
		// 		}
		// 	}
		// 	else{
		// 		if (!$carousel.hasClass('slick-initialized')) {
		// 		$carousel.slick({
		// 			vertical: true,
		// 			verticalSwiping: true,
		// 			autoplay: true,
		// 			autoplaySpeed: 2000,
		// 			arrows: false
		// 		});
		// 		}
		// 	}
		// 	});

		// });

		$('.promotion-code-bar').slick({
			vertical: true,
			verticalSwiping: true,
			autoplay: true,
			autoplaySpeed: 2000,
			arrows: false
		});
		$('.promotion-code-bar').removeClass('slides-opacity');

		$(window).on("scroll", function() {
			if($(window).scrollTop() > 50) {
				$(".header").addClass("active");
			} else {
				$(".header").removeClass("active");
			}
		});


		$(settings.toggleSideNav).on('click', function() {
			toggleSideNav();
		});
		$(settings.toggleSideSearch).on('click', function() {
			toggleSideSearch();
		});
		$(settings.closeSideNavSelector).on('click', function(){
			closeSideNav();
		})
		$(document).ready(function(){
			resizeWindow();
      createUnderline();
		})
		// createUnderline();
		// $(function(){createUnderline();})
		// setTimeout(function(){
		// 	createUnderline();
		// }, 3000);
		$(window).on('resize', function(){
			resizeWindow();
			createUnderline();
		});
		initAnchors();
	}

	function openSideNav() {
		closeSideSearch();
		$(window).trigger('resize');
		if($(settings.headerSelector).hasClass(settings.lightClass)){
			//$('html, body').animate({scrollTop: 0}, 200);
		}
		$(settings.sideNavSelector).addClass(settings.openSideNavClass);
		$(settings.headerSelector).addClass(settings.headerNotLight);
		$(settings.bodySelector).addClass(settings.nonScrollClass);

    if (document.querySelectorAll('.flip-card:first-child .flip-card-inner').length > 0) {
      document.querySelector('.flip-card:first-child .flip-card-inner').classList.add('flipcart-unset');
    }
	}
	function openSideSearch() {
		// if(ga) ga('send', 'event', 'Search', 'open', 'mobile');
		closeSideNav();
		if($(settings.headerSelector).hasClass(settings.lightClass)){
			//$('html, body').animate({scrollTop: 0}, 200);
		}
		$(window).trigger('resize');
		$(settings.sideSearchSelector).addClass(settings.openSideSearchClass);
		$(settings.headerSelector).addClass(settings.headerNotLight);
		$(settings.headerSelector).addClass(settings.headerNotLightSearch);
		$(settings.bodySelector).addClass(settings.nonScrollClass);
	}
	function createUnderline() {
		var styleElt = '<style data-underline-style>';
		$('.header__menu-item').each(function(i) {
			var width = $(this).width();
			$(this).attr('id', 'header__menu-item-' + i);
			styleElt += '#header__menu-item-' + i + ':after{width: ' + width + 'px;left:'+ $(this).offset().left +'px; opacity: 1;}';
		})
		setInterval(function(){
			$('.header__menu-item').each(function(i) {
				var width = $(this).width();
				$(this).attr('id', 'header__menu-item-' + i);
				styleElt += '#header__menu-item-' + i + ':after{width: ' + width + 'px;left:'+ $(this).offset().left +'px; opacity: 1;}';
			})
		}, 1000);

		styleElt += '</style>';
		$('[data-underline-style]').remove();
		$('body').append(styleElt)
	}
	function closeSideNav() {
		$(settings.sideNavSelector).removeClass(settings.openSideNavClass);
		$(settings.headerSelector).removeClass(settings.headerNotLight);
		$(settings.bodySelector).removeClass(settings.nonScrollClass);
    if (document.querySelectorAll('.flip-card:first-child .flip-card-inner').length > 0) {
      document.querySelector('.flip-card:first-child .flip-card-inner').classList.remove('flipcart-unset');
    }
	}
	function closeSideSearch() {
		$(settings.sideSearchSelector).removeClass(settings.openSideSearchClass);
		$(settings.headerSelector).removeClass(settings.headerNotLight);
		$(settings.headerSelector).removeClass(settings.headerNotLightSearch);
		$(settings.bodySelector).removeClass(settings.nonScrollClass);
	}

	function toggleSideNav() {
		if ($(settings.sideNavSelector).hasClass(settings.openSideNavClass)) {
			closeSideNav();
			$( ".header" ).removeClass('active');
			$( ".announcement-bar, .promotion-code-bar" ).removeClass('hide');
			$('.promotion-code-bar').slick({
				vertical: true,
				verticalSwiping: true,
				autoplay: true,
				autoplaySpeed: 2000,
				arrows: false
			});
			$('.promotion-code-bar').removeClass('slides-opacity');
		}	else {
			openSideNav();
			$( ".header" ).addClass('active');
      $("#shopify-section-header").addClass('sticky-header');
			$( ".announcement-bar, .promotion-code-bar" ).addClass('hide');
			$('.promotion-code-bar').slick("unslick");
			$('.promotion-code-bar').addClass('slides-opacity');
		}

	}
	function toggleSideSearch() {
		if ($(settings.sideSearchSelector).hasClass(settings.openSideSearchClass)) {
			closeSideSearch();
			$( ".header" ).removeClass('active');
			$( ".announcement-bar, .promotion-code-bar" ).removeClass('hide');
			$('.promotion-code-bar').slick({
				vertical: true,
				verticalSwiping: true,
				autoplay: true,
				autoplaySpeed: 2000,
				arrows: false
			});
			$('.promotion-code-bar').removeClass('slides-opacity');
		} else {
			openSideSearch();
			$( ".header" ).addClass('active');
			$( ".announcement-bar, .promotion-code-bar" ).addClass('hide');
			$('.promotion-code-bar').slick("unslick");
			$('.promotion-code-bar').addClass('slides-opacity');
      let detail = {
        type: 'header_click',
        click_text: 'click_search_header_bar',
        click_link: '/search'
      };
      clickevent = new CustomEvent("hb_navigation_click", { detail: detail });
      window.dispatchEvent(clickevent);
		}
	}

	function checkHeaderStatus() {
		var transparencyHeight = $(window).height() - $('.header').height();
		if($('[data-transparency-height]').length) transparencyHeight = $('[data-transparency-height]').height() + $('.header').height();

		// POUR REMETTRE LE HEADER, COMMENTER LA LIGNE SUIVANTE ET DECOMMENTER LES SUIVANTES ET REMETTRE FIXED  DANS .sticky-header
		// $('#' + settings.headerId).addClass('sticky-header');

		// REMI Tu mets tes 2 conditions et tu return

		//
		// if($(window).scrollTop() > transparencyHeight) {
		// 	if($(settings.headerSelector).hasClass('light')){
		// 		$(settings.headerSelector).removeClass("light");
		// 		$(settings.headerSelector).addClass("little");
		// 		$('#' + settings.headerId).addClass('sticky-header');
		// 		if($(settings.headerSelector).hasClass('header--transparent')){
		// 			$('#' + settings.headerId).removeClass('absolute-header');
		// 		}else{
		// 			var marginTop = $('.header-container').outerHeight() + $('.announcement-bar').outerHeight();
		// 			$('body').css('margin-top', marginTop + 'px');
		// 		}
		// 		$(settings.headerSelector).trigger('headerChange');
		// 	}
		// } else {
		// 	if($(settings.headerSelector).hasClass('little')){
		// 		$(settings.headerSelector).addClass("light");
		// 		$(settings.headerSelector).removeClass("little");
		// 		$('#' + settings.headerId).removeClass('sticky-header');
		// 		if($(settings.headerSelector).hasClass('header--transparent')){
		// 			$('#' + settings.headerId).addClass('absolute-header');
		// 		}else{
		// 			$('body').css('margin-top', 0);
		// 		}
		// 		$(settings.headerSelector).trigger('headerChange');
		// 	}
		// }
		createUnderline();
	}

	function resizeWindow() {
		var windowWidth = window.innerWidth,
		headerSection = document.getElementById(settings.headerId);
		// console.log('innerheight', window.innerHeight);
		document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
		if (headerSection) {
			var headerHeight = headerSection.clientHeight;
			var headerHeightReal = $('.header').height();
			// console.log('headerheight', headerHeight);
			// document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
			document.documentElement.style.setProperty('--header-height-real', headerHeightReal + 'px');
		}

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	function initAnchors(){
		if($(settings.anchorLink).length){
			$(settings.anchorContainer).clone().appendTo(settings.anchorHeaderContainer);
			$('.header').addClass('header--anchor');
			$(settings.anchorHeaderContainer).addClass("header__anchor--active");
			resizeWindow();
      var complementsClick = 0;
      var friandisesClick = 0;
			// Flag to control if scroll event should work
      // Flag to lock the scroll event temporarily
      let scrollLock = false;
      let observer;

      // Function to observe target element visibility
      function observeTarget($targetElement) {
          // Disconnect previous observer, if any
          if (observer) observer.disconnect();

          observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                  if (entry.isIntersecting) {
                      // Target is visible, so unlock scroll
                      scrollLock = false;
                      observer.disconnect(); // Stop observing once visible
                  }
              });
          }, {
              rootMargin: '0px',
              threshold: 0.1 // Adjust threshold as needed
          });

          observer.observe($targetElement[0]); // Start observing the target element
      }

      $(settings.anchorSlideTo).click(function(e) {
          e.preventDefault(); // Prevent default anchor behavior

          // Lock the scroll event logic
          scrollLock = true;

          // Remove active class from all anchors
          $(settings.anchorSlideTo).each(function() {
              $(this).parent().removeClass('anchor-link--active');
          });

          // Add active class to the clicked anchor
          $(this).parent().addClass('anchor-link--active');

          // Get the target element by data attribute
          var $targetElement = $('[data-anchor-id="' + $(this).attr('data-anchor-slideto') + '"]');

          if ($targetElement.length > 1) {
              $targetElement.each(function() {
                  if ($(this).is(':visible')) {
                      $targetElement = $(this);
                      return false;
                  }
              });
          }

          var heightSum = $('#shopify-section-header').height() + $('[data-section-type="anchor-menu"]').height();
          

          var currentScrollPosition = $(window).scrollTop();
    
          // Get the target scroll position (position of the target element)
          var targetScrollPosition = $targetElement.offset().top;

          // Different values based on whether scrolling to a higher or lower position
          if (targetScrollPosition < currentScrollPosition) {
              // Scrolling up to the target element
              if ($(window).width() < 800) {
                  heightSum += 230; // Adjust for small screens when scrolling up
              } else {
                  heightSum += 250; // Adjust for large screens when scrolling up
              }
          } else {
              // Scrolling down to the target element
              if ($(window).width() < 800) {
                  heightSum += 100; // Adjust for small screens when scrolling down
              } else {
                  heightSum += 120; // Adjust for large screens when scrolling down
              }
          }

          // Smooth scroll to the target element
          $("html, body").animate({
              scrollTop: $targetElement.offset().top - heightSum + 170
          }, 500, function() {
            // After the animation completes, observe the target element
            setTimeout(function() {
              // After the animation completes, observe the target element
              observeTarget($targetElement);
            }, 1500); // Delay of 500ms, can be adjusted as needed
          });
      });

      $(window).on('scroll', function() {
          // Prevent scroll handler if scrollLock is true
          if (scrollLock) return;

          var top = $(window).scrollTop() + 300 + $('.announcement-bar').height() + $('[data-section-type="anchor-menu"]').height() + $('.header-container').height();

          $(settings.anchorLink).each(function() {
            var targetAnchorId = $(this).find(settings.anchorSlideTo).attr('data-anchor-slideto');
        
            var $target;
            if (targetAnchorId == 'Croquettes') {
                // Select both elements with targetAnchorId and targetAnchorId_2
                $target = $('[data-anchor-id="' + targetAnchorId + '"], [data-anchor-id="' + targetAnchorId + '_2"]');
            } else {
                $target = $('[data-anchor-id="' + targetAnchorId + '"]');
            }
        
            if (!$target.length) return;
        
            // Get the top and bottom of both sections
            var targetTop = $target.first().offset().top;
            var targetBottom = $target.last().offset().top + $target.last().outerHeight();
        
            // Handle case where top is within any of the sections
            if (top > targetTop && top < targetBottom) {
              // For the "Croquettes" section, make sure the first button stays active when scrolling to the second
              $('.anchor-link').removeClass('anchor-link--active');
              $(this).closest('.anchor-link').addClass('anchor-link--active');
            } else {
              const stickyAnchorElement = document.querySelector('.all_products_collection_anchor_section-container');

              if (stickyAnchorElement && isElementOnTop(stickyAnchorElement)) {
                $(this).closest('.anchor-link').removeClass('anchor-link--active');
              }

              function isElementOnTop(element) {
                const rect = element.getBoundingClientRect();

                if (document.querySelector('.sticky-header')) {
                  return rect.top <= 117;
                } else {
                  return rect.top <= 0;
                }
              }
            }
          });
        
      });


		}
	}
	$('.announcement-bar, .promotion-code-bar').each(function() {
		if ($(this).is('[data-keep-in-header]') || $(this).closest('.header-v3').length) return;
    	$(this).insertBefore($(this).parent().parent().parent());
	})

	return header;
}
var header = new theme.header();

theme.searchBar = new function() {

  var settings = {
    searchToggle : '[data-search-toggle-desktop]',
    searchActiveClass : 'header__menu-item--search--active',
    openSelector : '[data-search-bar-open]',
    closeSelector : '[data-search-bar-close], main',
    searchBar : '[data-search-bar]',
    searchLaunch : '[data-search-launch]',
    inputBar : '[data-search-bar-input]',
    inputClean : '[data-search-clean]',
    result : '[data-search-result]',
    slider : '[data-search-slider]',
    activeClass : 'active',
    highlightClass : 'highlight'
  };

  var sendRequest = false;
  function searchBar() {
    $('.header__submenu--search').mouseleave(function(e){
      e.preventDefault();
      if($(settings.searchToggle).parent().hasClass(settings.searchActiveClass)){$(this).parent().removeClass(settings.searchActiveClass);}
    });
    $(settings.searchToggle).click(function(){
        if($(this).parent().hasClass(settings.searchActiveClass)){
          $(this).parent().removeClass(settings.searchActiveClass);
        }
        else{
          $(this).parent().addClass(settings.searchActiveClass);
          $(settings.inputBar).focus();
          let detail = {
            type: 'header_click',
            click_text: 'click_search_header_bar',
            click_link: '/search'
          };
          clickevent = new CustomEvent("hb_navigation_click", { detail: detail });
          window.dispatchEvent(clickevent);
        }
    });
    $(settings.inputClean).click(function(){
      $(settings.inputBar).val('');
      $(settings.result).removeClass(settings.activeClass);
      $(settings.inputClean).removeClass('active');
    })
    $(settings.inputBar).keyup(function( event ) {
      var code = event.key;

      if (this.value.length > 0)
      if(code === 'Enter'){
        goToSearchPage(this.value);
      }else{
        searchProduct(this.value);
      }

      if (this.value.length > 0) {
        $(settings.inputClean).addClass('active');
      } else {
        $(settings.inputClean).removeClass('active');
      }
    });
    $(settings.searchLaunch).click(function(){
      var search = false;
      $(settings.inputBar).each(function(){
        // console.log($(this));
        if($(this)[0].value.length > 0) search = $(this)[0].value;
      });
      if(search) goToSearchPage(search);
    })
    $(settings.openSelector).on('click', function(e) {
      openSearch();
      return false;
    });
    $(window).on('closeSearch', function(){
      if($(settings.searchToggle).parent().hasClass(settings.searchActiveClass)){$('.header__submenu--search').parent().removeClass(settings.searchActiveClass);}
      closeSearch();
      $(settings.result).removeClass(settings.activeClass);
      $(settings.searchBar).removeClass(settings.highlightClass);
    })
    $(settings.closeSelector).on('click', function() {
      closeSearch();
      $(settings.result).removeClass(settings.activeClass);
      $(settings.searchBar).removeClass(settings.highlightClass);
    });
    initSearchSlider();
  }


  function searchProduct(search) {
    $.get('/search?view=ajax&q=' + search + '*&type=product,article', function( data ) {
      $(settings.result).html(data);
      $(settings.searchBar).addClass(settings.highlightClass);
      $(settings.result).addClass(settings.activeClass);
      $(window).trigger('initQuickviewHandle');
      initSearchSlider();
    });

  }


  function openSearch() {
    if(ga) ga('send', 'event', 'Search', 'open', 'desktop');
    $(window).trigger('resize');
    $(settings.searchBar).addClass(settings.activeClass);
  }
  function closeSearch() {
    $(settings.searchBar).removeClass(settings.activeClass);
  }

  function initSearchSlider(){
    $(function(){
      $(settings.slider).each(function(){
        var flickitySettings = JSON.parse($(this).attr('data-search-slider'));
        // console.log("flickitySettings ", flickitySettings);

        var $carousel = $(this).flickity(flickitySettings);
      });
    })
  }
  function goToSearchPage(search){
    if ( matchMedia('screen and (min-width: 768px)').matches ) {
      window.location.href="/search?q=" + search + '*&type=product,article';
    }
  }
  return searchBar;
}

var searchBar = new theme.searchBar();

theme.scrollReveal = new function() {

    var settings = {
        elementSelector : '[data-scroll-reveal]'
    }
    function scrollReveal() {
        $(function(){
            $(settings.elementSelector).each(function(){
                if ( matchMedia('screen and (min-width: 768px)').matches ) {

                    var delay = $(this).attr('data-scroll-reveal');
                    var id = '#' + $(this).attr('id');
                    var options = {
                        delay : delay,
                        mobile:false
                    }
                    ScrollReveal().reveal(id, options)
                }
            });

        });
    }
    return scrollReveal;
}

var scrollReveal = new theme.scrollReveal();


/** side cart **/
theme.cart = new function() {

    var settings = {};

    function cart(cartSettings) {
        // init default settings
        var defaultSettings = {
            bodySelector : "body",
            nonScrollClass : "non-scroll",
            openCartSelector : "[data-cart-open]",
            toggleCartSelector : "[data-cart-toggle]",
            cartCountSelector:'[data-cart-count]',
            closeCartSelector : "[data-cart-close]",
            cartLoaderSelector : '[data-cart-loader]',
            cartSelector : "[data-side-cart]",
            orderPriceSelector : '[data-cart-price]',
            checkoutButtonSelector : '[data-checkout-button]',
            continueShoppingSelector : '[data-continue-shopping]',
            cartTotalPriceSelector : '[data-cart-total-price]',
            backgroundSelector : "[data-cart-background-overlay]",
            openCartClass : 'open',
            activeBackgroundClass : "active",
            emptyCartText : '<img src="https://cdn.shopify.com/s/files/1/2598/9270/files/Calque_1_1e7c3739-ecb0-40eb-ab13-5d0411e73345.svg?v=1738069139" alt="Votre panier est vide" /><div class="cart__empty-state heading z-h8">Votre panier est vide<span>Votre poilu attend !</span></div>',
            headerSelector : '.header',
            headerNotLight : 'not-light',

            cartItemsSelector : '[data-cart-items]',
            cartItemSelector : '[data-cart-item]',
            cartItemNoSubscribeSelector:'[data-cart-item--no-subscribe]',
            cartItemEchantillonSelector:'[data-cart-item--echantillon]',
            cartItemSubscribeOffSelector : '[data-cart-item--subscribe-off]',
            cartItemSubscribeOnSelector : '[data-cart-item--subscribe-on]',
            itemStatusAttribute : 'data-item-status',

            popupToggleSelector : '[data-item-popup-toggle]',
            popupKeyAttribute : 'data-item-popup-key',
            openPopup : '[data-open-popup]',
            closePopup : '[data-close-popup]',
            popupSelector : '[data-popup]',
            popupContainerSelector : '[data-quickview-container]',
            productPopupSelector : '[data-popup-product]',
            nonScrollClass : 'non-scroll',
            popupPlusSelector : '[data-popup-plus]',
            popupQuantitySelector : '[data-popup-quantity]',
            popupMinusSelector : '[data-popup-minus]',
            popupFrequencySelector : '[data-popup-frequency]',
            popupValidate : '[data-popup-validate]',
            qtyAttribute : 'data-quantity',

            itemSubscribeSelector : '[data-item-subscribe]',
            itemUnsubscribeSelector : '[data-item-unsubscribe]',
            itemKeyAttribute : 'data-item-key',

            itemUpdateSelector : '[data-item-update]',
            itemUpdateAttribute : 'data-item-update',
            itemQuantityAttribute : 'data-item-quantity',
            itemSkuAttribute: 'data-item-sku',
            itemHandleAttribute : 'data-item-handle',
            dataAttributesSelector : "[data-attributes]",
            customerIdAttribute : "data-customer-id",
            customerEmailAttribute : 'data-customer-email',

            progressPriceSelector : '[data-progress-price]',
            progressGoalAttr : 'data-progress-goal',
            progressGoalAttrChat : 'data-progress-goal-chat',
            progressContainerSelector : '[data-progress-container]',
            progressBarContainerSelector : '[data-progress-bar-container]',
            progressBarSelector : '[data-progress-bar]',
            progressReachClass : 'cart-progress__container--reached',
            goalStepSelector : "[data-goal-step]",
            progressStep1Text : "[data-progress-step1-text]",
            progressStep2Text : "[data-progress-step2-text]",
            progressStep3Text : "[data-progress-step3-text]",
            progressStep4Text : "[data-progress-step4-text]",

            gobeletContainerSelector : '[data-gobelet-container]',
            gobeletMinAttr : 'data-gobelet-min',
            gobeletIdAttr : 'data-gobelet-id',
            gobeletSwitchSelector : '[data-gobelet-switch]',


            upsellFlickity : '[data-flickity-cart-upsell]',
            upsellFlickityData : 'data-flickity-cart-upsell',
            upsellSwitch : '[data-upsell-switch]',
            upsellSwitchData : 'data-upsell-switch',
            upsellId : '[data-upsell-id]',
            upsellIdData : 'data-upsell-id',

            brocheContainerSelector : '[data-broche-container]',
            brocheMinAttr : 'data-broche-min',
            brocheIdAttr : 'data-broche-id',
            brocheSwitchSelector : '[data-broche-switch]'
        };
        // merge settings
        settings = $.extend({}, defaultSettings, cartSettings);

        // init cart
        $(document).on('cart.ready', function(event, cart) {
            constructCart(cart, false);
        });

        // call classic function on click on trigger elemets
        $(settings.toggleCartSelector).on('click', function() {
            $('[data-header-close]').click();
            toggleCart();
            return false;
        });

        $('body').on('click', settings.closeCartSelector, function() {
            closeCart();
            return false;
        });

        $(settings.openCartSelector).on('click', function() {
            openCart();
            return false;
        });

        $( document ).ready(function() {
          if (window.location.href.indexOf("sideCartOpen") > -1) {
            openCart();
            return false;
          }
        });

        document.addEventListener('giftcardAddedToCart', async function() {
          var _cart = await (await fetch(`/cart.json`)).json();
          constructCart(_cart, true);
          clearPopups();
        });
      

        $(document).on('cart.requestDone', function(event) {
            jQuery.getJSON('/cart', function(cart){
                $(settings.cartLoaderSelector).hide();
                constructCart(cart, true);
                clearPopups();
                $(window).trigger('triggerGtmAtc');
            });
        });
        $(document).on('cart.requestComplete', function(event, cart) {

            constructCart(cart, true);
            $(settings.bodySelector).addClass(settings.nonScrollClass);
            $('[data-cart-items]').focus();

            // Set timeout pour attendre l'application du Shopify Script
            setTimeout(function(){
                jQuery.getJSON('/cart', function(cart){
                    CartJS.cart = cart;
                    updateUpsellPrices(cart);
                    $(window).trigger('triggerGtmAtc');
                });
            }, 1100);
        });
        // setInterval(function(){
        //     calculateCartHeight(cart);
        // }, 400)
    }
    function addUpsell(cart, variant_id){
        var founded = false;
        for(var i = 0; i < cart.items.length; i++){
            var item = cart.items[i];
            // console.log('Item.id ', item.id, ' upsell_id ', variant_id);
            if(item.id == variant_id){
                founded = true;
            }
        }
        // console.log('Founded ', founded);
        if(!founded){
            $(settings.cartLoaderSelector).show();
            jQuery.post('/cart/add.js', {items : [{quantity: 1,id : variant_id}]})
            .done(function(){
                $(document).trigger('cart.requestDone');

                if (variant_id == 39371671568426) {
                    // variant_id = 39342566211626;
                } else if (variant_id == 39371675729962) {
                    // variant_id = 39342573518890;
                }

                async function getUpdatedCart () {
                  var _cart = await (await fetch(`/cart.json`)).json();
                  var addedItem = _cart.items.find(item => {
                    return item.id == variant_id
                  });
                   addToCartSnowplow(addedItem.quantity, addedItem.sku, addedItem.handle, false, false);
                }
        
                getUpdatedCart();

                if (!localStorage.getItem('sideCartUpsell_' + variant_id)) {
                    var element = $('[data-upsell-id="'+ variant_id +'"]');
                    localStorage.setItem('sideCartUpsell_' + variant_id, element.wrap('<div id="sideCartUpsell_'+variant_id+'"></div>').parent().html());
                }
                $(settings.upsellFlickity).flickity( 'remove', $('[data-upsell-id="'+ variant_id +'"]'));
                $('#sideCartUpsell_'+variant_id).remove();
            });
            
        }
                
    }

     // ADD TO CART SNOWPLOW EVENT

     function addToCartSnowplow(quantity, sku, handle, isSubscriptionProduct, subscription) {

      let detail = {
        sku: sku,
        handle: handle,
        quantity: parseInt(quantity),
        subscription: isSubscriptionProduct,
        inventory_status: subscription ? 'subscription' : 'oneoff',
        creative: "up-sell_sidecart"
      };
  
      let hb_event = new CustomEvent("hb_add_to_cart", { detail: detail });

      window.dispatchEvent(hb_event);
    }

    function addGobelet(cart){
        var gobelet_id = $(settings.gobeletContainerSelector).attr(settings.gobeletIdAttr);
        var founded = false;
        for(var i = 0; i < cart.items.length; i++){
            var item = cart.items[i];
            // console.log('Item.id ', item.id, ' gobelet_id ', gobelet_id);
            if(item.id == gobelet_id){
                founded = true;
                if(item.quantity > 1){
                    jQuery.post('/cart/update.js', ('updates[' + item.key + ']=1'))
                    .done(function(){$(document).trigger('cart.requestDone');});
                }
            }
        }
        // console.log('Founded ', founded);
        if(!founded){
            $(settings.cartLoaderSelector).show();
            jQuery.post('/cart/add.js', {items : [{quantity: 1,id : gobelet_id}]})
            .done(function(){$(document).trigger('cart.requestDone');});
        }
    }
    function removeGobelet(cart){
        var gobelet_id = $(settings.gobeletContainerSelector).attr(settings.gobeletIdAttr);
        for(var i = 0; i < cart.items.length; i++){
            var item = cart.items[i];
            if(item.id == gobelet_id){
                $(settings.cartLoaderSelector).show();
                jQuery.post('/cart/update.js', ('updates[' + item.key + ']=0'))
                .done(function(){$(document).trigger('cart.requestDone');});
            }
        }
    }
    function addBroche(cart){
        var broche_id = $(settings.brocheContainerSelector).attr(settings.brocheIdAttr);
        var founded = false;
        for(var i = 0; i < cart.items.length; i++){
            var item = cart.items[i];
            // console.log('Item.id ', item.id, ' broche_id ', broche_id);
            if(item.id == broche_id){
                founded = true;
                if(item.quantity > 1){
                    jQuery.post('/cart/update.js', ('updates[' + item.key + ']=1'))
                    .done(function(){$(document).trigger('cart.requestDone');});
                }
            }
        }
        // console.log('Founded ', founded);
        if(!founded){
            $(settings.cartLoaderSelector).show();
            jQuery.post('/cart/add.js', {items : [{quantity: 1,id : broche_id}]})
            .done(function(){$(document).trigger('cart.requestDone');});
        }
    }
    function removeBroche(cart){
        var broche_id = $(settings.brocheContainerSelector).attr(settings.brocheIdAttr);
        for(var i = 0; i < cart.items.length; i++){
            var item = cart.items[i];
            if(item.id == broche_id){
                $(settings.cartLoaderSelector).show();
                jQuery.post('/cart/update.js', ('updates[' + item.key + ']=0'))
                .done(function(){$(document).trigger('cart.requestDone');});
            }
        }
    }
    function initHandlers(cart){
        //upsell switch
        $(settings.upsellSwitch).each(function() {

            var $currentEl = $(this);
            // Remove any previous event listeners to prevent duplicates
            $($currentEl).off('change').on('change', function(){
                var variant_id = $currentEl.attr(settings.upsellSwitchData);

                if($($currentEl).is(':checked')){
                    addUpsell(cart, variant_id);
                }
            });

          });

        $(document).off('click.cartUpsellNav').on('click.cartUpsellNav', '.cart_upsell-nav-btn--prev', function() {
            $(this).closest('.cart_upsell-block').find(settings.upsellFlickity).flickity('previous');
        });

        $(document).on('click.cartUpsellNav', '.cart_upsell-nav-btn--next', function() {
            $(this).closest('.cart_upsell-block').find(settings.upsellFlickity).flickity('next');
        });

        // Gobelet switcher
        // Remove any previous event listeners to prevent duplicates
        $(settings.gobeletSwitchSelector).off('change').change(function(){
            if($(this).is(':checked')){
                // console.log('ADD GOBELET 1');
                addGobelet(cart);
            } else {
                // console.log('REMOVE GOBELET 1 ');
                removeGobelet(cart);
            }
        });
        // Broche switcher
        // Remove any previous event listeners to prevent duplicates
        $(settings.brocheSwitchSelector).off('change').change(function(){
            if($(this).is(':checked')){
                // console.log('ADD broche 1');
                addBroche(cart);
            } else {
                // console.log('REMOVE broche 1 ');
                removeBroche(cart);
            }
        });

        // Update quantity and delete
        // Remove any previous event listeners to prevent duplicates
        $(settings.itemUpdateSelector).off('click').click(function() {
            var key = $(this).attr('data-item-update');
            var variant_id = $(this).attr('data-item-update-variant-id') || $(this).closest('[data-cart-item]').attr('data-item-variant-id');
            var qty = $(this).attr(settings.itemQuantityAttribute);
            var handle = $(this).closest('.cart-item').attr(settings.itemHandleAttribute);
            var sku = $(this).closest('.cart-item').attr(settings.itemSkuAttribute);
            var isSubscription = $(this).closest('.cart-item').attr('data-item-status');
            
            // Show loader immediately
            $('[data-cart-loader]').css('display', 'block');

            if(qty != 0 && variant_id) {
              var cart = CartJS.cart;
              if (cart && cart.items) {
                var currentLineQty = 0;
                for (var i = 0; i < cart.items.length; i++) {
                  if (cart.items[i].key == key) currentLineQty = cart.items[i].quantity;
                }
                if (purchaseLimitBlocksLineUpdate(cart.items, variant_id, qty, currentLineQty)) {
                  $('[data-cart-loader]').css('display', 'none');
                  return;
                }
              }
            }

            if(qty == 0) {
              // Handle removal of items
              jQuery.post('/cart/update.js', ('updates[' + key + ']=0'))
              .done(function(data){
                  var cart = JSON.parse(data);
                  if (cart.total_price < 1000) {
                      var firstGiftRemoval = function() {
                          return jQuery.post('/cart/update.js', 'updates[39342566211626]=0');
                      };
                      
                      var secondGiftRemoval = function() {
                          return jQuery.post('/cart/update.js', 'updates[39342573518890]=0');
                      };
                      
                      firstGiftRemoval()
                          .then(secondGiftRemoval)
                          .then(function() {
                              // Hide loader after all operations complete
                              $('[data-cart-loader]').css('display', 'none');
                              $(document).trigger('cart.requestDone');
                          });
                  } else {
                      // Hide loader if no gifts to remove
                      $('[data-cart-loader]').css('display', 'none');
                      $(document).trigger('cart.requestDone');
                  }
                  for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key.startsWith('sideCartUpsell_')) {
                        const variant_id = key.replace('sideCartUpsell_', '');
                        // If product is NOT in cart, we need to restore it
                        if (!cart.items.some(item => item.variant_id == variant_id)) {
                            // Get the stored slide
                            const storedSlide = localStorage.getItem(key);
                            var $carousel = $(settings.upsellFlickity);
                            
                            // Force destroy Flickity
                            $carousel.each(function() {
                                var flkty = $(this).data('flickity');
                                if (flkty) {
                                    flkty.destroy();
                                }
                            });
                            
                            // Add the slide back
                            $carousel.append(storedSlide); 
                            
                            // Remove from storage
                            localStorage.removeItem(key);
                            
                            // Reinitialize Flickity with ALL options
                            $carousel.flickity({
                                wrapAround: true,
                                draggable: true,
                                prevNextButtons: true,
                                pageDots: true,
                                cellAlign: 'center'
                            });
                        }
                    }
                  }
                  snowplowUpdateCart(handle, sku, qty, isSubscription)
              });
          } else {
                // Handle quantity updates
                jQuery.post('/cart/update.js', ('updates[' + key + ']=' + qty))
                .done(function(){
                    // Hide loader after quantity update
                    $('[data-cart-loader]').css('display', 'none');
                    $(document).trigger('cart.requestDone');
                    snowplowUpdateCart(handle, sku, qty, isSubscription);
                });
            }
        });
    }
    function snowplowUpdateCart(handle, sku, qty, isSubscription) {
      let detail = {
        handle: handle,
        sku: sku,
        quantity: parseInt(qty),
        subscription: isSubscription !== 'SUBSCRIBE-OFF' ? true : false,
        inventory_status: isSubscription !== 'SUBSCRIBE-OFF' ? 'subscription' : 'oneoff',
        creative: 'minicart'
      };
 
      let cartevent = new CustomEvent("hb_update_cart", { detail: detail });
      window.dispatchEvent(cartevent);
    }
    function getPrice(price, cart) {
        var price = Number(price / 100).toFixed(2);
        if (cart.currency == "EUR")
        return price + "€";
        else
        return price + "$";
    }
    function formatUpsellPriceCents(cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + '€';
    }
    function getUpsellDiscountPercentage(cart) {
        if (!cart) return 0;

        var apps = cart.cart_level_discount_applications || [];
        if (apps.length > 0 && apps[0].value_type === 'percentage') {
            return parseFloat(apps[0].value) || 0;
        }

        var original = 0;
        var final = 0;
        (cart.items || []).forEach(function (item) {
            original += item.original_line_price != null ? item.original_line_price : item.line_price;
            final += item.final_line_price != null ? item.final_line_price : item.line_price;
        });

        if (original <= 0 || final >= original) return 0;
        return Math.round((1 - final / original) * 100);
    }
    function updateUpsellPrices(cart) {
        if (!cart) return;

        var discountPct = getUpsellDiscountPercentage(cart);

        document.querySelectorAll('[data-upsell-container][data-variant-price]').forEach(function(el) {
            var priceEl = el.querySelector('.cart_upsell-price');
            if (!priceEl) return;

            var priceCents = parseInt(el.getAttribute('data-variant-price'), 10);
            if (isNaN(priceCents)) return;

            if (discountPct > 0) {
                var discountAmount = Math.floor(priceCents * discountPct / 100);
                var finalCents = priceCents - discountAmount;
                priceEl.innerHTML =
                    '<span class="cart-item__price--compare">' + formatUpsellPriceCents(priceCents) + '</span>' +
                    '<span>' + formatUpsellPriceCents(finalCents) + '</span>';
            } else {
                priceEl.innerHTML = '<span>' + formatUpsellPriceCents(priceCents) + '</span>';
            }
        });
    }
    function unescape(string) {
        return new DOMParser().parseFromString(string,'text/html').querySelector('html').textContent;
    }
    function getCartItemsContainer() {
        var $list = $('[data-cart-items-list]');
        return $list.length ? $list : $(settings.cartItemsSelector);
    }
    var SUB_AUTO_GIFT_DEFAULT_DOG_VARIANT_ID = 52907219779913;
    var SUB_AUTO_GIFT_DEFAULT_CAT_VARIANT_ID = 52907179245897;
    var SUB_AUTO_GIFT_LEGACY_VARIANT_IDS = [14539662917674];

    function getSubAutoGiftConfig() {
      var config = window.subAutoGiftConfig || {};
      var dogVariantId = parseInt(config.dogVariantId, 10);
      var catVariantId = parseInt(config.catVariantId, 10);
      var legacyVariantIds = Array.isArray(config.legacyVariantIds) ? config.legacyVariantIds.slice() : SUB_AUTO_GIFT_LEGACY_VARIANT_IDS.slice();
      var threshold = parseFloat(config.threshold);

      return {
        enabled: config.enabled !== false,
        threshold: isNaN(threshold) ? 0 : threshold,
        dogVariantId: isNaN(dogVariantId) ? SUB_AUTO_GIFT_DEFAULT_DOG_VARIANT_ID : dogVariantId,
        catVariantId: isNaN(catVariantId) ? SUB_AUTO_GIFT_DEFAULT_CAT_VARIANT_ID : catVariantId,
        legacyVariantIds: legacyVariantIds
      };
    }

    function getSubAutoGiftVariantIds(config) {
      config = config || getSubAutoGiftConfig();
      var ids = [config.dogVariantId, config.catVariantId].concat(config.legacyVariantIds || []);
      return ids.filter(function(id, index, list) {
        return list.indexOf(id) === index;
      });
    }

    function cartHasSubAutoGiftVariant(cart, variantId) {
      if (!cart || !cart.items || !variantId) return false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id == variantId) return true;
      }
      return false;
    }

    function getCartTotalForSubAutoGiftThreshold(cart, giftVariantIds) {
      var total = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (giftVariantIds.indexOf(item.variant_id) !== -1) continue;
        total += item.final_line_price != null ? item.final_line_price : item.line_price;
      }
      return total / 100;
    }

    function isSubAutoGiftThresholdMet(cart, config) {
      config = config || getSubAutoGiftConfig();
      if (!config.threshold || config.threshold <= 0) return true;
      return getCartTotalForSubAutoGiftThreshold(cart, getSubAutoGiftVariantIds(config)) >= config.threshold;
    }

    function constructCart(cart, open) {
      // create elemets
      var contexts = [];
      var context = {};
      var c = null;
      var final_html = "";
      var source = "";
      var template = null;
      var echantillonCounter = 0;

      var totalQuantityByVariant = {};
      for (var qi = 0; qi < cart.items.length; qi++) {
        var vid = cart.items[qi].id;
        totalQuantityByVariant[vid] = (totalQuantityByVariant[vid] || 0) + cart.items[qi].quantity;
      }
    
      var cart_total_price_side_cart = getCartPrice(cart);
      var price_with_giftcard = getCartPrice(cart);
    
      const targetGiftCardIds = [
          9389312672073,
          9418861576521,
          9418862690633,
          9418863083849,
          9418866622793
      ];
    
      const targetProductTotal = cart.items
          .filter(item => targetGiftCardIds.includes(item.product_id))
          .reduce((sum, item) => sum + item.line_price, 0); // Additionne les prix des lignes (quantité * prix unitaire)
    
      // Met à jour le prix en déduisant le total des gift cards
      cart_total_price_side_cart -= targetProductTotal;
    
      // If there is only a subscription auto-gift in cart, remove it
      var subAutoGiftConfig = getSubAutoGiftConfig();
      var subAutoGiftVariantIds = getSubAutoGiftVariantIds(subAutoGiftConfig);
      if (cart.items.length == 1) {
          if (subAutoGiftVariantIds.indexOf(cart.items[0].variant_id) !== -1) {
              CartJS.removeItemById(cart.items[0].id);
          }
      }
    
      if (cart.items.length > 0 && offerProducts.length > 0 ) { //&& price_with_giftcard > 0
        // check if has category chat or chien or both
        var productCategory = [];
        var category = '';
        var hasChien = false;
        var hasChat = false;
        for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].id != 39357124018218) {
                productCategory.push(cart.items[i].vendor);
            }
        }
        for (var j = 0; j < productCategory.length; j++) {
            if (productCategory[j].includes("chien") || productCategory[j].includes("chiot")) {
                hasChien = true;
            }
            if (productCategory[j].includes("chat") || productCategory[j].includes("chaton")) {
                hasChat = true;
            }
        }
        if (hasChien && !hasChat) {
            category = 'chien';
        } else if (!hasChien && hasChat) {
            category = 'chat';
        } else if (hasChien && hasChat) {
            category = 'both';
        }
    
        var productChien = null;   // Step 2 dog product
        var productChat = null;    // Step 2 cat product
        var offerChien = null;     // Step 2 dog offer
        var offerChat = null;      // Step 2 cat offer
        var productChien2 = null;  // Step 3 dog product
        var productChat2 = null;   // Step 3 cat product
        var offerChien2 = null;    // Step 3 dog offer
        var offerChat2 = null;     // Step 3 cat offer
        var productChien3 = null;  // Step 4 dog product
        var productChat3 = null;   // Step 4 cat product
        var offerChien3 = null;    // Step 3 dog offer
        var offerChat3 = null;     // Step 3 cat offer
        var productChien4 = null;  // Step 4 second dog product
        var productChat4 = null;   // Step 4 second cat product
        var offerChien4 = null;    // Step 4 dog offer
        var offerChat4 = null;     // Step 4 cat offer

        for (var i = 0, l = offerProducts.length; i < l; i++) {
          if (offerProducts[i].category == 'chien') {
              if (!productChien) {
                  productChien = offerProducts[i].product;
                  offerChien = offerProducts[i];
              } else if (!productChien2) {
                  productChien2 = offerProducts[i].product;
                  offerChien2 = offerProducts[i];
              } else if (!productChien3) {
                  productChien3 = offerProducts[i].product;
                  offerChien3 = offerProducts[i];  // Added this
              } else {
                  productChien4 = offerProducts[i].product;
                  offerChien4 = offerProducts[i];  // Added this
              }
          }
          if (offerProducts[i].category == 'chat') {
              if (!productChat) {
                  productChat = offerProducts[i].product;
                  offerChat = offerProducts[i];
              } else if (!productChat2) {
                  productChat2 = offerProducts[i].product;
                  offerChat2 = offerProducts[i];
              } else if (!productChat3) {
                  productChat3 = offerProducts[i].product;
                  offerChat3 = offerProducts[i];  // Added this
              } else {
                  productChat4 = offerProducts[i].product;
                  offerChat4 = offerProducts[i];  // Added this
              }
          }
        }
    
        var offerProduct = category === 'chat' ? offerChat : offerChien;
        // Step-4 threshold is on product_4 slots (3rd/4th entries). Prefer 4th, fall back to 3rd.
        var offerProduct2 = category === 'chat'
          ? (offerChat4 || offerChat3)
          : (offerChien4 || offerChien3);

        var cartTotal = cart.total_price / 100;
        var useChatThresholds = hasChat && !hasChien;
        var tier2Check = 999;
        var tier4Check = 999;

        if (offerProduct) {
          tier2Check = useChatThresholds
            ? (offerProduct.progress_value_chat || offerProduct.progress_value || 999)
            : (offerProduct.progress_value || 999);
          offerProduct.progress_value_check = tier2Check;
        }
        if (offerProduct2) {
          tier4Check = useChatThresholds
            ? (offerProduct2.progress_value_chat || offerProduct2.progress_value || 999)
            : (offerProduct2.progress_value || 999);
          offerProduct2.progress_value_check = tier4Check;
        }

        $('[data-progress-value4-text-display]').text(tier4Check);

        // if both remove product chat if in cart
        if (category == 'both') {
            // Don't automatically remove chat products
            // Instead, check cart total and gift count
            var giftCount = cart.items.filter(item => 
              item.variant_id == productChat?.variants[0].id || 
              item.variant_id == productChien?.variants[0].id ||
              item.variant_id == productChat2?.variants[0].id || 
              item.variant_id == productChien2?.variants[0].id ||
              item.variant_id == productChat3?.variants[0].id || 
              item.variant_id == productChien3?.variants[0].id ||
              item.variant_id == productChat4?.variants[0].id || 
              item.variant_id == productChien4?.variants[0].id
            ).length;



            // If cart total is between step 2 and step 4 thresholds
            if (cartTotal >= tier2Check && cartTotal < tier4Check) {
                // Only allow one gift from first tier
                if (giftCount > 1) {
                    // Remove excess gifts
                    var firstTierGifts = 0;
                    var secondTierGifts = 0;
                    var thirdTierGifts = 0;
                    cart.items.forEach(function(item) {
                      if (item.variant_id == productChat?.variants[0].id || 
                          item.variant_id == productChien?.variants[0].id) {
                          firstTierGifts++;
                          if (firstTierGifts > 1) CartJS.removeItemById(item.id);
                      }
                      if (item.variant_id == productChat2?.variants[0].id || 
                          item.variant_id == productChien2?.variants[0].id) {
                          secondTierGifts++;
                          if (secondTierGifts > 1) CartJS.removeItemById(item.id);
                      }
                      if ((item.variant_id == productChat3?.variants[0].id || 
                           item.variant_id == productChien3?.variants[0].id) ||
                          (item.variant_id == productChat4?.variants[0].id || 
                           item.variant_id == productChien4?.variants[0].id)) {
                          thirdTierGifts++;
                          if (thirdTierGifts > 1) CartJS.removeItemById(item.id);
                      }
                    });
                }
            }
            // If cart total is above step 4 threshold
            else if (cartTotal >= tier4Check) {
                // Allow up to three gifts (one from each tier)
                if (giftCount > 3) {
                    // Remove excess gifts
                    var firstTierGifts = 0;
                    var secondTierGifts = 0;
                    var thirdTierGifts = 0;
                    cart.items.forEach(function(item) {
                      if (item.variant_id == productChat?.variants[0].id || 
                          item.variant_id == productChien?.variants[0].id) {
                          firstTierGifts++;
                          if (firstTierGifts > 1) CartJS.removeItemById(item.id);
                      }
                      if (item.variant_id == productChat2?.variants[0].id || 
                          item.variant_id == productChien2?.variants[0].id) {
                          secondTierGifts++;
                          if (secondTierGifts > 1) CartJS.removeItemById(item.id);
                      }
                      if (item.variant_id == productChat3?.variants[0].id || 
                          item.variant_id == productChien3?.variants[0].id ||
                          item.variant_id == productChat4?.variants[0].id || 
                          item.variant_id == productChien4?.variants[0].id) {
                          thirdTierGifts++;
                          if (thirdTierGifts > 1) CartJS.removeItemById(item.id);
                      }
                    });
                }
            }
        }

        // First check if we need to remove gifts
        if (cartTotal < tier2Check) {
          // Original step 2 removal logic stays the same
          cart.items.forEach(function(item) {
              if ((offerProduct && item.variant_id == offerProduct.product.variants[0].id) || 
                  (offerProduct2 && item.variant_id == offerProduct2.product.variants[0].id)) {
                  CartJS.removeItemById(item.id);
              }
          });
        }

        // Add check for step 4 to 3 transition
        if (cartTotal < tier4Check) {
          cart.items.forEach(function(item) {
              if ((offerChat3 && item.variant_id == offerChat3.product.variants[0].id) ||
                  (offerChat4 && item.variant_id == offerChat4.product.variants[0].id) ||
                  (offerChien3 && item.variant_id == offerChien3.product.variants[0].id) ||
                  (offerChien4 && item.variant_id == offerChien4.product.variants[0].id)) {
                  CartJS.removeItemById(item.id);
              }
          });
        }

        // Continue with regular item processing...
        for (var j = 0; j < cart.items.length; j++) {
            var c = cart.items[j];
            
            // Check both first and second offer products
            if ((offerProduct && c.variant_id == offerProduct.product.variants[0].id) || 
                (offerProduct2 && c.variant_id == offerProduct2.product.variants[0].id)) {
                
                if (cartTotal < tier2Check) {
                    CartJS.removeItemById(c.id);
                    var $carousel = $(settings.upsellFlickity);
                    if ($carousel.length > 0) {
                        if (localStorage.getItem('sideCartUpsell_' + c.id)) {
                            var item = $(localStorage.getItem('sideCartUpsell_' + c.id)).unwrap();
                            $carousel.flickity('append', item);
                            localStorage.removeItem('sideCartUpsell_' + c.id);
                        }
                    }
                } else if (c.quantity > 1) {
                    CartJS.updateItem(j + 1, 1);
                }
            }
        }
    
        // Check gift card
        const targetGiftCardIds = [
            9389312672073,
            9418861576521,
            9418862690633,
            9418863083849,
            9418866622793
        ];
    
        const onlyGiftCardProductInCart = cart.items.every(item => targetGiftCardIds.includes(item.product_id));
    
        if (onlyGiftCardProductInCart) {
        }
      }
    
      // Logic for adding free product for subscribers
      // Skip while subscription booster is rebuilding the cart — otherwise
      // CartJS add/remove gift races cause an infinite loader loop.
      var subAutoGiftDogVariantId = subAutoGiftConfig.dogVariantId;
      var subAutoGiftCatVariantId = subAutoGiftConfig.catVariantId;
      var subAutoGiftThresholdMet = isSubAutoGiftThresholdMet(cart, subAutoGiftConfig);
      var hasSubscription = hasCatSubscription = hasDogSubscription = false;
      var foundedCatGobelet = cartHasSubAutoGiftVariant(cart, subAutoGiftCatVariantId);
      var foundedDogGobelet = cartHasSubAutoGiftVariant(cart, subAutoGiftDogVariantId);
      for (var i = 0, l = cart.items.length; i < l; i++) {
          let it = cart.items[i];
          if (it.selling_plan_allocation) {
            hasSubscription = true;
            if (it.sku.includes('CAT') || it.vendor.includes("chat") || it.vendor.includes("chaton")) {
                hasCatSubscription = true;
              }
              if (it.sku.includes('DOG') || it.vendor.includes("chien") || it.vendor.includes("chiot")) {
                hasDogSubscription = true;
              }
          }
      }

      if (!window.__subscriptionBoosterUpdating) {
      if (!subAutoGiftConfig.enabled) {
        if (foundedDogGobelet) {
          CartJS.removeItemById(subAutoGiftDogVariantId);
        }
        if (foundedCatGobelet) {
          CartJS.removeItemById(subAutoGiftCatVariantId);
        }
      }
      // Remove gifts if there are no subscriptions in cart or threshold is not met
      else if (!hasSubscription || !subAutoGiftThresholdMet) {
        if (foundedDogGobelet) {
          CartJS.removeItemById(subAutoGiftDogVariantId);
        }
        if (foundedCatGobelet) {
          CartJS.removeItemById(subAutoGiftCatVariantId);
        }
      }
      else if (!foundedDogGobelet && hasDogSubscription) {
        if (foundedCatGobelet) {
          CartJS.removeItemById(subAutoGiftCatVariantId);
        }
        CartJS.addItem(subAutoGiftDogVariantId, 1, {
            '_giveaway': true
        });
      }
      else if (!foundedCatGobelet && hasCatSubscription && !hasDogSubscription) {
        if (foundedDogGobelet) {
          CartJS.removeItemById(subAutoGiftDogVariantId);
        }
        CartJS.addItem(subAutoGiftCatVariantId, 1, {
            '_giveaway': true
        });
      }
      else if(foundedCatGobelet && foundedDogGobelet) {
        CartJS.removeItemById(subAutoGiftCatVariantId);
      }
      }

    
      $(window).trigger('clearQuickviews');
      var gobelet_id = $(settings.gobeletContainerSelector).attr(settings.gobeletIdAttr);
      var broche_id = $(settings.brocheContainerSelector).attr(settings.brocheIdAttr);
      var shouldChangeCount = false;
      for (var i = 0, l = cart.items.length; i < l; i++) {
          c = cart.items[i];
          var productObject = {};
          var variantObject = {};
          var status = 'NO-SUBSCRIBE';
          var isGobeletOrBroche = '';
          var isEchantillon = '';
    
          for (var k = 0; k < all_products.length; k++) {
              var product = all_products[k];
              if (product.product.id == c.product_id) {
                  productObject = product;
                  if (productObject.product.tags.indexOf('echantillons') !== -1) {
                      status = 'ECHANTILLON';
                      echantillonCounter += c.quantity;
                  }
                  for (var j = 0; j < productObject.variants.length; j++) {
                      if (productObject.variants[j].variant.id == c.id) {
                          variantObject = productObject.variants[j];
                      }
                  }
              }
          }
          if (c && c.selling_plan_allocation) status = 'SUBSCRIBE-ON';
          else {
              status = 'SUBSCRIBE-OFF';
          }
          // GWP / auto free gifts (e.g. calendar gift): lock qty + use Offert template.
          var freeGiftProp = c.properties && (
            c.properties._free_gift === true ||
            c.properties._free_gift === 'true' ||
            !!c.properties.__free_gift ||
            !!c.properties._giveaway
          );
          if (freeGiftProp) {
              status = 'NO-SUBSCRIBE';
              isGobeletOrBroche = 'hide';
          }
          if (c.id.toString() == gobelet_id || c.id.toString() == broche_id) {
              status = 'NO-SUBSCRIBE';
              isGobeletOrBroche = 'hide';
          }
          if (subAutoGiftVariantIds.indexOf(c.id) !== -1) {
              status = 'NO-SUBSCRIBE';
              isGobeletOrBroche = 'hide';
          }
          if ((productChat && productChien) || (productChat2 && productChien2) || (productChat3 && productChien3) || (productChat4 && productChien4)) {
            if (c.id == productChat?.variants[0].id || 
                c.id == productChien?.variants[0].id ||
                c.id == productChat2?.variants[0].id || 
                c.id == productChien2?.variants[0].id ||
                c.id == productChat3?.variants[0].id || 
                c.id == productChien3?.variants[0].id ||
                c.id == productChat4?.variants[0].id || 
                c.id == productChien4?.variants[0].id) {
                status = 'NO-SUBSCRIBE';
                isGobeletOrBroche = 'hide';
            }
          }
          if (productObject?.product?.tags?.indexOf('echantillons') !== -1 || 
              variantObject?.variant?.title?.indexOf('chantillon') !== -1 || 
              variantObject?.variant?.title?.indexOf('unité') !== -1) {
                status = 'ECHANTILLON';
              isEchantillon = 'hide';
          }
          if (productObject?.product?.tags?.indexOf('echantillons') !== -1 || 
              variantObject?.variant?.title?.indexOf('chantillon') !== -1 || 
              variantObject?.variant?.title?.indexOf('unité') !== -1) {             
              if (c && c.selling_plan_allocation) {
                  status = 'SUBSCRIBE-ON'
                  isEchantillon = '';
              };
          }
    
          const targetGiftCardIds = [
              9389312672073,
              9418861576521,
              9418862690633,
              9418863083849,
              9418866622793
          ];
    
          var productTags = productObject?.product?.tags || [];
          var productVendor = productObject?.product?.vendor || c.vendor || '';
          var productType = productObject?.product?.type || c.product_type || '';
          
          // Compare-at in cart: subscription, line discount, or variant compare_at (FKLN-474 one-time duo/trio).
          var item_compare_at_price = null;
          var currentPriceCents = c.line_price || (c.price * c.quantity);
          var currentPricePerUnit = currentPriceCents / c.quantity;
          var originalLinePriceCents = (typeof c.original_line_price !== 'undefined' && c.original_line_price != null)
            ? c.original_line_price
            : currentPriceCents;
          var hasLineDiscountAlloc = (c.line_level_discount_allocations && c.line_level_discount_allocations.length > 0) ||
            (c.discount_allocations && c.discount_allocations.length > 0);
          var hasFinalLinePrice = typeof c.final_line_price !== 'undefined' && c.final_line_price != null;
          var hasLineDiscount = hasLineDiscountAlloc ||
            (hasFinalLinePrice && c.final_line_price < originalLinePriceCents) ||
            (c.discounted_price < c.original_price);
          var variantCompareAtCents = (typeof c.compare_at_price === 'number' && c.compare_at_price > 0)
            ? c.compare_at_price
            : (variantObject?.variant?.compare_at_price || 0);

          if (c.selling_plan_allocation && c.selling_plan_allocation.compare_at_price > c.selling_plan_allocation.price) {
              item_compare_at_price = ((c.selling_plan_allocation.compare_at_price * c.quantity) / 100).toFixed(2).toString().replace('.', ',') + '€';
          } else if (hasLineDiscount && originalLinePriceCents > currentPriceCents) {
              item_compare_at_price = getPrice(originalLinePriceCents, cart).replace('.', ',');
          } else if (currentPriceCents > 0 && variantCompareAtCents > currentPricePerUnit) {
              item_compare_at_price = ((variantCompareAtCents * c.quantity) / 100).toFixed(2).toString().replace('.', ',') + '€';
          }
          
          // Format tags for template (convert array to string if needed)
          var item_product_tags_formatted = '';
          if (Array.isArray(productTags)) {
              item_product_tags_formatted = productTags.join(', ');
          } else if (typeof productTags === 'string') {
              item_product_tags_formatted = productTags;
          }
          
          var rawProductTitle = productObject?.product?.title || c.product_title || '';
          var item_product_title = rawProductTitle
            ? rawProductTitle.charAt(0).toUpperCase() + rawProductTitle.slice(1).toLowerCase()
            : rawProductTitle;

          var context = {
              item_image: c.image,
              item_key: c.key,
              item_variant_id: variantObject?.variant?.id || c.id, // Fallback to c.id if variant id is undefined
              item_product_title: item_product_title,
              item_format: targetGiftCardIds.includes(productObject?.product?.id) ? 'Montant' : '',
              item_product_tags: item_product_tags_formatted,
              item_product_type: productType,
              item_vendor: productVendor,
              show_product_name_first: !!(productObject?.metafields?.show_product_name_first),
              item_quantity: c.quantity,
              item_handle: productObject?.product?.handle,
              item_sku: variantObject?.variant?.sku,
              item_shipping_interval_frequency: c.properties['_shipping_interval_frequency'],
              item_compare_at_price: item_compare_at_price,
              item_price: (function() {
                // Prefer item-level discount/final price instead of applying a global percentage
                var originalLinePrice = (typeof c.original_line_price !== 'undefined' && c.original_line_price != null)
                  ? c.original_line_price
                  : (typeof c.line_price !== 'undefined' ? c.line_price : (c.price * c.quantity));
                var hasAllocations = (c.line_level_discount_allocations && c.line_level_discount_allocations.length > 0) ||
                  (c.discount_allocations && c.discount_allocations.length > 0);
                var hasFinalPrice = typeof c.final_line_price !== 'undefined' && c.final_line_price != null;
                var isDiscounted = hasAllocations || (hasFinalPrice && c.final_line_price < originalLinePrice);
                var effectiveLinePrice = (isDiscounted && hasFinalPrice) ? c.final_line_price : originalLinePrice;
                if (!effectiveLinePrice || effectiveLinePrice <= 0) return "Offert";
                return getPrice(effectiveLinePrice, cart).replace('.', ',');
              })(),
              item_initial_price_without_discount: (function(){
                var originalLinePrice = (typeof c.original_line_price !== 'undefined' && c.original_line_price != null)
                  ? c.original_line_price
                  : (typeof c.line_price !== 'undefined' ? c.line_price : (c.price * c.quantity));
                var hasAllocations = (c.line_level_discount_allocations && c.line_level_discount_allocations.length > 0) ||
                  (c.discount_allocations && c.discount_allocations.length > 0);
                var hasFinalPrice = typeof c.final_line_price !== 'undefined' && c.final_line_price != null;
                var isDiscounted = hasAllocations || (hasFinalPrice && c.final_line_price < originalLinePrice);
                if (isDiscounted) return getPrice(originalLinePrice, cart).replace('.', ',');
                // FKLN-474: one-time purchase with variant compare_at (e.g. duo/trio)
                if (currentPriceCents > 0 && variantCompareAtCents > currentPricePerUnit) {
                  return ((variantCompareAtCents * c.quantity) / 100).toFixed(2).toString().replace('.', ',') + '€';
                }
                return null;
              })(),
              item_fake_initial_price_without_discount: (function() {
                // Check if this is an offer product by looking for matching product card in drawer
                var productCard = $(`.product-offer__drawer--products .product-card-offer[data-product-id="${c.product_id}"]`);
                if (productCard.length > 0 && productCard.attr('data-fake-price')) {
                  // Get the fake price from the data attribute
                  var fakePrice = productCard.attr('data-fake-price');
                  
                  // Convert to number and format with two decimal places
                  var formattedPrice;
                  if (fakePrice.includes(',')) {
                    // Handle comma as decimal separator
                    formattedPrice = parseFloat(fakePrice.replace(',', '.')).toFixed(2).replace('.', ',');
                  } else {
                    // Handle period as decimal separator or no decimal
                    formattedPrice = parseFloat(fakePrice).toFixed(2).replace('.', ',');
                  }
                  
                  // Add currency symbol
                  return formattedPrice + (cart.currency == "EUR" ? "€" : "$");
                }
                return null;
              })(),
              item_quantity_plus: ((c.quantity > 19) ? 19 : (c.quantity + 1)),
              item_quantity_minus: (c.quantity - 1),
              item_line_price: (getPrice(c.line_price, cart).replace('.', ',') != "0,00€") ? getPrice(c.line_price, cart).replace('.', ',') : "Offert",
              item_url: c.url,
              product_why_subscribe: unescape(themeSettings.product_why_subscribe),
              subscribe_popup_title: unescape(themeSettings.subscribe_popup_title),
              subscribe_popup_content: unescape(themeSettings.subscribe_popup_content).replace('<p>', '').replace('</p>', ''),
              subscribe_popup_cta: unescape(themeSettings.subscribe_popup_cta),
              subscribe_popup_url: unescape(themeSettings.subscribe_popup_url),
              subscribe_popup_picto_1: unescape(themeSettings.subscribe_popup_picto_1),
              subscribe_popup_title_1: unescape(themeSettings.subscribe_popup_title_1),
              subscribe_popup_text_1: unescape(themeSettings.subscribe_popup_text_1),
              subscribe_popup_picto_2: unescape(themeSettings.subscribe_popup_picto_2),
              subscribe_popup_title_2: unescape(themeSettings.subscribe_popup_title_2),
              subscribe_popup_text_2: unescape(themeSettings.subscribe_popup_text_2),
              subscribe_popup_picto_3: unescape(themeSettings.subscribe_popup_picto_3),
              subscribe_popup_title_3: unescape(themeSettings.subscribe_popup_title_3),
              subscribe_popup_text_3: unescape(themeSettings.subscribe_popup_text_3),
              subscribe_popup_picto_4: unescape(themeSettings.subscribe_popup_picto_4),
              subscribe_popup_title_4: unescape(themeSettings.subscribe_popup_title_4),
              subscribe_popup_text_4: unescape(themeSettings.subscribe_popup_text_4),
              hide_quantity: (variantObject?.metafields?.hide_quantity || isGobeletOrBroche === 'hide') ? 'hide' : '',
              limited_order: variantObject?.metafields?.limited_order || "",
              can_increase_quantity: (function() {
                if (isGobeletOrBroche === 'hide') return false;
                var scope = getPurchaseLimitScope(c.id);
                if (!scope) {
                  var limit = variantObject?.metafields?.limited_order;
                  if (limit === undefined || limit === null || limit === '') return true;
                  limit = parseInt(limit, 10);
                  if (isNaN(limit)) return true;
                  var total = totalQuantityByVariant[c.id] || 0;
                  return total < limit;
                }
                var productQty = cartQuantityForVariantIds(cart.items, scope.variantIds);
                var variantQty = totalQuantityByVariant[c.id] || 0;
                if (scope.variantLimit !== null && variantQty >= scope.variantLimit) return false;
                return productQty < scope.limit;
              })(),
              isGobeletOrBroche: isGobeletOrBroche,
              item_discount_percentage: (function() {
                var pct = productObject?.metafields?.discount_percentage;
                if (pct == null || pct === '') return '';
                var n = parseFloat(String(pct).replace(',', '.'));
                if (isNaN(n)) return '';
                if (n > 0 && n < 1) n = n * 100;
                return String(Math.round(n));
              })(),
              item_discount_variant_price: (function() {
                var allocations = variantObject?.variant?.selling_plan_allocations;
                if (allocations && allocations[0] && allocations[0].price != null) {
                  return getPrice(allocations[0].price * c.quantity, cart).replace('.', ',');
                }
                var pct = productObject?.metafields?.discount_percentage;
                var n = parseFloat(String(pct || '').replace(',', '.'));
                if (!isNaN(n) && n > 0) {
                  if (n < 1) n = n * 100;
                  var discounted = Math.round(c.price * c.quantity * (1 - n / 100));
                  return getPrice(discounted, cart).replace('.', ',');
                }
                return getPrice(c.price * c.quantity, cart).replace('.', ',');
              })()
          };
    
          /*if (c.id == 14539662917674 && !hasSubscription) {
              CartJS.removeItemById(c.id, {
                  // Define a success callback to display a success message.
                  "success": function(data, textStatus, jqXHR) {
                      console.log('ok');
                      var $carousel = $(settings.upsellFlickity);
                      if ($carousel.length > 0) {
                          if (localStorage.getItem('sideCartUpsell_14539662917674')) {
                              var item = $(localStorage.getItem('sideCartUpsell_14539662917674')).unwrap();
                              // console.log(item);
                              $carousel.flickity('append', item);
                              localStorage.removeItem('sideCartUpsell_14539662917674');
                          }
                          // bind event listener first
                          var dataflickity = $(settings.upsellFlickity).attr(settings.upsellFlickityData);
                          $carousel.on('ready.flickity', function() {
                              $(settings.upsellFlickity).flickity(dataflickity)
                          });
                          // initialize Flickity
                          $carousel.flickity();
                      }
                  },
                  // Define an error callback to display an error message.
                  "error": function(jqXHR, textStatus, errorThrown) {
                      console.log('error');
                  }
              });
              continue;
          }*/
          /*if (c.id == 14539662917674 && hasSubscription && c.properties['_giveaway']) {
              context.item_price = "Offert";
              setTimeout(function() {
                  $('[data-cart-count]').html(parseInt($('.header__menu-item-icon [data-cart-count]')[0].textContent) - 1)
              }, 1000);
              continue;
          }*/
          if (c.selling_plan_allocation) {
              context.item_initial_price = ((c.selling_plan_allocation.compare_at_price * c.quantity) / 100).toFixed(2).toString().replace('.', ',') + '€';
              context.item_discount_variant_price = getPrice(c.selling_plan_allocation.price * c.quantity, cart).replace('.', ',');
              if (!context.item_discount_percentage) {
                context.item_discount_percentage = '10';
              }
          }
          if (!c.product_has_only_default_variant) {
            context.item_variant_title = variantObject?.variant?.title || '';
          }
          // console.log('Context ', context);
    
    
          if (status == 'SUBSCRIBE-ON') {
              //console.log('Context ', context);
              source = $(settings.cartItemSubscribeOnSelector).html();
          } else if (status == 'SUBSCRIBE-OFF') {
              source = $(settings.cartItemSubscribeOffSelector).html();
          } else if (status == 'ECHANTILLON') {
              source = $(settings.cartItemEchantillonSelector).html();
          } else if (status == 'NO-SUBSCRIBE') {
              source = $(settings.cartItemNoSubscribeSelector).html();
          }
          Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
              return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
          });
          template = Handlebars.compile(source);
          html = template(context);
          final_html += html;
      }
      $(settings.cartTotalPriceSelector).html(getPrice(cart.total_price, cart));
      if (cart.items.length > 0) {
          getCartItemsContainer().html(final_html);
          getCartItemsContainer().find('[data-cart-item]').each(function(){
              var $item = $(this);
              var priceSpan = $item.find('.cart-item__price > span').last();
              var priceText = priceSpan.length ? priceSpan.text().trim() : '';
              var isOffert = priceText === 'Offert' || /offert/i.test(priceText);
              var isLockedGift = $item.attr('data-item-status') === 'NO-SUBSCRIBE' &&
                $item.find('.cart-item__quantity-container.hide').length > 0;
              if (isOffert || isLockedGift || $item.attr('data-gwp-gift') === 'true') {
                  $item.find('.cart-item__oneshot-title-quantity, .cart-item__quantity-container, .cart-item__delete').css('display', 'none');
              }
          });
          $('.cart-progress').removeClass('hide');
          $('.cart__payment-button--delivery').removeClass('hide');
          $('.cart__discount-message').removeClass('hide');
          $('.cart__items').removeClass('full-height');
          $('.cart-announcement').addClass('hide');
          $('.cart__payment-button').show();
          $('.cart__continue-shopping').hide();
      } else {
          getCartItemsContainer().html(settings.emptyCartText);
          $('.cart-progress').addClass('hide');
          $('.cart__payment-button--delivery').addClass('hide');
          $('.cart__discount-message').addClass('hide');
          $('.cart__items').addClass('full-height');
          $('.cart-announcement').removeClass('hide');
          $('.cart__payment-button').hide();
          $('.cart__continue-shopping').show();
      }
      if (open) openCart();
      initHandlers(cart);
      updateCartVariables(cart);
      updateUpsellPrices(cart);
      $('[data-cart-items]').focus();
      if (typeof window.syncDiscountBarFromCart === 'function') {
        window.syncDiscountBarFromCart(cart);
      } else if (typeof validateDiscountMessages === 'function') {
        validateDiscountMessages(cart);
      }
      if (typeof window.SubscriptionBooster !== 'undefined' && typeof window.SubscriptionBooster.update === 'function') {
        window.SubscriptionBooster.update(cart);
      }
    }
    function calculateCartHeight(){
        var cartItemsHeight = $(window).innerHeight();
        cartItemsHeight = $('.cart__payment-container').offset().top - $('[data-cart-items]').offset().top;
        document.documentElement.style.setProperty('--cart-items-height', cartItemsHeight + 'px');
    }
    function getCartPrice(cart){
        if(integrate_checkout){
            var total_price = 0;
            for(var i = 0; i < cart.items.length; i++){
                var item = cart.items[i];
                if(item.properties && item.properties.recharge_variant_id){
                    var productObject = null;
                    if (typeof all_products !== 'undefined') {
                      for(var j = 0; j < all_products.length; j++){
                          var product = all_products[j];
                          if(product.product.id == item.product_id){
                              productObject = product;
                          }
                      }
                    }
                    if (productObject && productObject.variants) {
                      for(var k = 0; k < productObject.variants.length; k++){
                          if(productObject.variants[k].variant.id == item.id){
                              var allocation = productObject.variants[k].variant.selling_plan_allocations;
                              if (allocation && allocation[0] && allocation[0].price) {
                                total_price += (allocation[0].price * item.quantity);
                              } else {
                                total_price += item.final_line_price;
                              }
                          }
                      }
                    } else {
                      total_price += item.final_line_price;
                    }

                }else{
                    total_price += item.final_line_price;
                }
            }
            return total_price;
        }
        else return cart.total_price;
    }
    function updateCartVariables(cart){
        var price = getCartPrice(cart)
        var price_with_giftcard = getCartPrice(cart)
        
        var cartCount = 0;
        var isOnlyEchantillon = true;

        const targetGiftCardIds = [
          9389312672073,
          9418861576521,
          9418862690633,
          9418863083849,
          9418866622793
        ];
        
        const targetProductTotal = cart.items
          .filter(item => targetGiftCardIds.includes(item.product_id))
          .reduce((sum, item) => sum + item.line_price, 0); // Additionne les prix des lignes (quantité * prix unitaire)

        // Met à jour le prix en déduisant le total des gift cards
        price -= targetProductTotal;

        for(var i = 0; i < cart.items.length; i++){
            cartCount += cart.items[i].quantity;
        }

        //upsell
        var $carousel = $(settings.upsellFlickity);

        if ($carousel.length > 0 ) {

            var $upsellBlocks = $('.cart_upsell-block');
            var $blockChien = $upsellBlocks.filter('.cart_upsell-chien__only');
            var $blockChat = $upsellBlocks.filter('.cart_upsell-chat__only');
            var $blockMix = $upsellBlocks.filter('.cart_upsell-mix__only');

            function getUpsellContainer($thisCarousel) {
                var $block = $thisCarousel.closest('.cart_upsell-block');
                return $block.length ? $block : $thisCarousel.closest('.cart_upsell-slider');
            }

            function getUpsellFlickityOptions($thisCarousel) {
                if ($thisCarousel.closest('.cart_upsell-achat-abonnement__only').length > 0) {
                    return {
                        wrapAround: true,
                        draggable: true,
                        prevNextButtons: false,
                        pageDots: false,
                        cellAlign: 'left',
                        contain: true
                    };
                }

                return {
                    wrapAround: true,
                    draggable: true,
                    prevNextButtons: true,
                    pageDots: true,
                    cellAlign: 'center',
                    contain: true
                };
            }

            var $cartItems = document.querySelectorAll('[data-cart-item]');

            var hasChien = false;
            var hasChat = false;

            if (cart.item_count != 0) {
              $cartItems.forEach(item => {
                if (item.getAttribute('data-tags').includes('chien')) {
                  hasChien = true;
                }
                if (item.getAttribute('data-tags').includes('chat')) {
                  hasChat = true;
                }
              });
  
              if (hasChien && !hasChat) {
                // Hide chat products, show chien products
                $('.product-offer__drawer--products [data-product-category="chat"]').addClass('hide');
                $('.product-offer__drawer--products [data-product-category="chien"]').removeClass('hide');
                $blockChien.removeClass('hide');
                $blockChat.addClass('hide');
                $blockMix.addClass('hide');
                
                // Add disable class to products and buttons in cart
                $('.product-offer__drawer--products .product-card-offer').each(function() {
                  var productId = $(this).data('product-id');
                  var inCart = cart.items.some(item => item.product_id == productId);
                  $(this).toggleClass('disable', inCart);
                  $(this).find('.product-card-offer__button').prop('disabled', inCart);
                  $('[data-cart-loader]').css('display', 'none');
                });
                
              } else if (hasChat && !hasChien) {
                  // Hide chien products, show chat products
                  $('.product-offer__drawer--products [data-product-category="chien"]').addClass('hide');
                  $('.product-offer__drawer--products [data-product-category="chat"]').removeClass('hide');
                  $blockChat.removeClass('hide');
                  $blockChien.addClass('hide');
                  $blockMix.addClass('hide');
                  
                  // Add disable class to products and buttons in cart
                  $('.product-offer__drawer--products .product-card-offer').each(function() {
                      var productId = $(this).data('product-id');
                      var inCart = cart.items.some(item => item.product_id == productId);
                      $(this).toggleClass('disable', inCart);
                      $(this).find('.product-card-offer__button').prop('disabled', inCart);
                      $('[data-cart-loader]').css('display', 'none');
                  });
                  
              } else if (hasChien && hasChat) {
                  // Show all products
                  $('.product-offer__drawer--products [data-product-category="chat"]').removeClass('hide');
                  $('.product-offer__drawer--products [data-product-category="chien"]').removeClass('hide');
                  $blockMix.removeClass('hide');
                  $blockChien.addClass('hide');
                  $blockChat.addClass('hide');
                  
                  // Add disable class to products and buttons in cart
                  $('.product-offer__drawer--products .product-card-offer').each(function() {
                      var productId = $(this).data('product-id');
                      var inCart = cart.items.some(item => item.product_id == productId);
                      $(this).toggleClass('disable', inCart);
                      $(this).find('.product-card-offer__button').prop('disabled', inCart);
                      $('[data-cart-loader]').css('display', 'none');
                  });
              }
              
              // After conditions, check class status
  
              // First destroy any existing Flickity instances
              $carousel.each(function() {
                  var flkty = $(this).data('flickity');
                  if (flkty) {
                      flkty.destroy();
                  }
              });

              // Remove any upsell products that are already in the cart
              cart.items.forEach(function(cartItem) {
                  var variant_id = cartItem.variant_id;
                  
                  // Handle special variant ID cases
                  if (variant_id == 39371671568426) {
                      // variant_id = 39342566211626;
                  } else if (variant_id == 39371675729962) {
                      // variant_id = 39342573518890;
                  }

                  // Remove the slide element completely from DOM
                  $('[data-upsell-id="'+ variant_id +'"]').remove();
              });

              // Check if there are any slides left
              setTimeout(function() {
                  $carousel.each(function() {
                      var $thisCarousel = $(this);
                      var $upsellContainer = getUpsellContainer($thisCarousel);
                      if ($thisCarousel.find('[data-upsell-id]').length === 0) {
                          $upsellContainer.hide();
                      } else {
                          $upsellContainer.show();
                          $thisCarousel.flickity(getUpsellFlickityOptions($thisCarousel));
                      }
                  });
              }, 250);

            } else {
              $blockMix.addClass('hide');
              $blockChien.addClass('hide');
              $blockChat.addClass('hide');
            }

            $(settings.upsellId).each(function() {

                var founded = false;
                var $currentEl = $(this);
                var variant_id = $currentEl.attr(settings.upsellIdData);

                for(var i = 0; i < cart.items.length; i++){
                    var item = cart.items[i];
                    //console.log('Item.id ', item.id, ' upsell_id ', variant_id);
                    if(item.id == variant_id){
                        founded = true;
                    }

                    if(item.id == 39371675729962 && variant_id == 39342573518890){
                        founded = true;
                    }

                    if(item.id == 39371671568426 && variant_id == 39342566211626){
                        founded = true;
                    }

                }



                //Set item in localstorage if already in cart
                if (founded) {

                    if (variant_id == 39371671568426) {
                        // variant_id = 39342566211626;
                    } else if (variant_id == 39371675729962) {
                        // variant_id = 39342573518890;
                    }

                    if (!localStorage.getItem('sideCartUpsell_' + variant_id)) {
                        var element = $('[data-upsell-id="'+ variant_id +'"]');
                        localStorage.setItem('sideCartUpsell_' + variant_id, element.wrap('<div id="sideCartUpsell_'+variant_id+'"></div>').parent().html());
                    }
                    // console.log(variant_id);
                    $(settings.upsellFlickity).flickity( 'remove', $('[data-upsell-id="'+ variant_id +'"]'));
                    $('#sideCartUpsell_'+variant_id).remove();
                } else {
                    if (localStorage.getItem('sideCartUpsell_' + variant_id)) {
                        var item = $(localStorage.getItem('sideCartUpsell_' + variant_id)).unwrap();
                        // console.log(item);
                        $carousel.flickity( 'append', item );
                        localStorage.removeItem('sideCartUpsell_' + variant_id);
                    }
                }
              });

            $carousel.each(function() {
              var $thisCarousel = $(this);
              $thisCarousel.flickity(getUpsellFlickityOptions($thisCarousel));
            });

        }

        // Show section gobelet
        if ($(settings.gobeletContainerSelector).length > 0 ) {
            var gobelet_id = $(settings.gobeletContainerSelector).attr(settings.gobeletIdAttr);
            var minGobelet = parseFloat($(settings.gobeletContainerSelector).attr(settings.gobeletMinAttr).toString().replace(',','.')) * 100;
        }

        if (minGobelet && gobelet_id) {
            if ($(settings.brocheContainerSelector).length > 0) {
                var broche_id = $(settings.brocheContainerSelector).attr(settings.brocheIdAttr);
                var minBroche = parseFloat($(settings.brocheContainerSelector).attr(settings.brocheMinAttr).toString().replace(',','.')) * 100;
              }
              for(var i = 0; i < cart.items.length; i++){
                  // console.log('Item ', cart.items[i]);
                  if(cart.items[i].sku.indexOf('SAMP') == -1) isOnlyEchantillon = false;
                  if(cart.items[i].id == gobelet_id){
                      $(settings.gobeletSwitchSelector).prop('checked',true);
                  }else if(cart.items[i].id == broche_id){
                      $(settings.brocheSwitchSelector).prop('checked',true);
                  }else{
                      cartCount += cart.items[i].quantity;
                  }
              }
              if(minGobelet > price){
                  $(settings.gobeletContainerSelector).hide();
                  removeGobelet(cart);
              }else{
                  $(settings.gobeletContainerSelector).show();
              }
              if(minBroche > price){
                  $(settings.brocheContainerSelector).hide();
                  removeBroche(cart);
              }else{
                  $(settings.brocheContainerSelector).show();
              }
        }

        // Change cart count
        if(cartCount > 0){
            $(settings.cartCountSelector).show();
            $(settings.cartCountSelector).parent().show();
        }else{
            $(settings.cartCountSelector).hide();
            $(settings.cartCountSelector).parent().hide();
        }
        $(settings.cartCountSelector).html(cartCount);

        // Change button price
        // Consider discount present only if any item has an actual allocation or reduced final price
        var hasAnyDiscount = cart.items && cart.items.some(function(item){
          var originalLinePrice = (typeof item.original_line_price !== 'undefined' && item.original_line_price != null)
            ? item.original_line_price
            : (typeof item.line_price !== 'undefined' ? item.line_price : (item.price * item.quantity));
          var hasAlloc = (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) ||
            (item.discount_allocations && item.discount_allocations.length > 0);
          var hasFinal = typeof item.final_line_price !== 'undefined' && item.final_line_price != null;
          return hasAlloc || (hasFinal && item.final_line_price < originalLinePrice);
        });

        var original_total = cart.items.reduce((sum, item) => {
            if (item.selling_plan_allocation) {
                return sum + (item.final_line_price / 0.80);
            }
            return sum + item.final_line_price;
        }, 0);

        var price_with_giftcard = cart.total_price;
        var cart_total_price = (price_with_giftcard / 100).toFixed(2);

        var hasSubscription = cart.items.some(item => item.selling_plan_allocation);
        var hasOfferProduct = cart.items.some(item => {
          // Find matching product card in drawer
          var productCard = $(`.product-offer__drawer--products .product-card-offer[data-product-id="${item.product_id}"]`);
          // Check if this product is both in drawer (with fake price) AND in cart
          return productCard.length > 0 && 
                 productCard.attr('data-fake-price') && 
                 cart.items.some(cartItem => cartItem.product_id === item.product_id);
        });

        // Calculate original total including fake prices
        var original_total = cart.items.reduce((sum, item) => {
          if (item.selling_plan_allocation) {
            // For subscription items, use compare_at_price from the allocation
            return sum + (item.selling_plan_allocation.compare_at_price * item.quantity);
          }

          if (item.discounted_price < item.original_price) {
            // let regularDiscount = (item.original_price - item.discounted_price) * item.quantity;
            return sum + (item.original_price * item.quantity);
          }
          
          // For offer products, add their fake price
          var productCard = $(`.product-offer__drawer--products .product-card-offer[data-product-id="${item.product_id}"]`);
          if (productCard.length > 0 && productCard.attr('data-fake-price')) {
              // Convert fake price from string (ex: "14,90") to cents
              var fakePrice = parseFloat(productCard.attr('data-fake-price').replace(',','.')) * 100;
              return sum + (fakePrice * item.quantity);
          }
          
          // For regular items, use original line price
          return sum + item.final_line_price;
        }, 0);

        var cart_total_price = (cart.total_price / 100).toFixed(2);

        // Show original price if we have subscriptions, offer products, any discount, or compare nodes exist in DOM
        // Prefer summing DOM prices per cart item: if compare exists use it, else use visible price ("Offert" => 0)
        var domMixedSumCents = 0;
        var priceNodesCount = 0;
        try {
          var priceNodes = document.querySelectorAll('.cart__items .cart-item__price');
          priceNodesCount = priceNodes ? priceNodes.length : 0;
          if (priceNodes && priceNodes.length > 0) {
            priceNodes.forEach(function(container){
              // Prefer compare price if present
              var node = container.querySelector('.cart-item__highlight-oneshot-price.cart-item__price--compare');
              var text = '';
              if (node) {
                text = (node.textContent || '').trim();
              } else {
                // Fallback to the first span (visible price) inside the price container
                var firstSpan = container.querySelector('span');
                text = (firstSpan && firstSpan.textContent) ? firstSpan.textContent.trim() : '';
              }
              var norm = text.toLowerCase();
              if (!text || norm.indexOf('offert') > -1) {
                // Offert or empty => 0
                return;
              }
              // Normalize number: remove currency/symbols/spaces; support both 12,34 and 12.34
              var num = text.replace(/[^0-9,\.]/g, '');
              if (num.indexOf(',') > -1 && num.indexOf('.') > -1) {
                num = num.replace(/\./g, '').replace(',', '.');
              } else if (num.indexOf(',') > -1) {
                num = num.replace(',', '.');
              }
              var euros = parseFloat(num);
              if (!isNaN(euros)) {
                var cents = Math.round(euros * 100);
                domMixedSumCents += cents;
              }
            });
          }
        } catch (e) { /* ignore parse errors and fallback */ }

        var shouldShowOriginal = (hasSubscription || hasOfferProduct || hasAnyDiscount || priceNodesCount > 0);
        if (shouldShowOriginal) {
          var useDomSum = priceNodesCount > 0;
          var centsSource = useDomSum ? domMixedSumCents : original_total;
          var original_price = ((centsSource > 0 ? centsSource : original_total) / 100).toFixed(2);
          var __cartTotalStr = cart_total_price.toString();
          var __originalStr = original_price.toString();
          var __cartTotalNum = parseFloat(__cartTotalStr);
          var __originalNum = parseFloat(__originalStr);
          if (!isNaN(__cartTotalNum) && !isNaN(__originalNum) && __cartTotalNum === __originalNum) {
            $(settings.orderPriceSelector).html(__cartTotalStr.replace('.',',') + '€');
          } else {
            $(settings.orderPriceSelector).html(
                `${__cartTotalStr.replace('.',',')}€ ` +
                `<span class=\"cart__payment-price--original\">${__originalStr.replace('.',',')}€</span>`
            );
          }
          // Observe changes inside .cart__items to recompute original price from DOM compare nodes
          try {
            var orderPriceEl = document.querySelector(settings.orderPriceSelector);
            if (orderPriceEl) {
              orderPriceEl.setAttribute('data-cart-total-price-eur', cart_total_price.toString().replace('.',','));
            }
            if (!window.__cartOriginalObserver) {
              var cartItemsEl = document.querySelector('.cart__items');
              if (cartItemsEl) {
                var recomputeOriginalFromDom = function() {
                  try {
                    var sum = 0;
                    var containers = document.querySelectorAll('.cart__items .cart-item__price');
                    if (containers && containers.length) {
                      containers.forEach(function(container){
                        var node = container.querySelector('.cart-item__highlight-oneshot-price.cart-item__price--compare');
                        var text = '';
                        if (node) text = (node.textContent || '').trim();
                        else {
                          var firstSpan = container.querySelector('span');
                          text = (firstSpan && firstSpan.textContent) ? firstSpan.textContent.trim() : '';
                        }
                        var norm = text.toLowerCase();
                        if (!text || norm.indexOf('offert') > -1) return;
                        var num = text.replace(/[^0-9,\.]/g, '');
                        if (num.indexOf(',') > -1 && num.indexOf('.') > -1) num = num.replace(/\./g, '').replace(',', '.');
                        else if (num.indexOf(',') > -1) num = num.replace(',', '.');
                        var eur = parseFloat(num);
                        if (!isNaN(eur)) sum += Math.round(eur * 100);
                      });
                    }
                    var totalEl = document.querySelector(settings.orderPriceSelector);
                    var totalStr = totalEl && totalEl.getAttribute('data-cart-total-price-eur');
                    if (totalEl && totalStr && sum > 0) {
                      var originalNumStr = (sum / 100).toFixed(2);
                      var totalNum = parseFloat(totalStr.replace(',', '.'));
                      var originalNum = parseFloat(originalNumStr);
                      if (!isNaN(totalNum) && !isNaN(originalNum) && totalNum === originalNum) {
                        totalEl.innerHTML = `${totalStr}€`;
                      } else {
                        var originalStr = originalNumStr.toString().replace('.', ',');
                        totalEl.innerHTML = `${totalStr}€ <span class=\"cart__payment-price--original\">${originalStr}€</span>`;
                      }
                    }
                  } catch(e) {}
                };
                window.__cartOriginalObserver = new MutationObserver(function(){
                  if (window.__cartOriginalObserverTimer) clearTimeout(window.__cartOriginalObserverTimer);
                  window.__cartOriginalObserverTimer = setTimeout(recomputeOriginalFromDom, 60);
                });
                window.__cartOriginalObserver.observe(cartItemsEl, { childList: true, subtree: true, characterData: true });
                // Run once initially to catch late inserts
                setTimeout(recomputeOriginalFromDom, 0);
              }
            }
          } catch(e) {}
        } else {
          $(settings.orderPriceSelector).html(cart_total_price.toString().replace('.',',') + '€');
        }

        // Change progress bar
        var price_for_progress = cart.items.reduce((sum, item) => {
          if (item.selling_plan_allocation) {
              // Always use original price for subscription items
              return sum + (item.original_line_price);
          }
          // For regular items, use original price too
          return sum + item.original_line_price;
        }, 0);

        let vd_hasChat = false;
            let vd_hasChien = false;
            cart.items.forEach(item => {
               if (item.sku.includes('CAT') || item.vendor.includes("chat") || item.vendor.includes("chaton")) {
                vd_hasChat = true;
              }
              if (item.sku.includes('DOG') || item.vendor.includes("chien") || item.vendor.includes("chiot")) {
                vd_hasChien = true;
              }
            });
            
        
        $(settings.progressPriceSelector).each(function() {
          // Raw goal is already in cents (4900 = 49€)
          if (vd_hasChat && !vd_hasChien) {
            var progressGoal = parseInt($(this).attr(settings.progressGoalAttrChat));
          }
          else {
            var progressGoal = parseInt($(this).attr(settings.progressGoalAttr));
          }
          
          // Cart price is in cents (3991 = 39.91€)
          var price_for_progress = cart.total_price;
          
          // Calculate difference in cents (4900 - 3991 = 909 cents = 9.09€)
          var diffInCents = progressGoal - price_for_progress;
          
          // Convert to euros and format
          var difference = (diffInCents / 100).toFixed(2).toString().replace('.', ',');
          
          $(this).html(difference);
        });
      // Keep the rest of the progress bar code as is
      price_for_progress = price_for_progress / 100;
      var targetWidth = price_for_progress * 100;

        //if only echantillon active step free delivery
        if (targetWidth == 1
          || targetWidth == 2
          || targetWidth == 4
          || targetWidth == 6) {
          targetWidth = 8;
        }

        var steps = [];
        if ($(settings.goalStepSelector).length > 0) {
          $(settings.goalStepSelector).each(function(){
            var stepsContainer = $(settings.progressBarContainerSelector);
            var stepsContainerWidth = stepsContainer.width();
            var stepsContainerPosition = stepsContainer.offset().left;
            var widthPosition = Math.ceil((($(this).offset().left - stepsContainerPosition) * 100) / stepsContainerWidth);
            if (vd_hasChat && !vd_hasChien) {
            steps.push(
              {
                'goal': parseInt($(this).attr('data-goal-step-chat')) * 100,
                'positionInPercentage': widthPosition
              }
            );
          } else {
            steps.push(
              {
                'goal': parseInt($(this).attr('data-goal-step')) * 100,
                'positionInPercentage': widthPosition
              }
            );
          }
          });

          if (steps.length === 4) {
            let activeIndex = 0;
        
            let finalPrice = cart.total_price / 100;
            let finalWidth = finalPrice * 100;

            if (finalWidth == 1
              || finalWidth == 2
              || finalWidth == 4
              || finalWidth == 6) {
              finalWidth = 8;
            }

            if (finalWidth >= steps[3].goal) {
                activeIndex = 4;  // Over 89€ -> Step 4
            } else if (finalWidth >= steps[2].goal) {
                activeIndex = 3;  // Over 69€ -> Step 3
            } else if (finalWidth >= steps[1].goal) {
                activeIndex = 2;  // Over 49€ -> Step 2
            } else if (finalWidth >= steps[0].goal) {
                activeIndex = 1;  // Over 0€ -> Step 1
            }
            
            //@VD -- START
            //
            //
            
            let pickup, gift1, delivery, gift2;
            if (vd_hasChat && !vd_hasChien) {
              pickup = parseInt($("[data-progress-name='pickup']").attr('data-progress-goal-chat')) / 100;
              gift1 = parseInt($("[data-progress-name='gift1']").attr('data-progress-goal-chat')) / 100;
              delivery = parseInt($("[data-progress-name='delivery']").attr('data-progress-goal-chat')) / 100;
              gift2 = parseInt($("[data-progress-name='gift2']").attr('data-progress-goal-chat')) / 100;
            } else {
              pickup = parseInt($("[data-progress-name='pickup']").attr('data-progress-goal')) / 100;
              gift1 = parseInt($("[data-progress-name='gift1']").attr('data-progress-goal')) / 100;
              delivery = parseInt($("[data-progress-name='delivery']").attr('data-progress-goal')) / 100;
              gift2 = parseInt($("[data-progress-name='gift2']").attr('data-progress-goal')) / 100;
            }

            let vd_cartTotal = finalPrice;
            let vd_activeIndex = 0;
            let vd_maxCart = 0;
            let vd_progressPoints = [
              { name: 'start', id: 0, cart: 0, beforeIndex: 0},
              { name: 'pickup', id: 1, cart: pickup, beforeIndex: 0},
              { name: 'gift1', id: 2, cart: gift1, beforeIndex: 1},
              { name: 'delivery', id: 3, cart: delivery, beforeIndex: 2},
              { name: 'gift2', id: 4, cart: gift2, beforeIndex: 3}
            ];
            vd_progressPoints.sort((a, b) => a.cart - b.cart);
            
            vd_progressPoints.forEach((point, index) => {
                if (vd_cartTotal >= point.cart) {
                    vd_activeIndex = vd_progressPoints[index+1] && vd_progressPoints[index+1].cart != 999 ? vd_progressPoints[index+1].beforeIndex : 4; // 
                }
                if (point.cart > vd_maxCart && point.cart != 999) {
                    vd_maxCart = point.cart;
                }
            });

            // Set bottom text id
            let vd_bottomTextId;
            if (vd_activeIndex == 4) {
              vd_bottomTextId = 9;
            }
            else if (vd_cartTotal >= delivery) {
              vd_bottomTextId = 3;
            }
            else if (vd_cartTotal >= pickup) {
              vd_bottomTextId = 2;
            }
            else {
              vd_bottomTextId = 1;
            }

             // Toggle progress reach class
             $(settings.progressContainerSelector).toggleClass(settings.progressReachClass, vd_activeIndex > 0);

            // Remove 'active' from all progress steps and set the active one
            for (let i = 1; i <= 4; i++) {
                $(settings[`progressStep${i}Text`]).toggleClass('active vd', i === vd_activeIndex);
            }

            // Remove 'active' from all progress bar texts and set the active one
            for (let i = 0; i <= 4; i++) {
                $(`.cart-progress__bar--bottom_text--${i}`).toggleClass('active', i === vd_bottomTextId);
            }
        
            //frame(activeIndex === 4 ? 98 : Math.min(finalWidth / 100, 98));
            let vd_progressPercent = (vd_cartTotal / vd_maxCart) * 100;
            if (vd_progressPercent > 98) vd_progressPercent = 98;
            frame(vd_progressPercent);

            //
            //
            // @VD -- END
          
        
            // Count gift products in cart that match products in drawer
            const giftProductsInCart = cart.items.filter(item => 
                $('.product-offer__drawer--products .product-card-offer').toArray()
                .some(product => $(product).data('product-id') === item.product_id)
            ).length;
        
            // Check if cart has chien or chat products
            const hasChien = cart.items.some(item => 
                (item.product_type && item.product_type.toLowerCase().includes('chien')) || 
                (item.tags && Array.isArray(item.tags) && item.tags.some(tag => tag.toLowerCase().includes('chien'))) ||
                (item.vendor && item.vendor.toLowerCase().includes('chien')) ||
                (item.vendor && item.vendor.toLowerCase().includes('chiot'))
            );
            const hasChat = cart.items.some(item => 
                (item.product_type && item.product_type.toLowerCase().includes('chat')) || 
                (item.tags && Array.isArray(item.tags) && item.tags.some(tag => tag.toLowerCase().includes('chat'))) ||
                (item.vendor && item.vendor.toLowerCase().includes('chat')) ||
                (item.vendor && item.vendor.toLowerCase().includes('chatton'))
                
            );
        
            // Check conditions for showing offers
            const showInStep2 = activeIndex === 2 && giftProductsInCart === 0;
            const showInStep3 = activeIndex === 3 && giftProductsInCart === 0;
            const showInStep4 = activeIndex === 4 && giftProductsInCart < 2;

            let step2Product, step4Product;
            if (hasChien) {
              step2Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chien"][data-step="2"]').first().attr('data-variant-id');
              step4Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chien"][data-step="4"]').first().attr('data-variant-id');
            } else if (hasChat) {
              step2Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chat"][data-step="2"]').first().attr('data-variant-id');
              step4Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chat"][data-step="4"]').first().attr('data-variant-id');
            }

            if (vd_cartTotal > gift1 && giftProductsInCart === 0) {
              CartJS.addItem(step2Product, 1, {
                "__free_gift": "tier_1"
              });
            }

            if (vd_cartTotal > gift2 && giftProductsInCart === 1) {
              CartJS.addItem(step4Product, 1, {
                "__free_gift": "tier_2"
              });
            }
        
        
            // Toggle visibility based on all conditions
            //$('.product-offer').toggleClass('hide', !(showInStep2 || showInStep3 || showInStep4));
            $('.product-offer').addClass('hide');
            
            // First, disable products that are in cart (in all steps)
            $('[data-product-category]').each(function() {
                var inCart = cart.items.some(item => item.product_id == $(this).data('product-id'));
                $(this).toggleClass('disable', inCart);
                $(this).find('.product-card-offer__button').prop('disabled', inCart);
                $('[data-cart-loader]').css('display', 'none');
            });
        
            // Handle product visibility based on steps
            if (activeIndex === 2 || activeIndex === 3) {
              // First hide all products
              $('.product-offer__title').html('<span>🎁</span> Sélectionnez votre 1<sup>er</sup> produit offert');
              $('.product-offer__item').addClass('hide');
              
              // Then show the appropriate first product
              if (hasChien) {
                  $('.product-offer__item:nth-child(3)').removeClass('hide');
              } else if (hasChat) {
                  $('.product-offer__item:nth-child(2)').removeClass('hide');
              } else {
                  // If no pets in cart, default to showing first chien product
                  $('.product-offer__item:nth-child(3)').removeClass('hide');
              }
                
            } else if (activeIndex === 4) {
                if (giftProductsInCart === 0) {
                    $('.product-offer__title').html('<span>🎁</span> Sélectionnez vos 2 produits offerts');
                    // If no gifts in cart, show both products of relevant type
                    if (hasChien) {
                        $('[data-offer-animal="chat"]').addClass('hide');
                        $('[data-offer-animal="chien"]').removeClass('hide');
                    } else if (hasChat) {
                        $('[data-offer-animal="chien"]').addClass('hide');
                        $('[data-offer-animal="chat"]').removeClass('hide');
                    } else {
                        // If no pets in cart, default to showing both chien products
                        $('[data-offer-animal="chat"]').addClass('hide');
                        $('[data-offer-animal="chien"]').removeClass('hide');
                    }
                } else if (giftProductsInCart === 1) {
                  $('.product-offer__title').html('<span>🎁</span> Sélectionnez votre 2<sup>ème</sup> produit offert');
                  // First hide all products
                  $('.product-offer__item').addClass('hide');
                  
                  // Show only second product of relevant type
                  if (hasChien) {
                      const $lastChien = $('.product-offer__item[data-offer-animal="chien"]').last();
                      const lastChienId = $lastChien.data('offer-product');
                      const isLastChienInCart = cart.items.some(item => item.product_id == lastChienId);
                      
                      if (isLastChienInCart) {
                          $('.product-offer__item[data-offer-animal="chien"]').first().removeClass('hide');
                      } else {
                          $lastChien.removeClass('hide');
                      }
                  } else if (hasChat) {
                      const $lastChat = $('.product-offer__item[data-offer-animal="chat"]').last();
                      const lastChatId = $lastChat.data('offer-product');
                      const isLastChatInCart = cart.items.some(item => item.product_id == lastChatId);
                      
                      if (isLastChatInCart) {
                          $('.product-offer__item[data-offer-animal="chat"]').first().removeClass('hide');
                      } else {
                          $lastChat.removeClass('hide');
                      }
                  }
                }
            }
        
            // Then, handle step-specific disabling for second products
            if (activeIndex === 2 || activeIndex === 3) {
                $('[data-product-category="chat"]').each(function(i) {
                    if (i > 1) {
                        $(this).addClass('disable');
                        $(this).find('.product-card-offer__button').prop('disabled', true);
                        $('[data-cart-loader]').css('display', 'none');
                    }
                });
                $('[data-product-category="chien"]').each(function(i) {
                    if (i > 1) {
                        $(this).addClass('disable');
                        $(this).find('.product-card-offer__button').prop('disabled', true);
                        $('[data-cart-loader]').css('display', 'none');
                    }
                });
            } else if (activeIndex === 4 && giftProductsInCart === 1) {
              // Check if the product in cart is from step 2 or step 4
              const hasStep2ProductInCart = cart.items.some(item => 
                $('.product-offer__drawer--products .product-card-offer[data-step="2"]').toArray()
                .some(product => $(product).data('product-id') === item.product_id)
              );

              const hasStep4ProductInCart = cart.items.some(item => 
                $('.product-offer__drawer--products .product-card-offer[data-step="4"]').toArray()
                .some(product => $(product).data('product-id') === item.product_id)
              );

              if (hasStep2ProductInCart) {
                $('[data-step="2"]').addClass('hide');
              } else if (hasStep4ProductInCart) {
                $('[data-step="4"]').addClass('hide');
              }
            }
        
            

            const $cartItems = $('.cart__items');
            const $visibleOfferItems = $('.product-offer__item:not(.hide)');
            const visibleCount = $visibleOfferItems.length;

            // Remove any existing classes first
            $cartItems.removeClass('has-no-offer-item has-one-offer-item has-two-offer-item');

            // Add appropriate class based on count
            if ($('.product-offer').hasClass('hide')) {
              $cartItems.addClass('has-no-offer-item');
            } else if (!$('.product-offer').hasClass('hide') && visibleCount === 1) {
              $cartItems.addClass('has-one-offer-item');
            } else if (!$('.product-offer').hasClass('hide') && visibleCount === 2) {
              $cartItems.addClass('has-two-offer-item');
            }
          }
        }

    }

    function frame(widthCss) {
      var widthCss = (widthCss) + '%';
      $(settings.progressBarSelector).css('width', widthCss);
    }

    const drawerOpenerSidecard = document.querySelectorAll('.product-offer__button');
    const drawerCloserSidecard = document.querySelector('.product-offer__drawer--close');
    const drawerSidecard = document.querySelector('.product-offer__drawer');
    if (drawerOpenerSidecard) {
      drawerOpenerSidecard.forEach(function(button) {
        button.addEventListener('click', function() {
          drawerSidecard.classList.add('open');
        })
      })
      drawerCloserSidecard.addEventListener('click', function() {
        drawerSidecard.classList.remove('open');
      })
    }
    // Add the observer code right after this line:
    const sideCartObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const sideCart = mutation.target;
          if (!sideCart.classList.contains('open')) {
            const productOfferDrawer = document.querySelector('.product-offer__drawer');
            if (productOfferDrawer && productOfferDrawer.classList.contains('open')) {
              productOfferDrawer.classList.remove('open');
            }
          }
        }
      });
    });

    // Start observing the side-cart element
    const sideCart = document.querySelector('[data-side-cart]');
    if (sideCart) {
      sideCartObserver.observe(sideCart, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    async function openCart() {

        if ($('body').hasClass('template-cart')) return;

        var cart = await (await fetch(`/cart.json`)).json();
        var cartHasSubscription = false;
        var items = cart.items;
        for (let index = 0; index < items.length; index++) {
          if (items[index].selling_plan_allocation != null) {
            cartHasSubscription = true;
          }
        }

        $(settings.cartSelector).addClass(settings.openCartClass);

        if (document.querySelectorAll('.flip-card:first-child .flip-card-inner').length > 0) {
          document.querySelector('.flip-card:first-child .flip-card-inner').classList.add('flipcart-unset');
        }

        if (cartHasSubscription) {
          var upsellAchatUnique = document.querySelector('.cart_upsell-achat-unique-only')
          if (upsellAchatUnique) {
            // upsellAchatUnique.classList.add('hide');
          }
          // document.querySelector('.cart_upsell-achat-abonnement__only').classList.remove('hide');
          window.dispatchEvent(new Event('resize'));
        } else {
          var upsellAchatUnique = document.querySelector('.cart_upsell-achat-unique-only')
          if (upsellAchatUnique) {
            // upsellAchatUnique.classList.remove('hide');
          }
          // document.querySelector('.cart_upsell-achat-abonnement__only').classList.add('hide');
          window.dispatchEvent(new Event('resize'));
        }
        $(settings.backgroundSelector).addClass(settings.activeBackgroundClass);
        $(settings.headerSelector).addClass(settings.headerNotLight);
        $(settings.bodySelector).addClass(settings.nonScrollClass);
        $('#chat-button').addClass('hide--pocket');
        let detail = {
          type: "header_click",
          click_text: 'click_cart_menu',
          click_link: '/cart'
        };
        clickevent = new CustomEvent("hb_navigation_click", { detail: detail });
        window.dispatchEvent(clickevent);
    }
    window.openCart = openCart;

    function closeCart() {
        $(settings.cartSelector).removeClass(settings.openCartClass);
        if (document.querySelectorAll('.flip-card:first-child .flip-card-inner').length > 0) {
          document.querySelector('.flip-card:first-child .flip-card-inner').classList.remove('flipcart-unset');
        }
        $(settings.backgroundSelector).removeClass(settings.activeBackgroundClass);
        $(settings.headerSelector).removeClass(settings.headerNotLight);
        $(settings.bodySelector).removeClass(settings.nonScrollClass);
        $('#chat-button').removeClass('hide--pocket');
        if ($('body').hasClass('template-cart'))
        window.location.href = "/";
    }

    function toggleCart() {
        if ($(settings.cartSelector).hasClass(settings.openCartClass))
        closeCart();
        else
        openCart();
    }

    function clearPopups(){
        $(settings.popupContainerSelector).each(function(){
            $(this).empty();
        });
        $('body').removeClass(settings.nonScrollClass);
    }

    function filterPopupSelectedElements(cart){
        var $selectedElt = $('[data-popup-select]').children('option:selected');

        $('[data-popup-option] option').each(function(){
            $(this).removeAttr('disabled');
        });

        $('[data-popup-option] option').each(function(){
            var optionIndex = $(this).parents('[data-popup-option]').attr('data-popup-option');
            var value = $(this).val();
            var exist = false;
            var available = true;
            var firstQuery = '[data-popup-select-option-' + optionIndex + '="' + value + '"]';
            var baseQueryElt = '';
            var queryElt = '';

            for(var i = 0; i < 4; i++){
                if(i == optionIndex) continue;
                var selectedValue = $selectedElt.attr('data-popup-select-option-' + i);
                if(!selectedValue) continue;
                baseQueryElt = firstQuery + '[data-popup-select-option-' + i + '="' + selectedValue + '"] ';
                for(var y = 0; y < 4; y++){
                    if(y == i) continue;
                    var selectedValue = $selectedElt.attr('data-popup-select-option-' + y);
                    if(!selectedValue) continue;
                    queryElt = baseQueryElt;
                    if(y != optionIndex) queryElt += baseQueryElt + '[data-popup-select-option-' + y + '="' + selectedValue + '"]';
                    if($(queryElt).length > 0){
                        exist = true;
                        // if($(queryElt).attr('data-variant-available') == 'false') available = false;
                    }
                }
            }
            // Cas où 1 seule option
            if($('[data-popup-select-option-1]').length == 0){
                if($('[data-popup-select-option-0="' + value + '"]').length){
                    exist = true;
                    // if($('[data-popup-select-option-0="' + value + '"]').attr('data-variant-available') == 'false'){
                    //     available = false;
                    // }
                }
            }
            // console.log('Value' , value);
            // console.log('Exist ', exist, ' available ', available);
            if(!exist || !available) $(this).attr('disabled', true);
        });
    }

    function initPopupHandlers(cart){
        // Close popup
        $(settings.popupSelector).click(function(event) {
            if ($(event.target).closest(settings.productPopupSelector).get(0) == null ) {
                clearPopups();
            }
        });
        $(settings.closePopup).click(function(){
            clearPopups();
        });
        $(settings.popupMinusSelector).click(function(){
            var $popup = $(this).parents(settings.productPopupSelector);
            var newQuantity = $popup.find(settings.popupQuantitySelector).html();
            if(newQuantity > 0) newQuantity--;
            $popup.find(settings.popupQuantitySelector).html(newQuantity);
        });
        $(settings.popupPlusSelector).click(function(){
            var $popup = $(this).parents(settings.productPopupSelector);
            var newQuantity = $popup.find(settings.popupQuantitySelector).html();
            if(newQuantity <= 9) newQuantity++;
            $popup.find(settings.popupQuantitySelector).html(newQuantity);
        });

        $('[data-popup-option]').change(function(){
            var targetQuery = '';
            for(var i = 0; i < 3; i++){
                var $optionElt = $('[data-popup-option-' + i + ']');
                if($optionElt.length > 0){
                    var value = $optionElt.children('option:selected').val();
                    targetQuery += '[data-popup-select-option-' + i + '="' + value + '"]';
                }
            }
            // console.log('Target query ', targetQuery);
            $(targetQuery).prop('selected',true);
            filterPopupSelectedElements(cart);
        });

        $(settings.popupValidate).click(function(){
            var $popup = $(this).parents(settings.productPopupSelector);
            var item_key = $popup.attr(settings.itemKeyAttribute);
            var newQuantity = $popup.find(settings.popupQuantitySelector).html();
            var newFrequency = $popup.find(settings.popupFrequencySelector).children('option:selected').val();
            var initialFrequency = $popup.find('[data-popup-frequency-initial]').val();
            var initialVariant = $popup.find('[data-popup-select-initial]').val();
            var newVariant = $popup.find('[data-popup-select]').children('option:selected').val();
            if(newQuantity == 0){
                $(settings.cartLoaderSelector).show();
                jQuery.post('/cart/update.js', ('updates[' + item_key + ']=0'))
                .done(function(){$(document).trigger('cart.requestDone');});
                clearPopups();
            }else if(newVariant && initialVariant && (newVariant != initialVariant)){
                var cart_properties = {};
                var newId = newVariant;
                if(newFrequency){
                    for(var i = 0; i< cart.items.length; i++){
                        if(cart.items[i].key == item_key){
                            cart_properties = cart.items[i].properties;
                            var quantity = newQuantity;
                            if(cart_properties) cart_properties['_shipping_interval_frequency'] = newFrequency
                        }
                    }
                    if(integrate_checkout){
                        newId = $popup.find('[data-popup-select]').children('option:selected').attr('data-popup-select-variant-id');
                    }else{
                        newId = $popup.find('[data-popup-select]').children('option:selected').attr('data-popup-subscription-variant-id');
                    }
                }
                $(settings.cartLoaderSelector).show();
                // console.log('Cart properties', cart_properties);
                // console.log('new id ', newId);
                jQuery.post('/cart/update.js', ('updates[' + item_key + ']=0'))
                .done(function(e, b){
                    jQuery.post('/cart/add.js', {
                        items : [
                            {
                                quantity: newQuantity,
                                id : newId,
                                properties : cart_properties
                            }
                        ]
                    })
                    .done(function(){$(document).trigger('cart.requestDone');});
                })
                clearPopups();
            }else if(newFrequency && initialFrequency && (newFrequency != initialFrequency)){
                for(var i = 0; i< cart.items.length; i++){
                    if(cart.items[i].key == item_key){
                        var properties = cart.items[i].properties;
                        var quantity = newQuantity;
                        i++;
                        properties['_shipping_interval_frequency'] = newFrequency
                        CartJS.updateItem(i, quantity, properties);
                        clearPopups();
                        return;
                    }
                }
            }else{
                $(settings.cartLoaderSelector).show();
                jQuery.post('/cart/update.js', ('updates[' + item_key + ']=' + newQuantity))
                .done(function(){$(document).trigger('cart.requestDone');});
            }
        });
        filterPopupSelectedElements(cart);
    }


    return cart;
}
var cart = new theme.cart();
customElements.define(
  'subscription-popup-sidecart',
  class SubscriptionPopupSidecart extends HTMLElement {
    constructor() {
      super();

      let selectors = {
        "dropdown": "#dropbox-abonnement-popup",
        "productList": "#abonnement-products-list",
        "productListContainer": ".cart_upsell-achat-unique__abonnement-popup-products--container",
        "frequencesListContainer": ".cart_upsell-achat-unique__abonnement-popup--container",
        "selectBox": "select.abonnement-popup__select-box",
        "selection": "#selected_title",
        "addToCart": "[data-switch-to-subscription]"
      };

      this.selectors = selectors;

      this.dropdown = this.querySelector(this.selectors.dropdown);
      this.productList = this.querySelector(this.selectors.productList);
      this.productListContainer = this.querySelector(this.selectors.productListContainer);
      this.frequencesListContainer = this.querySelector(this.selectors.frequencesListContainer);
      this.selectBox = this.querySelector(this.selectors.selectBox);
      this.selection = this.querySelector(this.selectors.selection);
      this.buttonAddToCart = this.querySelector(this.selectors.addToCart);

      this.frequency = null;

      this.init();
      this.initFrequenciesSelect();

      var self = this;

    }

    parseFrequencyFromPlan(plan) {
      if (!plan) return null;

      if (plan.options && plan.options[0] && plan.options[0].value) {
        return String(plan.options[0].value).replace(/\s*Day\(s\)/i, '').replace(/\s*Week\(s\)/i, '').trim();
      }

      if (plan.name) {
        var match = plan.name.match(/(\d+)\s*jours/i);
        if (match) return match[1];
      }

      return null;
    }

    getFrequenciesFromProduct(product) {
      if (!product || !product.selling_plan_groups || !product.selling_plan_groups[0]) return [];

      var plans = product.selling_plan_groups[0].selling_plans || [];
      var frequencies = [];

      for (var i = 0; i < plans.length; i++) {
        var value = this.parseFrequencyFromPlan(plans[i]);
        if (value && frequencies.indexOf(value) === -1) {
          frequencies.push(value);
        }
      }

      return frequencies.sort(function (a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      });
    }

    intersectFrequencyLists(lists) {
      if (!lists.length) return [];

      return lists.reduce(function (common, list) {
        if (!common.length) return list.slice();
        return common.filter(function (value) {
          return list.indexOf(value) > -1;
        });
      }, lists[0].slice());
    }

    getFallbackFrequencies() {
      var fallback = this.getAttribute('data-fallback-frequencies') || '';
      return fallback.split(',').map(function (value) {
        return value.trim();
      }).filter(Boolean);
    }

    getDefaultFrequency(frequencies) {
      var preferred = (this.getAttribute('data-default-frequency') || '30').trim();

      if (this.frequency && frequencies.indexOf(String(this.frequency)) > -1) {
        return String(this.frequency);
      }

      if (frequencies.indexOf(preferred) > -1) {
        return preferred;
      }

      return frequencies[0] || null;
    }

    async getFrequenciesForCheckedProducts() {
      var checked = this.querySelectorAll('.abonnement-products-popup__products-list__product-item input[type="checkbox"]:checked');
      var lists = [];

      for (var i = 0; i < checked.length; i++) {
        var item = checked[i].closest('.abonnement-products-popup__products-list__product-item');
        var cached = item && item.getAttribute('data-selling-plan-frequencies');
        if (cached) {
          var freqs = cached.split(',').map(function (value) {
            return value.trim();
          }).filter(Boolean);
          if (freqs.length) lists.push(freqs);
          continue;
        }

        var handle = item && item.getAttribute('data-product-handle');
        if (!handle) continue;

        var product = await this.getProduct(handle);
        var productFreqs = this.getFrequenciesFromProduct(product);
        if (productFreqs.length) {
          lists.push(productFreqs);
          if (item) item.setAttribute('data-selling-plan-frequencies', productFreqs.join(','));
        }
      }

      if (!lists.length) return this.getFallbackFrequencies();

      var common = this.intersectFrequencyLists(lists);
      return common.length ? common : lists[0];
    }

    populateFrequenciesSelect(frequencies) {
      if (!this.dropdown || !this.selectBox) return;

      var dropList = this.dropdown.querySelector('ul.abonnement-popup__list-items');
      if (!dropList) return;

      var checkSvg = '<svg class="abonnement-popup__list-item-check" width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.7894 0.135709C16.6698 0.0364698 16.5155 -0.0114135 16.3604 0.00256854C16.2054 0.0165506 16.0622 0.0912557 15.9624 0.210288L6.69545 11.2809L1.87302 6.02375C1.68036 5.81299 1.41155 5.68711 1.12574 5.67381C0.839927 5.66051 0.560519 5.76088 0.348981 5.95284C0.137444 6.1448 0.0111048 6.41262 -0.00224236 6.69739C-0.0155895 6.98216 0.0851486 7.26055 0.277811 7.47131L5.93098 13.6418L5.95798 13.6699C6.05155 13.7708 6.16418 13.8523 6.2894 13.9098C6.41463 13.9673 6.55001 13.9997 6.68779 14.005C6.82558 14.0104 6.96307 13.9886 7.0924 13.9409C7.22173 13.8933 7.34036 13.8207 7.44152 13.7274C7.49299 13.6801 7.53945 13.6276 7.58018 13.5709L16.8876 0.932845C16.9757 0.81233 17.0146 0.662969 16.9964 0.514981C16.9781 0.366993 16.9042 0.231426 16.7894 0.135709Z" fill="white"/></svg>';

      this.selectBox.innerHTML = '';
      dropList.innerHTML = '';

      for (var i = 0; i < frequencies.length; i++) {
        var frequency = frequencies[i];
        var option = document.createElement('option');
        option.value = frequency;
        option.textContent = 'Tous les ' + frequency + ' jours';
        this.selectBox.appendChild(option);

        var li = document.createElement('li');
        li.className = 'abonnement-popup__list-item';
        li.setAttribute('data-value', frequency);
        li.innerHTML = 'Tous les ' + frequency + ' jours ' + checkSvg;
        dropList.appendChild(li);
      }

      var selected = this.getDefaultFrequency(frequencies);
      if (!selected) {
        this.frequency = null;
        if (this.selection) this.selection.innerHTML = '';
        return;
      }

      var selectedLi = dropList.querySelector('li[data-value="' + selected + '"]');
      this.selectBox.value = selected;
      this.frequency = selected;
      if (this.selection && selectedLi) {
        this.selection.innerHTML = selectedLi.innerHTML;
      }
    }

    init() {
      var self = this;
      this.buttonAddToCart.addEventListener('click', function(e){
        self.addToCart();
        self.buttonAddToCart.classList.add('loading');
      });
      self.productListContainer.querySelector('.cart_upsell-achat-unique__abonnement-popup-products__button').addEventListener('click', async function(){
        var frequencies = await self.getFrequenciesForCheckedProducts();
        self.populateFrequenciesSelect(frequencies);
        self.productListContainer.classList.add('hide');
        self.frequencesListContainer.classList.remove('hide');
      })



      var productsSansAbonnement = []
      var productsSansAbonnementArray = self.productListContainer.getAttribute('data-vaiants-sans-abonnement');
      productsSansAbonnementArray.split(',').forEach(function(obj){
        productsSansAbonnement.push(parseInt(obj));
      });

      // show products in the popup
      var achatUniqueButton = document.querySelector('.cart_upsell-achat-unique-button');
      if (achatUniqueButton) {
        achatUniqueButton.addEventListener('click', function(e){
          var cartFetchUrl = '/cart.json';
          const cartFetchOptions = {
            method: 'GET',
            headers: {Accept: 'application/json', 'Content-Type': 'application/json'}
          };
          fetch(cartFetchUrl, cartFetchOptions)
            .then(res => res.json())
            .then(async function(json) {
              var productItems = json.items;
              var productItemsContainer = "";
              for (let i = 0; i < productItems.length; i++) {
                const productItem = productItems[i];

                const productItemVendor = productItem.vendor;
                const productItemId = productItem.id;
                const productItemTitle = productItem.product_title;
                const productItemVariant = productItem.variant_options[0];
                const productItemQuantity = productItem.quantity;
                const productItemImage = productItem.featured_image.url;

                const productItemPrice = (productItem.price * productItemQuantity).toString();
                var productItemPriceLength = productItemPrice.length;
                var productItemPriceCorrect = productItemPrice.substring(0, productItemPriceLength-2) + "," + productItemPrice.substring(productItemPriceLength-2) + "€";

                var disabled = "";
                var disabledText = "";
                var hidePrice = "";
                var AbonnementPrice = "";
                var AbonnementPriceCorrect = "";
                var productItemFrequencies = "";

                if (productsSansAbonnement.includes(productItemId)) {
                  disabled = "disabled";
                  disabledText = "<p class='abonnement-products-popup__products-list__product-item__disabled-text'>indisponible en abonnement</p>";
                  hidePrice = "hide";
                }

                await getProduct(productItem.handle);
                async function getProduct(handle) {
                  return await fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    }
                  }).then(res => res.json())
                  .then(json => {
                    // console.log('product handle :', json.variants[0].selling_plan_allocations[0].price);
                    // console.log('product handle :', json);
                    for (let i = 0; i < json.variants.length; i++) {
                      const variant = json.variants[i];
                      if (variant.id == productItemId) {
                        AbonnementPrice = (variant.selling_plan_allocations[0].price * productItemQuantity ).toString();
                        AbonnementPriceCorrect = AbonnementPrice.substring(0, (AbonnementPrice.length)-2) + "," + AbonnementPrice.substring((AbonnementPrice.length)-2) + "€";
                      }
                    }

                    var productFrequencies = self.getFrequenciesFromProduct(json);
                    productItemFrequencies = productFrequencies.join(',');
                  })
                }

                var ProductItemHtml = `
                  <div class="abonnement-products-popup__products-list__product-item" data-popup-product-id="${productItemId}" data-product-handle="${productItem.handle}" data-selling-plan-frequencies="${productItemFrequencies}">
                    <div class="abonnement-products-popup__products-list__product-item__left-column">
                      <img class="abonnement-products-popup__products-list__product-item__image" src="${productItemImage}" />
                    </div>
                    <div class="abonnement-products-popup__products-list__product-item__middle-column">
                      <p class="abonnement-products-popup__products-list__product-item__vendor">${productItemVendor}</p>
                      <p class="abonnement-products-popup__products-list__product-item__title">${productItemTitle}</p>
                      <p class="abonnement-products-popup__products-list__product-item__variant">(<span class="${hidePrice}">${productItemVariant}</span> x ${productItemQuantity})</p>
                      ${disabledText}
                    </div>
                    <div class="abonnement-products-popup__products-list__product-item__right-column">
                      <p class="abonnement-products-popup__products-list__product-item__abonnement-price ${hidePrice}">${AbonnementPriceCorrect}</p>
                      <p class="abonnement-products-popup__products-list__product-item__price ${hidePrice}">${productItemPriceCorrect}</p>
                      <input type="checkbox" id="${productItemId}" name="${productItemId}" value="${productItemId}" ${disabled}>
                    </div>
                  </div>
                `
                productItemsContainer += ProductItemHtml;
              }

              self.productListContainer.querySelector('.abonnement-products-popup__products-list').insertAdjacentHTML( 'beforeend', productItemsContainer );

              var productCheckboxes = self.querySelectorAll('.abonnement-products-popup__products-list__product-item input[type="checkbox"]');
              for (let i = 0; i < productCheckboxes.length; i++) {
                const checkbox = productCheckboxes[i];
                checkbox.addEventListener('change', function(){
                  if (self.querySelectorAll('.abonnement-products-popup__products-list__product-item input[type="checkbox"]:checked').length > 0) {
                    self.productListContainer.querySelector('.cart_upsell-achat-unique__abonnement-popup-products__button').classList.remove('disable');
                  } else {
                    self.productListContainer.querySelector('.cart_upsell-achat-unique__abonnement-popup-products__button').classList.add('disable');

                  }
                })
              }
          })
        })
      }
    }

    async addToCart() {

      var self = this;

      var items = [];
      var newFrequency = this.frequency;

      var _cart = await (await fetch(`/cart.json`)).json();
      for (let i = 0; i < _cart.items.length; i++) {
        var element = _cart.items[i];

          var product = await this.getProduct(element.handle);

          var sellingPlans = product.selling_plan_groups[0].selling_plans;
          for (let j = 0; j < sellingPlans.length; j++) {

            if (sellingPlans[j].name.indexOf('Livraison tous les ' + newFrequency + ' jours') > -1) {
              var data = '';

              if (document.querySelector('.abonnement-products-popup__products-list input[name="'+ element.variant_id+'"]').checked == true) {
                data = {
                  'properties': {
                    '_shipping_interval_frequency': newFrequency,
                    '_shipping_interval_unit_type': "Days"
                  },
                  'selling_plan': sellingPlans[j].id,
                  'id': element.variant_id,
                  'quantity': element.quantity
                };
              } else {
                data = {
                  'id': element.variant_id,
                  'quantity': element.quantity
                };
              }

              items.push(data);
            }

        }
      }

      CartJS.clear();
      CartJS.addItems(items, {

        // Define a success callback to display a success message.
        "success": async function(data, textStatus, jqXHR) {
          self.classList.remove('active');
        },

        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {

        }

      });

      this.buttonAddToCart.classList.remove('loading');
    }

    async getProduct(handle) {
      return await fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
      }).then(response => {
        return response.json();
      }).catch((error) => {
        console.error('Error:', error);
      });
    }

    initFrequenciesSelect() {
      if (this.dropdown != null) {
        const dropList = this.dropdown.querySelector('ul.abonnement-popup__list-items');

        document.addEventListener('click', e => {
          if (!this.dropdown.contains(e.target)) {
            if (dropList.classList.contains('open')) {
              dropList.classList.remove('open');
            }
          }
        });

        this.dropdown.addEventListener('click', e => {
          if (dropList.classList.contains('open')) {
              dropList.classList.remove('open');
          } else {
              dropList.classList.add('open');
          }
          var selectedItem = e.target.closest('li[data-value]');
          if (selectedItem && dropList.contains(selectedItem)) {
              this.selectBox.value = selectedItem.dataset.value;
              this.frequency = selectedItem.dataset.value;
              this.selection.innerHTML = selectedItem.innerHTML;
          }
        });
      }
    }


  }
);

/**************************
  Custom select
***************************/

theme.customSelect = new function() {

  function customSelect() {

    // init default settings
    var settings = {
      select: '[data-custom-select]',
      menu: '.blog_menu',
      parentSelect: '.customSelect'
    };

    // Iterate over each select element
    $(settings.select).each(function () {

        // Cache the number of options
        var $this = $(this),
            numberOfOptions = $(this).children('option').length;

        if(numberOfOptions > 1){
        // Hides the select element
        $this.addClass('s-hidden');


        // Wrap the select element in a div
        $this.wrap('<div class="select text t-4"></div>');

        var id = Math.floor(Math.random() * 100);

        // Insert a styled div to sit over the top of the hidden select element
        $this.after('<div class="styledSelect" id="'+id+'" data-custom-select-link="'+ $this.data('customSelectLink') +'"></div>');


        // Cache the styled div
        var $styledSelect = $this.next('div.styledSelect');

        // Show the first select option in the styled div
        $styledSelect.append('<span class="option">'+$this.children('option').eq(0).text()+'</span>');

        if(numberOfOptions > 1){
          $styledSelect.append('<span class="select_chevron_down"></span>');
        }

        // Insert an unordered list after the styled div and also cache the list
        if(numberOfOptions > 1){
          var $list = $('<ul />', {
              'class': 'options_blog_menu',
              'id': 'options-'+id
          }).appendTo($styledSelect);


        // Insert a list item into the unordered list for each select option
        for (var i = 0; i < numberOfOptions; i++) {
          var text = '';
          if (i != 0) {
            text = $this.children('option').eq(i).text()
            $('<li />', {
                text: text,
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
          }
        }

        // Cache the list items
        var $listItems = $list.children('li');

        // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
        $styledSelect.hover(function (e) {
            e.stopPropagation();
            var idTarget = $(this).attr('id');
            var target = '#options-'+idTarget;
            $('div.styledSelect.active').not(this).each(function () {
                $("ul:not("+target+")").removeClass('active');
                $(this).removeClass('active');
                $(settings.parentSelect).removeClass('active');
            });
            //var pl = ($(this).find('.option').offset().left) + 'px';
            //$(target).css('padding-left', pl);

            $(settings.parentSelect).toggleClass('active');
            $(this).toggleClass('active');
            $(target).toggleClass('active');
        });
        $styledSelect.click(function (e) {
            e.stopPropagation();
            var link = $(this).attr('data-custom-select-link');
            window.location.href = link;
        });

        // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
        // Updates the select element to have the value of the equivalent option
        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            var url = $(this).attr('rel').toString();
            window.location.replace(url);
            $list.hide();
            /* alert($this.val()); Uncomment this for demonstration! */
        });

        // // Hides the unordered list when clicking outside of it
        // $(document).click(function () {
        //     $(settings.parentSelect).removeClass('active');
        //     $styledSelect.removeClass('active');
        //     $('ul.options_blog_menu').removeClass('active');
        //     $list.hide();
        // });
      }
    }else{

    }
    });


  }
  return customSelect;
}

var customSelect = new theme.customSelect();

/**************************
  LoadMore with pagination
***************************/

theme.loadMorePagination = new function() {

  function loadMorePagination() {

    // init default settings
    var settings = {
      buttonLoadMore: '[data-load-more]',
      container: '[data-load-more-grid]'
    };

    // Iterate over each select element
    $(settings.buttonLoadMore).each(function () {
      let nextlink = '';

      $(this).click(function (e) {
        // Shortcircuit variable
        let triggered = false;

        // Locate loadmore button
        let moreButon = $(this);

        // Get URL from the loadmore button
        let nextUrl = $(this).attr("data-load-more");
        if (nextlink != '') {
          nextUrl = nextlink;
        }

        // Button position when AJAX call should be made one time
        if ((($(moreButon).offset().top - $(window).scrollTop()) < 800) && (triggered == false)) {

          // Trigger shortcircuit to ensure AJAX only fires once
          triggered = true;

          // Make ajax call to next page for load more data
          $.ajax({
            url: nextUrl,
            type: 'GET',
            beforeSend: function() {
              //moreButon.remove();
            }
          })
          .done(function(data) {
            var link = $(data).filter('link[rel="next"]').attr('href');

            if (link != nextlink && link != undefined) {
              nextlink = link;
              $(this).data("loadMore", link);
            } else {
              nextlink = link;
              //$(this).hide();
              moreButon.remove();
            }

            // Append data
            $(settings.container).append($(data).find(settings.container).html());
            $(settings.container).removeClass('grid-articles');
            // On success, reset shortcircuit
            triggered = false
          });
        }
      });

    });


  }
  return loadMorePagination;
}

var loadMorePagination = new theme.loadMorePagination();

/**************************
  LoadMore with list
***************************/

theme.loadMoreList = new function() {

  function loadMoreList() {

    // init default settings
    var settings = {
      buttonLoadMore: '[data-load-more-list]',
      item: '[data-load-more-list-item]'
    };

    // Iterate over each select element
    $(settings.buttonLoadMore).each(function () {
      // Locate loadmore button
      let moreButon = $(this);

      // Get URL from the loadmore button
      let numberToDisplay = $(this).attr("data-load-more-list");

      $(settings.item).slice(0, parseInt(numberToDisplay)).removeClass('hide');

      $(this).click(function (e) {
        // Shortcircuit variable
        let triggered = false;

        // Button position when AJAX call should be made one time
        if ((($(moreButon).offset().top - $(window).scrollTop()) < 800) && (triggered == false)) {

          $('[data-load-more-list-item].hide').slice(0, parseInt(numberToDisplay)).removeClass('hide');
          // Trigger shortcircuit to ensure AJAX only fires once
          triggered = true;
          if ($('[data-load-more-list-item].hide').length == 0) {
            moreButon.remove();
          }
        }
      });

    });


  }
  return loadMoreList;
}

var loadMoreList = new theme.loadMoreList();

/**************************
  Valid form contact
***************************/

theme.checkForm = new function() {

  function checkForm() {

    // init default settings
    var settings = {
      input: '[data-valid-input]',
      button: '[data-valid-button]'
    };

    $(settings.button).click(function(){
        var email = $('#ContactFormEmail').val();
        window.dispatchEvent(new Event('gtmContact', {}));
        $('[action="/contact#contact_form"]').submit();
    });

    $(settings.input).keyup(function() {

        var empty = false;
        $(settings.input).each(function() {
            if ($(this).val().length == 0 && $(this).attr('required')) {
                empty = true;
            }
        });

        if (empty) {
            $(settings.button).attr('disabled', 'disabled');
        } else {
            $(settings.button).attr('disabled', false);
        }
    });


  }
  return checkForm;
}

var checkForm = new theme.checkForm();


// theme.contactSuivi = new function() {

//   function contactSuivi() {
//       if ($('.contact__select').length > 0) {
//         $('.contact__select').on('change', function() {
//           console.log($( this ).val());
//           if ($( this ).val() == "Oùestmoncolis?" || $( this ).val() == "Problèmelorsdelaréceptiondemoncolis") {
//             	var popupSuiviTemplate = document.getElementById("popup-suivi");
//               var popupSuiviHTML = popupSuiviTemplate.innerHTML;
//               $('body').append(popupSuiviHTML);
//               $('.popup-suivi').show();

//               $('.popup-suivi-container .popupCloseButton').on('click', function() {
//                 console.log('ok');
//                 $('.popup-suivi').hide();
//                 $('.popup-suivi').remove();
//               });
//           }
//         });

//       }
//   }

//   return contactSuivi;
// }
// var contactSuivi = new theme.contactSuivi();
/**************************
  Slider only mobile
***************************/

theme.sliderOnlyMobile = new function() {

  function sliderOnlyMobile() {

    // init default settings
    var settings = {
      selector: '[data-only-mobile-f]',
      selectorChild: '[data-slider-mobile-item]',
      selectorData : 'only-mobile-f'
    };

    // init flickity default settings
    var flickitySettings = {
    };

    $(settings.selectorChild).each(function() {
      var $currentEl = $(this);
      if ($currentEl.hasClass('grid__cell')) {
        $currentEl.removeClass('grid__cell')
      }
    });

    // iterate across all slider
    $(settings.selector).each(function() {

      var $currentEl = $(this);
      if ($currentEl.hasClass('grid')) {
          $currentEl.removeClass('grid')
        }
      // get elements settings
      var elementSettings = $currentEl.data(settings.selectorData);
      // merge default settings with elements settings
      var finalSettings = $.extend({}, flickitySettings, elementSettings);
      //console.log(finalSettings);

      // wait all images in slider are loaded
      $currentEl.imagesLoaded( function() {
        // init carousel
        var $carousel = $currentEl.flickity(finalSettings);
      });

    });
  }
  return sliderOnlyMobile;
}

var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
    isMobile = true;
}
if ($(window).width() < 1024) {
    isMobile = true;
}
$(window).resize(function(){
  if ($(window).width() < 1024) {
      isMobile = true;
  } else {
    isMobile = false;
  }
  if (isMobile) {
    var sliderOnlyMobile = new theme.sliderOnlyMobile();
  }
})

if (isMobile) {
  var sliderOnlyMobile = new theme.sliderOnlyMobile();
}

/**************************
  Slider only desktop
***************************/

theme.sliderOnlyDesktop = new function() {

  function sliderOnlyDesktop() {

    // init default settings
    var settings = {
      selector: '[data-only-desktop-f]',
      selectorChild: '[data-slider-desktop-item]',
      selectorData : 'only-desktop-f'
    };

    // init flickity default settings
    var flickitySettings = {

    };

    $(settings.selectorChild).each(function() {
      var $currentEl = $(this);
      if ($currentEl.hasClass('grid__cell')) {
        $currentEl.removeClass('grid__cell')
      }
    });

    // iterate across all slider
    $(settings.selector).each(function() {

      var $currentEl = $(this);
      if ($currentEl.hasClass('grid')) {
          $currentEl.removeClass('grid')
        }
      // get elements settings
      var elementSettings = $currentEl.data(settings.selectorData);
      // merge default settings with elements settings
      var finalSettings = $.extend({}, flickitySettings, elementSettings);

      // wait all images in slider are loaded
      $currentEl.imagesLoaded( function() {
        // init carousel
        var $carousel = $currentEl.flickity(finalSettings);
      });

    });
  }
  return sliderOnlyDesktop;
}

var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
    isMobile = true;
}

if ($(window).width() < 800) {
    isMobile = true;
}

$(window).resize(function(){
  if ($(window).width() < 800) {
      isMobile = true;
  } else {
    isMobile = false;
  }
  if (!isMobile) {
    var sliderOnlyDesktop = new theme.sliderOnlyDesktop();
  }
})

if (!isMobile) {
  var sliderOnlyDesktop = new theme.sliderOnlyDesktop();
}

/** Account popup **/
theme.accountPopup = new function() {

	var context = {
		isActivateOnce : false,
		userMail : false,
		routeUrl:'https://8d8m8hkpo1.execute-api.eu-west-1.amazonaws.com/prod/franklin-pet-food.myshopify.com/customers/search',
		disabledClass : 'button--disabled',
		finalStateClass : 'account-popup--final-state',
		storefrontApiKey : 'f30850f961aadcf23f39666a3041d658',
		shopUrl : 'https://franklinpetfood.com/'
	}

	var selectors = {
		openPopup : '[data-open-account]',
		closePopup : '[data-close-account]',

		accountLoader : '[data-account-loader]',

		errors:'[data-account-error]',

		quickviewContainer : '[data-quickview-container]',
		nonScrollClass : 'non-scroll',

		accountContainer : '[data-account-container]',
		accountPopup : '[data-account-popup]',
		accountState : '[data-account-state]',

		emailTemplate : '[data-email-template]',
		emailInput : '[data-email-input]',
		emailButton : '[data-email-button]',

		registerTemplate : '[data-register-template]',
		registerForm : '[data-register-form]',
		registerMail : '[data-register-mail]',
		registerPassword : '[data-register-password]',
		registerConfirmation : '[data-register-confirmation]',
		registerButton : '[data-register-button]',
		registerNewstext : '[data-register-newstext]',
		registerNewscheck : '[data-register-newscheck]',

		signinTemplate : '[data-signin-template]',
		signinForm : '[data-signin-form]',
		signinForgot : '[data-signin-forgot]',
		signinMail : '[data-signin-mail]',
		signinButton : '[data-signin-button]',
		signinPassword : '[data-signin-password]',

		forgotTemplate : '[data-forgot-template]',
		forgotMail : '[data-forgot-mail]',
		forgotButton : '[data-forgot-button]',

		activateTemplate : '[data-activate-template]',
		activateMail : '[data-activate-mail]',
		activateButton : '[data-activate-button]',


		pendingTemplate : '[data-pending-template]'

	};

	function ensureLoginReturnTo(form) {
		var returnUrl = (window.FK_ACCOUNT && window.FK_ACCOUNT.loginReturnUrl) || '/pages/account';
		var input = form.querySelector('input[name="return_to"]');
		if (!input) {
			input = document.createElement('input');
			input.type = 'hidden';
			input.name = 'return_to';
			form.appendChild(input);
		}
		input.value = returnUrl;
	}

	function accountPopup() {
		$(window).on('openPopup', function(){
			console.log('Open POPUP');
			openPopup();
			return false;
		});
		$(selectors.openPopup).on('click', function(e) {
			var portal = (window.FK_ACCOUNT && window.FK_ACCOUNT.portalUrl) || "/pages/account";
			var isLoggedIn = (window.FK_ACCOUNT && window.FK_ACCOUNT.isLoggedIn) ||
				$("[data-attributes][data-customer-id]").length > 0;

			if (isLoggedIn) {
				window.location.href = portal;
				e.preventDefault();
				return false;
			}

			e.preventDefault();
			openPopup();
      let detail = {
        type: "header_click",
        click_text: 'click_login_menu',
        click_link: portal
      };
      clickevent = new CustomEvent("hb_navigation_click", { detail: detail });
      window.dispatchEvent(clickevent);
			return false;
		});

		var allowSubmit = false;
		if(!window.location.search || (window.location.search.indexOf('checkout_url') == -1)){
			$('form[action="/account"]').submit(function(e){
				window.dispatchEvent(new Event('gtmCreateAccount', {}));
				return true;
			});
			$('form[action="/account/login"]').submit(function(e){
				var form = this;
				if(allowSubmit){
					allowSubmit = false;
					return true;
				}else{
					e.preventDefault();
				}
				console.log('Coucou ', allowSubmit);
				var password = $('input[name="customer[password]"]').val();
				var email = $('input[name="customer[email]"]').val();
				setCookie('email', email, 0.1);
				setCookie('login', true, 0.1);
				return getAccessToken(email, password)
				.then(function(result){
					setCookie('login', true, 0.1);
					if(result && result.data && result.data.customerAccessTokenCreate && result.data.customerAccessTokenCreate.customerAccessToken && result.data.customerAccessTokenCreate.customerAccessToken.accessToken){
						setCookie('customerAccessToken', result.data.customerAccessTokenCreate.customerAccessToken.accessToken);
					}
					ensureLoginReturnTo(form);
					allowSubmit = true;
					form.submit();
				})
				.catch(function(err){
					ensureLoginReturnTo(form);
					allowSubmit = true;
					form.submit();
				})
			});
		}
	}

	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	function showLoader(){
		$(selectors.accountLoader).show();
	}

	function hideLoader(){
		$(selectors.accountLoader).hide();
	}

	function getAccessToken(email, password){
		const recoverQuery = `mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
			customerAccessTokenCreate(input: $input) {
				customerAccessToken {
					accessToken
					expiresAt
				}
				customerUserErrors {
					code
					field
					message
				}
			}
		}`;
		const params = {
			query : recoverQuery,
			variables : {
				"input": {
					"email": email,
					"password": password
				}
			}
		};
		const optionsQuery = {
			method: "post",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json",
				"X-Shopify-Storefront-Access-Token": context.storefrontApiKey
			},
			body: JSON.stringify(params)
		};

		return fetch(`/api/2023-07/graphql`, optionsQuery)
		.then(res => res.json());
	}

	function loginUser(email, password) {
    setCookie('login', true, 0.1);
    
    const form = document.createElement('form');
    form.setAttribute('action', '/account/login');
    form.setAttribute('accept-charset', 'UTF-8');
    form.setAttribute('id', 'customer_login');
    form.setAttribute('method', 'POST');
    
    const emailInput = document.createElement('input');
    emailInput.setAttribute('type', 'email');
    emailInput.setAttribute('name', 'customer[email]');
    emailInput.value = email;
    
    const passwordInput = document.createElement('input');
    passwordInput.setAttribute('type', 'password');
    passwordInput.setAttribute('name', 'customer[password]');
    passwordInput.value = password;

		const utf = document.createElement('input');
		utf.setAttribute('type', 'hidden');
		utf.setAttribute('name', 'utf8');
		utf.value = '✓';

		const formType = document.createElement('input');
		formType.setAttribute('type', 'hidden');
		formType.setAttribute('name', 'form_type');
		formType.value = 'customer_login';

		const returnTo = document.createElement('input');
		returnTo.setAttribute('type', 'hidden');
		returnTo.setAttribute('name', 'return_to');
		returnTo.value = (window.FK_ACCOUNT && window.FK_ACCOUNT.loginReturnUrl) || '/pages/account';
    
    form.appendChild(emailInput);
    form.appendChild(passwordInput);
		form.appendChild(utf);
		form.appendChild(formType);
		form.appendChild(returnTo);

		document.body.appendChild(form);
		window.Shopify.captcha.protect(form, () => {
			form.elements["customer[email]"].value = email;
			form.elements["customer[password]"].value = password;
			form.submit();
		});
	}

	function recoverPassword(email){
		const recoverQuery = `mutation customerRecover($email: String!) {
			customerRecover(email: $email) {
				customerUserErrors {
					code
					field
					message
				}
			}
		}`;
		const params = {
			query : recoverQuery,
			variables : {
				email : email
			}
		};
		const optionsQuery = {
			method: "post",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json",
				"X-Shopify-Storefront-Access-Token": context.storefrontApiKey
			},
			body: JSON.stringify(params)
		};

		return fetch(`/api/2023-07/graphql`, optionsQuery)
		.then(res => res.json());
	}
	function registerUser(customer) {
		const registerQuery = `mutation customerCreate($input: CustomerCreateInput!) {
			customerCreate(input: $input) {
				customer {
					id
				}
				customerUserErrors {
					code
					field
					message
				}
			}
		}
		`;
		const params = {
			query : registerQuery,
			variables : {
				input:{
					acceptsMarketing:customer.accepts_marketing,
					email:customer.email,
					firstName:customer.first_name,
					lastName:customer.last_name,
					password:customer.password
				}
			}
		};
		const optionsQuery = {
			method: "post",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json",
				"X-Shopify-Storefront-Access-Token": context.storefrontApiKey
			},
			body: JSON.stringify(params)
		};

		return fetch(`/api/2023-07/graphql`, optionsQuery)
		.then(res => res.json());
	}

	function validateEmail(email){
		console.log('Validate email ', email);
		context.userMail = email;
		showLoader();
		$.post(context.routeUrl, {email:email},function(response){
			hideLoader();
			console.log('Route response ', response);
			if(!response.data){
				changePopup('register');
			}else{
				var state = response.data.state;
				if(state == 'enabled'){
					changePopup('signin');
				}else if(state == 'disabled'){
					changePopup('activate');
				}else if(state == 'pending' || state == 'invited' || state == 'declined'){
					changePopup('pending');
				}
			}
		})
	}



	function activateAccount(email){
		const registerQuery = `mutation customerCreate($input: CustomerCreateInput!) {
			customerCreate(input: $input) {
				customer {
					id
				}
				customerUserErrors {
					code
					field
					message
				}
			}
		}
		`;

		const params = {
			query : registerQuery,
			variables : {
				input:{
					email:email,
					password:'franklin'
				}
			}
		};

		const optionsQuery = {
			method: "post",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json",
				"X-Shopify-Storefront-Access-Token": context.storefrontApiKey
			},
			body: JSON.stringify(params)
		};
		if(!context.isActivateOnce){
			context.isActivateOnce = true;
			return fetch(`/api/2023-07/graphql`, optionsQuery)
			.then(res => res.json());
		}else{
			return Promise.resolve();
		}

	}

	function verifyEmail(emailPattern, elementValue){
		return emailPattern.test(elementValue);
	}

	// Accept any syntactically valid email domain (incl. custom TLDs like .digital).
	// Previous pattern capped TLD at 2–4 chars, which blocked many business emails.
	function isValidLoginEmail(email){
		var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailPattern.test(String(email || '').trim());
	}

	function checkEmail(email, code){
		if(isValidLoginEmail(email)){
			$(selectors.emailButton).prop('disabled', false);
			$(selectors.emailButton).removeClass(context.disabledClass);
			if(code == 'Enter'){
				validateEmail(String(email || '').trim());
			}
		}else{
			$(selectors.emailButton).prop('disabled', true);
			$(selectors.emailButton).addClass(context.disabledClass);
		}
	}

	function initEmailPopup(){
		var efficientFn = debounce(function(e){
			checkEmail(this.value, e.key);
		}, 150)
		$(selectors.emailInput).keyup(efficientFn);
		$(selectors.emailButton).click(function(){
			var email = String($(selectors.emailInput).val() || '').trim();
			if(isValidLoginEmail(email)){
				validateEmail(email);
			}
		});
	}

	function initPendingPopup(){
		var mail = context.userMail;
		return activateAccount(mail);
	}

	function initRegisterPopup(){
		if(context.userMail) $(selectors.registerMail).val(context.userMail);
		$(selectors.registerNewstext).click(function(){
			$(selectors.registerNewscheck).click();
		})
		$(selectors.registerForm + ' .input-text').keyup(function(e){
			var isEmpty = false;
			$(selectors.registerForm + ' .input-text').each(function(){
				if(!$(this).val() || $(this).val == '') isEmpty = true;
			});
			if(isEmpty){
				$(selectors.registerButton).prop('disabled', true);
				$(selectors.registerButton).addClass(context.disabledClass);
			}
			else{
				$(selectors.registerButton).prop('disabled', false);
				$(selectors.registerButton).removeClass(context.disabledClass);
				if(e.key == 'Enter') $(selectors.registerButton).click()
			}
		});
		$(selectors.registerButton).click(function(){
			if($(selectors.registerPassword).val() !== $(selectors.registerConfirmation).val()){
				$(selectors.errors).html("Les mots de passes ne correspondent pas");
				$(selectors.errors).show();
				return;
			}
			showLoader();
			var newCustomer = $(selectors.registerForm).serializeArray().reduce(function(obj, item) {
				obj[item.name] = item.value;
				return obj;
			}, {});
			newCustomer.accepts_marketing = $('[data-register-newscheck]').is(':checked');
			// console.log('new customer ', newCustomer);
			if(newCustomer.accepts_marketing) newCustomer.accepts_marketing = true;
			else newCustomer.accepts_marketing = false;
			return registerUser(newCustomer)
			.then(function(response){
				console.log('World');
				// console.log('Response ', response);
				var errorHtml = null;
				if(!response || !response.data) return;
				if(response.data.customerCreate){
					var errors = response.data.customerCreate.customerUserErrors
				}else {
					var errors = response.data.errors;
				}
				hideLoader();
				if(errors.length){
					errorHtml = ''
					for(var i = 0; i < errors.length; i++){
						errorHtml += errors[i].message + ' <br>';
					}
					$(selectors.errors).show();
					$(selectors.errors).html(errorHtml);
				}else{
					changePopup('signin');
					$(selectors.errors).html('Merci d\'avoir créé votre compte Franklin. <br> Vous pouvez maintenant vous connecter.');
					$(selectors.errors).show();
					window.dispatchEvent(new Event('gtmCreateAccount', {}));
				}
			})
		});
	}

	function initSigninPopup(){
		if(context.userMail) $(selectors.signinMail).val(context.userMail);

		$(selectors.signinForgot).click(function(e){
			e.preventDefault();
			e.stopPropagation();
			changePopup('forgot');
		});
		$(selectors.signinForm + ' .input-text').keyup(function(e){
			var isEmpty = false;
			$(selectors.signinForm + ' .input-text').each(function(){
				if(!$(this).val() || $(this).val == '') isEmpty = true;
			});
			if(isEmpty){
				$(selectors.signinButton).prop('disabled', true);
				$(selectors.signinButton).addClass(context.disabledClass);
			}
			else{
				$(selectors.signinButton).prop('disabled', false);
				$(selectors.signinButton).removeClass(context.disabledClass);
				if(e.key == 'Enter') $(selectors.signinButton).click()
			}
		});
		if($(selectors.signinPassword).length > 0) {
			setTimeout(function(){
				if($('.input-text[type="password"]').val().length !== 0) {
					$(selectors.signinButton).removeAttr("disabled");
					$(selectors.signinButton).removeClass("button--disabled");
				}
			}, 1000);
		}
		$(selectors.signinButton).click(function(){
			showLoader();
			var password = $(selectors.signinPassword).val();
			var email = $(selectors.signinMail).val();
			setCookie('email', email, 0.1);
			return getAccessToken(email, password)
			.then(function(result){
				console.log('Get access token result', result);

				console.log(window.dataLayer);
				if(result && result.data && result.data.customerAccessTokenCreate && result.data.customerAccessTokenCreate.customerAccessToken && result.data.customerAccessTokenCreate.customerAccessToken.accessToken){
					setCookie('customerAccessToken', result.data.customerAccessTokenCreate.customerAccessToken.accessToken);
				}
				return loginUser(email, password);
			})
			// .done(function (html) {
			// 	hideLoader();
			// 	if (html.indexOf('data-errors') !== -1) {
			// 		console.log('Invalid password');
			// 		$(selectors.errors).html('Email ou mot de passe incorrect');
			// 		// invalid password - show a message to the user
			// 	} else {
			// 		console.log("OK connected");
			// 		setCookie('login', true, 0.1);
			// 		window.location.href = '/account';
			// 	}
			// })
			// .fail(function(error){
			// 	hideLoader();
			// 	$(selectors.errors).html('Trop de requêtes. Connectez vous <a href="/account/login">en cliquant ici</a>')
			// })
		});
	}

	function initForgotPopup(){
		if(context.userMail) $(selectors.forgotMail).val(context.userMail);

		$(selectors.forgotButton).click(function(){
			showLoader();
			var email = $(selectors.forgotMail).val();
			return recoverPassword(email)
			.then(function(response){
				var errorHtml = null;
				// console.log('Response forgot ', response);
				if(!response || !response.data) return;
				if(response.data.customerCreate){
					var errors = response.data.customerRecover.customerUserErrors
				}else {
					var errors = response.data.errors;
				}
				if(errors && errors.length){
					errorHtml = ''
					for(var i = 0; i < errors.length; i++){
						errorHtml += errors[i].message + ' <br>';
					}
					$(selectors.errors).html(errorHtml);
					$(selectors.errors).show();
					hideLoader();
				}else{
					$(selectors.accountState).addClass(context.finalStateClass);
					hideLoader();
				}
			})
		});
	}
	function initActivatePopup(){
		if(context.userMail) $(selectors.activateMail).val(context.userMail);

		$(selectors.activateButton).click(function(){
			showLoader();
			var email = $(selectors.activateMail).val();
			return activateAccount(email)
			.then(function(response){
				// TODO
				console.log('Response ', response);
				var errorHtml = null;
				if(response.data.customerCreate){
					var errors = response.data.customerRecover;
				}else {
					var errors = response.data.errors;
				}
				hideLoader();
				if(errors && errors.length){
					errorHtml = ''
					for(var i = 0; i < errors.length; i++){
						errorHtml += errors[i].message + ' <br>';
					}
					$(selectors.errors).html(errorHtml);
					$(selectors.errors).show();
				}else{
					changePopup('pending');
				}
				console.log('Response ', response);
			});
		})
	}
	function initPopupHandlers(){
		$(document).click(function(event) {
			var $target = $(event.target);
			if(!$target.closest('[data-account-state]').length &&
			$('[data-account-state]').is(":visible")) {
				console.log('Visible');
				closePopup();
			}
		});

		$('body').on('click', selectors.closePopup, function() {
			closePopup();
			return false;
		});
		initEmailPopup();
	}

	function changePopup(key){
		if(key == 'register'){
			$(selectors.accountContainer).html($(selectors.registerTemplate).html());
			initRegisterPopup();
		}
		if(key == 'signin'){
			$(selectors.accountContainer).html($(selectors.signinTemplate).html())
			initSigninPopup();
		}
		if(key == 'email'){
			$(selectors.accountContainer).html($(selectors.emailTemplate).html());
			initEmailPopup();
		}
		if(key == 'forgot'){
			$(selectors.accountContainer).html($(selectors.forgotTemplate).html());
			initForgotPopup();
		}
		if(key == 'activate'){
			$(selectors.accountContainer).html($(selectors.activateTemplate).html());
			initActivatePopup();
		}
		if(key == 'pending'){
			$(selectors.accountContainer).html($(selectors.pendingTemplate).html())
			initPendingPopup();
		}
	}


	function openPopup(){
    localStorage.removeItem('PopupShippingDisplayed');
		clearPopup();
		$('body').addClass(selectors.nonScrollClass);
		$(selectors.accountContainer).html($(selectors.emailTemplate).html());
		$(selectors.accountPopup).show();
		initPopupHandlers();
	}

	function closePopup(){
		clearPopup();
		$(selectors.accountPopup).hide();
	}

	function clearPopup(){
		$(selectors.quickviewContainer).each(function(){
			$(this).empty();
		});
		$('body').removeClass(selectors.nonScrollClass);
	}

	return accountPopup;
}

var accountPopup = new theme.accountPopup();

theme.resetPassword = new function() {

  var settings = {
    password : '[data-reset-password-password]',
    passwordConfirmation : '[data-reset-password-confirmation]',
    passwordSubmit : '[data-reset-password-submit]'
  };

  function resetPassword() {
    if( $(settings.password).length && ($(settings.password).val().length === 0 || $(settings.passwordConfirmation).val().length === 0)) {
        $(settings.passwordSubmit).prop( "disabled", true );
    } else {
      $(settings.passwordSubmit).prop( "disabled", false );
    }
  }

  $(settings.password).on('input', function() {
    resetPassword();
  })
  $(settings.password).on('blur', function() {
    resetPassword();
  })

  $(settings.passwordConfirmation).on('input', function() {
    resetPassword();
  })
  $(settings.passwordConfirmation).on('blur', function() {
    resetPassword();
  })

  return resetPassword;
}

var resetPassword = new theme.resetPassword();

// bring the accordion list for mobile and tablet

function screenSize(desktop) {
  if (desktop.matches) {
    $('.icon_list_lamarque_position_mobile').remove();
  } else {
    $('.icon_list_lamarque_position').remove();
  }
}

var desktop = window.matchMedia("(min-width: 1024px)")
screenSize(desktop)
desktop.addListener(screenSize)

// uncheck the first item of accordion list

$(".text-background-image__accordion-list:first-child").find('input[type="checkbox"]').prop('checked', false);

// check the rest items of accordion list when one is unchecked

$('.text-background-image__accordion-list').find('input[type="checkbox"]').on('change', function() {
    $('.text-background-image__accordion-list').find('input[type="checkbox"]').not(this).prop('checked', true);
});

// rotate image on scroll

$(window).scroll(function() {
var theta = $(window).scrollTop() / 600 % Math.PI;
$('.middle_image').css({ transform: 'rotate(' + theta + 'rad)' });
});

/**************************
  Text CTA Blog
***************************/

theme.textCTABlog = new function() {

  function textCTABlog() {

    // init default settings
    var settings = {
      title: '[data-text-cta-title]',
      backgrounds: '[data-background-tags]'
    };

    var isMobile = false;

    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent.substr(0,4))) {
        isMobile = true;
    }

    if (window.location.href.indexOf("blogs") > -1) {
      if (window.location.href.indexOf("tagged") > -1) {
        var split = window.location.pathname.split('tagged/');
        var tags = decodeURIComponent(split[1])
        if (tags.indexOf("+") > -1) {
          var titles = tags.replace('1-meta-categorie_','').split('-').join(' ').split('+');
          var title = titles[0].toUpperCase() + '.' + '<br/><span class="text-cta__title-tag">'+ titles[1].toUpperCase() +'.</span>';
        } else {
          if (tags.replace('1-meta-categorie_','').split('-').join(' ') == 'comme chien et chat') {
            var titles = tags.replace('1-meta-categorie_','').split('-').join(' ').split('et');
            var title = titles[0].toUpperCase() + '<br/><span>et '+ titles[1].toUpperCase() +'.</span>';
          } else {
            var title = tags.replace('1-meta-categorie_','').split('-').join(' ') + '.';
            title = title.toUpperCase();

          }
        }

        var links = $('.link_all_articles');
        links.each( function( index, element ) {
            if ($(this).attr('href').replace('https://franklinpetfood.com', '') == window.location.pathname) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
            $(this).on('click', function(){
              links.removeClass('active');
              setTimeout(() => {
                $(this).addClass('active');
              }, 10);
            })
        });

        // $(settings.title).html(title);
        // $(settings.title).css('text-transform', 'capitalize');



        if (isMobile) {
          if ($('body').hasClass('template-blog')) {
            $('.accordion-menu-blog [data-accordion-trigger]').click();
            console.log(tags);
            var linksMobile = $('.accordion_link-blog');
            linksMobile.each( function( index, element ) {
                if ($(this).attr('href').replace('https://franklinpetfood.com', '') == window.location.pathname) {
                  $(this).addClass('active');
                } else {
                  $(this).removeClass('active');
                }
            });
          }
        }
      }
    }


  }
  return textCTABlog;
}

var textCTABlog = new theme.textCTABlog();

/**************************
  Text Slider
***************************/

theme.textSlider = new function() {

  function textSlider() {

    // init default settings
    var settings = {
      readMoreContent: '[data-read-more-content]',
      readMoreButton: '[data-read-more-button]'
    };

    $(settings.readMoreButton).each(function () {
      $(this).on('click', function () {
        $(this).prev().toggleClass('read_more_mobile-text');
        $(this).toggleClass('read_more_mobile-active');
        $('.carousel-main').flickity('resize');
      })
    });
  }
  return textSlider;
}

var textSlider = new theme.textSlider();

/** Calculateur de ration **/
theme.calculateurPopup = new function() {

	var selectors = {
		openPopup : '[data-open-calculateur]',
		closePopup : '[data-close-calculateur]',
    openPopupMobile: '.abonnement-product__calculator-mobile',
		quickviewContainer : '[data-quickview-container]',
		nonScrollClass : 'non-scroll',

		calculateurPopup : '[data-calculateur-popup]',
		calculateurProduct : '[data-calculateur-product]',
		calculateurProductContent : '[data-calculateur-product-content]',
		calculateurQuestion : '[data-calculateur-question]',
		calculateurAllResults : '[data-calculateur-results]',
		calculateurProductOptions : '[data-calculateur-product-options]',
		calculateurProductOption : '[data-calculateur-product-option]',

		calculateurLoading1 : '[data-calculateur-loading-1]',
		calculateurLoading2 : '[data-calculateur-loading-2]',
		calculateurLoaded1 : '[data-calculateur-loaded-1]',
		calculateurLoaded2 : '[data-calculateur-loaded-2]',
		calculateurLoadedText1 : '[data-calculateur-loaded-text-1]',
		calculateurLoadedText2 : '[data-calculateur-loaded-text-2]',

		calculateurFooter : '[data-calculateur-footer]',
		calculateurPriceOneShot : '[data-calculateur-price-one-shot]',
		calculateurPriceSubscribe : '[data-calculateur-price-subscribe]',
		calculateurFrequencySelector : '[data-calculateur-frequency-selector]',
		calculateurAddToCart : '[data-calculateur-add-to-cart]',
		calculateurAddToCartDual : '[data-calculateur-add-to-cart-dual]',

		productVendor : '[data-product-vendor]',
		productVendorData : 'data-product-vendor'
	};
	function calculateurPopup() {
		function sameCalculateurAnswer(a, b) {
			return String(a == null ? '' : a).trim().toLowerCase() === String(b == null ? '' : b).trim().toLowerCase();
		}

		$(selectors.openPopup).on('click', function() {
			openPopup();
			window.dispatchEvent(new Event('openPopupCalculateur'));

      let detail = {
        type: 'click',
        name: 'feeding_guide_action',
      };

      let clickevent = new CustomEvent("hb_feeding_guide_action", { detail: detail });
      window.dispatchEvent(clickevent);

			return false;
		});

    $(selectors.openPopupMobile).on('click', function() {
			window.dispatchEvent(new Event('openPopupCalculateur'));
      var productHandle = this.parentElement.getAttribute('data-product-handle');
      document.querySelector('[data-calculateur-state] [data-calculateur-product] optgroup option[value="'+ productHandle +'"]').selected = true;
      getProductTemplate($(selectors.calculateurProduct).val());
      console.log(productHandle);
			return false;
		});

		$('body').on('click', selectors.closePopup, function() {
			closePopup();
			return false;
		});

		var allResults = $(selectors.calculateurAllResults).data("calculateurResults");

		var ration = '';

    // page abonnement select recette
    $(selectors.calculateurProduct).on("change",function(event) {
      getProductTemplate($(this).val());
    });

		//Check if step 1 is completed
		$(selectors.calculateurQuestion).on("change",function(event) {
				var empty = true;
				var answer_1 = "";
				var answer_2 = "";
				var is_answer_2 = false;
				var answer_3 = "";
				var is_answer_3 = false;

				$(selectors.calculateurQuestion).each(function() {
					if($(this).val() || $(this).val() != null){
						if ($(this).val().length != 0) {
								empty = false;
								$(this).removeClass('default');
						}
					}

					if ($(this).attr('id') == "question1") {
						answer_1 = $(this).val();
					}
					if ($(this).attr('id') == "question2") {
						answer_2 = $(this).val();
						is_answer_2 = true;
					}
					if ($(this).attr('id') == "question3") {
						answer_3 = $(this).val();
						is_answer_3 = true;
					}
				});

				if (!empty) {
					//display loader
					$(selectors.calculateurLoaded1).addClass('hide');
					$(selectors.calculateurLoaded2).addClass('hide');
					$(selectors.calculateurProductOptions).addClass('hide');
					$(selectors.calculateurFooter).addClass('hide');

					$.each(allResults, function(i, v) {
						if (sameCalculateurAnswer(v.answer_1, answer_1)) {
							if (is_answer_2) {
								if (sameCalculateurAnswer(v.answer_2, answer_2)) {
									if (is_answer_3) {
										if (sameCalculateurAnswer(v.answer_3, answer_3)) {
											$(selectors.calculateurLoading1).removeClass('hide');
											ration = v.result;

											var vendor = $(selectors.productVendor).attr(selectors.productVendorData).toLowerCase();
											console.log(vendor);

											var conditionnement = parseInt(v.result.replace('g', '')) * 31;
											console.log(conditionnement);
											conditionnement = parseInt(conditionnement) / 1000;
											conditionnement = conditionnement.toFixed(2);

											if (vendor.indexOf('croquette') > -1 && vendor.indexOf('chat') > -1 && answer_3 && sameCalculateurAnswer(answer_3, 'Mixte')) {
												var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ".";
											} else if ((vendor.indexOf('pâtées') > -1 || vendor.indexOf('filet') > -1) && vendor.indexOf('chat') > -1) {
												var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ".";
											} else if (vendor.indexOf('pâtées') > -1 && vendor.indexOf('chien') > -1) {
												var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ".";
											} else {
												var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ", ce qui correspond à une consommation de "+ conditionnement +" kg/mois.";
											}
											$(selectors.calculateurLoadedText1).text(ration_text);

											setTimeout(function() {
												$(selectors.calculateurLoading1).addClass('hide');
												$(selectors.calculateurLoaded1).removeClass('hide');
												$(selectors.calculateurProductOptions).removeClass('hide');
												$(selectors.calculateurProductOption).val("default");
												$(selectors.calculateurProductOption).addClass('default');
                        feedingGuideSnowplow(ration);
											}, 1000);
										}
									} else {
										$(selectors.calculateurLoading1).removeClass('hide');
										ration = v.result;

                    var vendor = $(selectors.productVendor).attr(selectors.productVendorData).toLowerCase();
                    console.log(vendor);

										var conditionnement = parseInt(v.result.replace('g', '')) * 31;
										console.log(conditionnement);
										conditionnement = parseInt(conditionnement) / 1000;
										conditionnement = conditionnement.toFixed(1);

										if (+conditionnement.toString().split('').pop() == 0) {
											conditionnement = parseInt(conditionnement);
										}

                    if (sameCalculateurAnswer(v.answer_2, 'Mixte')) {
                      var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + "/jour.";
                    }  else if (vendor.indexOf('pâtées') > -1 || vendor.indexOf('filet') > -1) {
                      var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ".";
                    } else {
                      var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + "/jour, soit une consommation de "+ conditionnement +" kg/mois.";
                    }
										$(selectors.calculateurLoadedText1).text(ration_text);

										setTimeout(function() {
											$(selectors.calculateurLoading1).addClass('hide');
											$(selectors.calculateurLoaded1).removeClass('hide');
											$(selectors.calculateurProductOptions).removeClass('hide');
											$(selectors.calculateurProductOption).val("default");
											$(selectors.calculateurProductOption).addClass('default');
                      feedingGuideSnowplow(ration);
										}, 1000);
									}
								}
							} else {
								$(selectors.calculateurLoading1).removeClass('hide');
								ration = v.result;

                var vendor = $(selectors.productVendor).attr(selectors.productVendorData).toLowerCase();
                console.log(vendor);

								var conditionnement = parseInt(v.result.replace('g', '')) * 31;
								console.log(conditionnement);
								conditionnement = parseInt(conditionnement) / 1000;
								conditionnement = conditionnement.toFixed(1);


								if (+conditionnement.toString().split('').pop() == 0) {
									conditionnement = parseInt(conditionnement);
								}

                if (sameCalculateurAnswer(v.answer_2, 'Mixte')) {
                  var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + "/jour.";
                }  else if (vendor.indexOf('pâtées') > -1 || vendor.indexOf('filet') > -1) {
                  var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ".";
                } else {
                  var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + "/jour, soit une consommation de "+ conditionnement +" kg/mois.";
                }
								$(selectors.calculateurLoadedText1).text(ration_text);

								setTimeout(function() {
									$(selectors.calculateurLoading1).addClass('hide');
									$(selectors.calculateurLoaded1).removeClass('hide');
									$(selectors.calculateurProductOptions).removeClass('hide');
									$(selectors.calculateurProductOption).val("default");
									$(selectors.calculateurProductOption).addClass('default');
                  feedingGuideSnowplow(ration);
								}, 1000);
							}
						}
					});

				}
		});

    function feedingGuideSnowplow(result) {
      let detail = {
        type: 'generate',
        name: 'feeding_guide_action',
        result: result
      };

      let resultEvent = new CustomEvent("hb_feeding_guide_action", { detail: detail });
      window.dispatchEvent(resultEvent);
    }

		//Check if step 2 is completed
		$(selectors.calculateurProductOption).on("change",function(event) {
				window.dispatchEvent(new Event('changeVariantCalculateur'));
				var empty = true;
				var taille_value = "";
				var conditionnement_value = "";


				$(selectors.calculateurProductOption).each(function() {
					if ($(this).val() && $(this).val() != null && $(this).val() != 'default'){
						if ($(this).val().length != 0 ) {
								empty = false;
								$(this).removeClass('default');

								if ($(this).attr('data-variant-option-name-calculateur') == "Taille") {
									taille_value = $(this).val();
									$('[data-product-form] [data-variant-option-name="Taille"]').val(taille_value);
									$('[data-product-form] [data-variant-option-name="Taille"]').trigger('change');

									setTimeout(function() {
										conditionnement_value = $('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').val();
										$('[data-product-form] [data-variant-option-name="Conditionnement"]').val(conditionnement_value);
										$('[data-product-form] [data-variant-option-name="Conditionnement"]').trigger('change');
										if ($('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').val() != null && $('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').val() != 'default') {
											$('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').removeClass('default');
										}
									}, 600);

								}
								if ($(this).attr('data-variant-option-name-calculateur') == "Conditionnement") {
									conditionnement_value = $(this).val();
									if(conditionnement_value.toLowerCase().indexOf('15 kg') !== -1) {
										$('[data-product-form] [data-variant-option-name="Taille de la croquette"]').val('Grande');
										$('[data-product-form] [data-variant-option-name="Taille de la croquette"]').trigger('change');
									} else {
										$('[data-product-form] [data-variant-option-name="Taille de la croquette"]').val('Normale');
										$('[data-product-form] [data-variant-option-name="Taille de la croquette"]').trigger('change');
										$('[data-product-form] [data-variant-option-name="Conditionnement"]').val(conditionnement_value);
										$('[data-product-form] [data-variant-option-name="Conditionnement"]').trigger('change');
									}
								}
						}
					}
				});

				if ($('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').val() != null && $('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').val() != '' && $('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').val() != 'default') {
					empty = false;
					conditionnement_value = $('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').val();
				} else {
					empty = true;
					$(selectors.calculateurLoading2).addClass('hide');
					$(selectors.calculateurLoaded2).addClass('hide');
					$(selectors.calculateurFooter).addClass('hide');
					$('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').val('default');
					$('[data-calculateur-product-option][data-variant-option-name-calculateur="Conditionnement"]').addClass('default');
				}

				if (!empty) {

					$('[data-subscription-activate]').click();

					//display loader
					$(selectors.calculateurLoading2).removeClass('hide');
					$(selectors.calculateurLoaded2).addClass('hide');
					$(selectors.calculateurFooter).addClass('hide');


						setTimeout(function() {

							if (conditionnement_value != '' || taille_value.indexOf('Grande') !== -1) {

								// $('[data-product-form] [data-variant-option-name="Taille"]').val(taille_value);
								// $('[data-product-form] [data-variant-option-name="Taille"]').trigger('change');
								//
								// $('[data-product-form] [data-variant-option-name="Conditionnement"]').val(conditionnement_value);
								// $('[data-product-form] [data-variant-option-name="Conditionnement"]').trigger('change');

								var ration_int = ration.split(' g');
								ration_int = parseInt(ration_int[0]);
								var conditionnement_int = conditionnement_value.split(' kg');
								conditionnement_int = parseFloat(conditionnement_int[0]) * 1000;

								var nb_repas_value = Math.round(conditionnement_int / ration_int);
								//var nb_repas_text = $(selectors.calculateurLoadedText2).data("calculateurLoadedText-2").replace("$_kg_$", conditionnement_value).replace("$_nb_repas_$", nb_repas_value);
								//$(selectors.calculateurLoadedText2).text(nb_repas_text);

								var frequency = 0;
								switch (true) {
									case nb_repas_value < 22:
										frequency = 15;
										break;
									case nb_repas_value >= 22 && nb_repas_value <= 26:
										frequency = 15;
										break;
									case nb_repas_value >= 27 && nb_repas_value <= 31:
										frequency = 20;
										break;
									case nb_repas_value >= 32 && nb_repas_value <= 36:
										frequency = 25;
										break;
									case nb_repas_value >= 37 && nb_repas_value <= 41:
										frequency = 30;
										break;
									case nb_repas_value >= 42 && nb_repas_value <= 46:
										frequency = 35;
										break;
									case nb_repas_value >= 47 && nb_repas_value <= 51:
										frequency = 40;
										break;
									case nb_repas_value >= 52 && nb_repas_value <= 56:
										frequency = 45;
										break;
									case nb_repas_value >= 57 && nb_repas_value <= 61:
										frequency = 50;
										break;
									case nb_repas_value >= 62 && nb_repas_value <= 66:
										frequency = 55;
										break;
									case nb_repas_value >= 67 && nb_repas_value <= 71:
										frequency = 60;
										break;
									case nb_repas_value >= 72 && nb_repas_value <= 80:
										frequency = 65;
										break;
									case nb_repas_value >= 81 && nb_repas_value <= 90:
										frequency = 70;
										break;
									case nb_repas_value >= 91 && nb_repas_value <= 100:
										frequency = 80;
										break;
									case nb_repas_value >= 101 && nb_repas_value <= 120:
										frequency = 90;
										break;
									case nb_repas_value >= 121 && nb_repas_value <= 150:
										frequency = 120;
										break;
									case nb_repas_value > 151:
										frequency = 150;
										break;
									default:
										frequency = 30;
								}

								console.log(frequency);

								$(selectors.calculateurFrequencySelector).val(frequency);
								$('[data-frequency-selector]').val(frequency);

								$(selectors.calculateurLoading2).addClass('hide');
								$(selectors.calculateurLoaded2).removeClass('hide');
								$(selectors.calculateurFooter).removeClass('hide');
							}
						}, 500);

					}
		});

		//Change frequency
		$(selectors.calculateurFrequencySelector).on("change",function(event) {
			$('[data-frequency-selector]').val($(this).val());
		});

		//Add to cart
		$(selectors.calculateurAddToCart).on("click",function(event) {
			closePopup();
			$('.product__add-to-cart-container [data-add-to-cart]').click();
		});

		//Add to cart dual
		$(selectors.calculateurAddToCartDual).on("click",function(event) {
			closePopup();
			$('.product__add-to-cart-container [data-add-to-cart-dual]').click();
		});


	}

	function openPopup() {
		$('body').addClass(selectors.nonScrollClass);
		$(selectors.calculateurPopup).show();
	}

	function closePopup() {
		$('body').removeClass(selectors.nonScrollClass);
		$(selectors.calculateurPopup).hide();
	}


  async function getProductTemplate(handle) {
    await fetch('/products/' + handle + '?section_id=calculateur-de-ration')
    .then(response => response.text())
    .then(function(data) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(data, 'text/html');

      var image = doc.querySelector('.calculateur-de-ration__image').getAttribute('src');
      var questions_box = doc.querySelector('.calculateur-de-ration__first-questions-box').innerHTML;
      var allResults = JSON.parse(doc.querySelector(selectors.calculateurAllResults).dataset.calculateurResults);
      var vendor = doc.querySelector(selectors.productVendor).dataset.productVendor.toLowerCase();

      document.querySelector('.calculateur-de-ration__image').setAttribute('src', image);
      document.querySelector(selectors.calculateurProductContent).innerHTML = questions_box;
      document.querySelector(selectors.calculateurLoaded1).classList.add('hide');
      initCalculateurAbonnement(allResults, vendor);
      openPopup();
    });
  }

  function initCalculateurAbonnement(allResults, vendor) {

		var ration = '';

    //Check if step 1 is completed
		$(selectors.calculateurQuestion).on("change",function(event) {
      var empty = true;
      var answer_1 = "";
      var answer_2 = "";
      var is_answer_2 = false;
      var answer_3 = "";
      var is_answer_3 = false;

      $(selectors.calculateurQuestion).each(function() {
        if($(this).val() || $(this).val() != null){
          if ($(this).val().length != 0) {
              empty = false;
              $(this).removeClass('default');
          }
        }

        if ($(this).attr('id') == "question1") {
          answer_1 = $(this).val();
        }
        if ($(this).attr('id') == "question2") {
          answer_2 = $(this).val();
          is_answer_2 = true;
        }
        if ($(this).attr('id') == "question3") {
          answer_3 = $(this).val();
          is_answer_3 = true;
        }
      });

      if (!empty) {
        //display loader
        $(selectors.calculateurLoaded1).addClass('hide');
        $(selectors.calculateurLoaded2).addClass('hide');
        $(selectors.calculateurProductOptions).addClass('hide');
        $(selectors.calculateurFooter).addClass('hide');

        $.each(allResults, function(i, v) {
          if (sameCalculateurAnswer(v.answer_1, answer_1)) {
            if (is_answer_2) {
              if (sameCalculateurAnswer(v.answer_2, answer_2)) {
                if (is_answer_3) {
                  if (sameCalculateurAnswer(v.answer_3, answer_3)) {
                    $(selectors.calculateurLoading1).removeClass('hide');
                    ration = v.result;

                    var conditionnement = parseInt(v.result.replace('g', '')) * 31;

                    conditionnement = parseInt(conditionnement) / 1000;
                    conditionnement = conditionnement.toFixed(2);

                    if (vendor.indexOf('croquette') > -1 && vendor.indexOf('chat') > -1 && answer_3 && sameCalculateurAnswer(answer_3, 'Mixte')) {
                      var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ".";
                    } else if ((vendor.indexOf('pâtées') > -1 || vendor.indexOf('filet') > -1) && vendor.indexOf('chat') > -1) {
                      var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ".";
                    } else {
                      var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ", ce qui correspond à une consommation de "+ conditionnement +" kg/mois.";
                    }
                    $(selectors.calculateurLoadedText1).text(ration_text);

                    setTimeout(function() {
                      $(selectors.calculateurLoading1).addClass('hide');
                      $(selectors.calculateurLoaded1).removeClass('hide');
                      $(selectors.calculateurProductOptions).removeClass('hide');
                      $(selectors.calculateurProductOption).val("default");
                      $(selectors.calculateurProductOption).addClass('default');
                    }, 1000);
                  }
                } else {
                  $(selectors.calculateurLoading1).removeClass('hide');
                  ration = v.result;

                  var conditionnement = parseInt(v.result.replace('g', '')) * 31;

                  conditionnement = parseInt(conditionnement) / 1000;
                  conditionnement = conditionnement.toFixed(1);

                  if (+conditionnement.toString().split('').pop() == 0) {
                    conditionnement = parseInt(conditionnement);
                  }

                  if (sameCalculateurAnswer(v.answer_2, 'Mixte')) {
                    var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + "/jour.";
                  } else if (vendor.indexOf('pâtées') > -1 || vendor.indexOf('filet') > -1) {
                    var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ".";
                  }  else {
                    var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + "/jour, soit une consommation de "+ conditionnement +" kg/mois.";
                  }
                  $(selectors.calculateurLoadedText1).text(ration_text);

                  setTimeout(function() {
                    $(selectors.calculateurLoading1).addClass('hide');
                    $(selectors.calculateurLoaded1).removeClass('hide');
                    $(selectors.calculateurProductOptions).removeClass('hide');
                    $(selectors.calculateurProductOption).val("default");
                    $(selectors.calculateurProductOption).addClass('default');
                  }, 1000);
                }
              }
            } else {
              $(selectors.calculateurLoading1).removeClass('hide');
              ration = v.result;

              var conditionnement = parseInt(v.result.replace('g', '')) * 31;

              conditionnement = parseInt(conditionnement) / 1000;
              conditionnement = conditionnement.toFixed(1);


              if (+conditionnement.toString().split('').pop() == 0) {
                conditionnement = parseInt(conditionnement);
              }

              if (sameCalculateurAnswer(v.answer_2, 'Mixte')) {
                var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + "/jour.";
              } else if (vendor.indexOf('pâtées') > -1 || vendor.indexOf('filet') > -1) {
                var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + ".";
              }  else {
                var ration_text = $(selectors.calculateurLoadedText1).data("calculateurLoadedText-1").replace(/\$_ration_\$\.?/g, ration) + "/jour, soit une consommation de "+ conditionnement +" kg/mois.";
              }
              $(selectors.calculateurLoadedText1).text(ration_text);

              setTimeout(function() {
                $(selectors.calculateurLoading1).addClass('hide');
                $(selectors.calculateurLoaded1).removeClass('hide');
                $(selectors.calculateurProductOptions).removeClass('hide');
                $(selectors.calculateurProductOption).val("default");
                $(selectors.calculateurProductOption).addClass('default');
              }, 1000);
            }
          }
        });

      }
  });
  }

	return calculateurPopup;
}

var calculateurPopup = new theme.calculateurPopup();

/**************************
  LoadMore with list
***************************/

if (document.querySelectorAll('.grid-reviews .avis-tags__container').length > 0) {
  var filtersContainer = document.querySelector('.avis-tags__container');
  var reviews = document.querySelectorAll('.review-container');

  var isMobile = false;

  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
      isMobile = true;
  }

  if (isMobile) {
    var numberToDisplay = 6;
  } else {
    var numberToDisplay = 15;
  }

  filtersContainer.addEventListener('change', function(){
    reviewsFilters();
    $('[data-load-more-reviews-item]:not(.hide-filter).hide').slice(0, parseInt(numberToDisplay)).removeClass('hide');
    $('[data-load-more-reviews-item].hide-filter').addClass('hide');

    console.log($('[data-load-more-reviews-item]:not(.hide-filter).hide').length)
    if ($('[data-load-more-reviews-item]:not(.hide-filter).hide').length == 0) {
      $('[data-load-more-reviews]').addClass('hide');
    } else {
      $('[data-load-more-reviews]').removeClass('hide');
    }

    for (let i = numberToDisplay; i < reviews.length; i++) {
      var element = document.querySelectorAll('.review-container:not(.hide-filter)')[i];
      if (typeof(element) != 'undefined' && element != null) {
        element.classList.add('hide');
      }
    }
  })

  function reviewsFilters() {

    var isMobile = false;

    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
        isMobile = true;
    }

    if (isMobile) {
      var numberToDisplay = 6;
    } else {
      var numberToDisplay = 15;
    }

    if (document.querySelectorAll('.grid-reviews input[name="animal-tags"]:checked').length > 0) {
      var filter1 = document.querySelector('.grid-reviews input[name="animal-tags"]:checked');
      var filter1Value = filter1.value;
    } else {
      var filter1Value = ''
    }

    if (document.querySelectorAll('.grid-reviews input[name="type-tags"]:checked').length > 0) {
      var filter2 = document.querySelector('.grid-reviews input[name="type-tags"]:checked');
      var filter2Value = filter2.value;
    } else {
      var filter2Value = ''
    }

    if (filter1Value != '' && filter2Value != '') {
      for (let i = 0; i < reviews.length; i++) {
        const review = reviews[i];
        if (review.matches('[data-filter-1="'+filter1Value+'"]') && review.matches('[data-filter-2="'+filter2Value+'"]')) {
          console.log(review)
          review.classList.remove('hide-filter');
        } else {
          review.classList.add('hide-filter');
        }
      } 
      
    } else if (filter1Value != '' && filter2Value == '') {
      for (let i = 0; i < reviews.length; i++) {
        const review = reviews[i];
        if (review.matches('[data-filter-1="'+filter1Value+'"]')) {
          console.log(review)
          review.classList.remove('hide-filter');
        } else {
          review.classList.add('hide-filter');
        }
      } 
      
    } else if (filter1Value == '' && filter2Value != '') {
      for (let i = 0; i < reviews.length; i++) {
        const review = reviews[i];
        if (review.matches('[data-filter-2="'+filter2Value+'"]')) {
          console.log(review)
          review.classList.remove('hide-filter');
        } else {
          review.classList.add('hide-filter');
        }
      }
      
    } else if (filter1Value == '' && filter2Value == '') {
      for (let i = 0; i < reviews.length; i++) {
        const review = reviews[i];
        console.log(review)
        review.classList.remove('hide-filter');
      }
      
    }
  }
}

theme.loadMoreReviews = new function() {

  function loadMoreReviews() {

    // init default settings
    var settings = {
      buttonLoadMore: '[data-load-more-reviews]',
      item: '[data-load-more-reviews-item]'
    };

    var isMobile = false;

    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
        isMobile = true;
    }

    if (isMobile) {
      var numberToDisplay = 6;
    } else {
      var numberToDisplay = 15;
    }

    // Iterate over each select element
    $(settings.buttonLoadMore).each(function () {
      // Locate loadmore button
      let moreButon = $(this);

      $('[data-load-more-reviews-item]:not(.hide-filter).hide').slice(0, parseInt(numberToDisplay)).removeClass('hide');

      $(this).click(function (e) {
        console.log('clicked');
        // Shortcircuit variable
        let triggered = false;

        // Button position when AJAX call should be made one time
        if (triggered == false) {

          $('[data-load-more-reviews-item]:not(.hide-filter).hide').slice(0, parseInt(numberToDisplay)).removeClass('hide');
          // Trigger shortcircuit to ensure AJAX only fires once
          triggered = true;
          if ($('[data-load-more-reviews-item]:not(.hide-filter).hide').length == 0) {
            moreButon.addClass('hide');
          } else {
            moreButon.removeClass('hide');
          }
        }
      });

      if ($('[data-load-more-reviews-item]:not(.hide-filter).hide').length == 0) {
        moreButon.addClass('hide');
      } else {
        moreButon.removeClass('hide');
      }

    });


  }
  return loadMoreReviews;
}

var loadMoreReviews = new theme.loadMoreReviews();


function activeProgressBar(desktopScreen) {
  if (desktopScreen.matches) {

        var activeAnimate = false;
        var count = 0;

        $(document).scroll(function() {
            if ($(window).scrollTop() > $('.progress-sign').offset().top / 2 && !activeAnimate) {
                animateProgressBar();
                activeAnimate = true;
            }
        });

        function animateProgressBar() {
            var progressBar = setInterval(function () {
                var width = parseInt($('.progress-sign')[0].style.width) + 20;
                count = count + 1;
                if (count != 4) {
                    $(".progress-sign").width(width + '%');
                    $('[data-progress-bar-item=' + count + ']').addClass('active');
                } else if (count == 4) {
                    $(".progress-sign").width(width + '%');
                    $('[data-progress-bar-item=' + count + ']').addClass('active');
                    setTimeout(function () {
                        $(".progress-sign").width('20%');
                        $('[data-progress-bar-item]').removeClass('active');
                        count = 0;
                        animateProgressBar();
                    }, 1000);

                }
            }, 1000);
            setTimeout(function () { clearInterval(progressBar); }, 5000);
        }

  } else {
    //   $('.progress-sign').removeAttr('style').css('height', '20%');

      var activeAnimate = false;
        var count = 0;

        $(document).scroll(function() {
            if ($(window).scrollTop() > $('.progress-sign').offset().top / 2 && !activeAnimate) {
                animateProgressBar();
                activeAnimate = true;
            }
        });

        function animateProgressBar() {
            var progressBar = setInterval(function () {
                var width = parseInt($('.progress-sign')[0].style.width) + 20;
                count = count + 1;
                if (count != 4) {
                    $(".progress-sign").width(width + '%');
                    $('.progress-bar').css('transform', 'translateX(-'+ ($('.progress-bar').width() / 5) * count +'px)');
                    $('[data-progress-bar-item=' + count + ']').addClass('active');
                } else if (count == 4) {
                    $(".progress-sign").width(width + '%');
                    $('[data-progress-bar-item=' + count + ']').addClass('active');
                    setTimeout(function () {
                        $(".progress-sign").width('20%');
                        $('[data-progress-bar-item]').removeClass('active');
                        $('.progress-bar').css('transform', 'translateX(0px)');
                        count = 0;
                        animateProgressBar();
                    }, 2000);

                }
            }, 2000);
            setTimeout(function () { clearInterval(progressBar); }, 10000);
        }
  }
}

var desktopScreen = window.matchMedia("(min-width: 801px)");
if ($('.progress-sign').length > 0) {
    activeProgressBar(desktopScreen);
    desktopScreen.addListener(activeProgressBar);
}
theme.offreRejoindre = new function() {

  var selectors = {
    openTarget : '[data-open-offre]',
    closeTarget : '[data-close-offre]',
    targetData : 'open-offre',
    targetCloseData : 'close-offre',
    nonScrollClass : 'non-scroll'
  };

  function offreRejoindre() {
		$(selectors.openTarget).on('click', function() {
      var offre_id = $(this).data(selectors.targetData);
			openPopup(offre_id);
			return false;
		});

		$(selectors.closeTarget).on('click', function() {
      var offre_id = $(this).data(selectors.targetCloseData);
			closePopup(offre_id);
			return false;
		});
  }

  function openPopup(offre_id) {
		$('body').addClass(selectors.nonScrollClass);
    console.log($('#offre-overlay-' + offre_id));
		$('#offre-overlay-' + offre_id).addClass('active');
		$('#offre-' + offre_id).addClass('active');
	}

	function closePopup(offre_id) {
    console.log(offre_id);
		$('body').removeClass(selectors.nonScrollClass);
		$('#offre-overlay-' + offre_id).removeClass('active');
		$('#offre-' + offre_id).removeClass('active');
	}

  return offreRejoindre;
}

var offreRejoindre = new theme.offreRejoindre();


window.addEventListener('CookiebotOnDialogInit', function (e) {

  setTimeout(function () {

    if ($('#CybotCookiebotDialog').css('display') == 'block') {
      var overlay = "<div class='quickview' data-overlay-cookie></div>";
      $('body').append(overlay);
    }

    $('body').on('click', '#CybotCookiebotDialogBodyButtonDecline', function () {
      $('[data-overlay-cookie]').remove();
    });

    $('body').on('click', '#CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll', function () {
      $('[data-overlay-cookie]').remove();
    });

    $('body').on('click', '#CybotCookiebotDialogBodyButtonAccept', function () {
      $('[data-overlay-cookie]').remove();
      //consentGranted();
    });

    $('body').on('click', '#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll', function () {
      $('[data-overlay-cookie]').remove();
      //consentGranted();
    });

    $('body').on('click', '#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection', function () {
      $('[data-overlay-cookie]').remove();
      //consentGranted();
    });

    $('<span data-show-cookies class="expend-cookies CybotCookiebotDialogBodyButton">Afficher les détails</span>').insertAfter('#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection');
    $('#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection').hide();
    $('body').on('click', '[data-show-cookies]', function (e) {
      $('#CybotCookiebotDialogBodyLevelButtons').show();
      $('#CybotCookiebotDialogBodyLevelDetailsWrapper').click();
      $('#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection').show();
      $('[data-show-cookies]').hide();
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if ($('#CybotCookiebotDialog').hasClass('cookie-expanded')) {
        $('#CybotCookiebotDialog').removeClass('cookie-expanded');
      } else {
        $('#CybotCookiebotDialog').addClass('cookie-expanded');
      }
    });

  }, 300);

}, false);

$('body').on('click', '#CybotCookiebotDialogBodyButtonDetails', function () {
  $('#CybotCookiebotDialog').toggleClass('cookie-expanded');
});

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
    var sections = new slate.Sections();
    // sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'rte__table-wrapper',
    });

    // Target iframes to make them responsive
    var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'rte__video-wrapper'
    });

    // Apply a specific class to the html element for browser support of cookies.
    if (slate.cart.cookiesEnabled()) {
        document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
    }

    // /*================ Custom flickity arrow buttons ================*/
    $('[data-carousel-prev]').click(function(){
        $(this).parents('[data-carousel-container]').find('[data-flickity]').flickity('previous');
    });
    $('[data-carousel-next]').click(function(){
        $(this).parents('[data-carousel-container]').find('[data-flickity]').flickity('next');
    });
    $('[data-carousel-prev-only-desktop]').click(function(){
        $(this).parents('[data-carousel-container]').find('[data-only-desktop-f]').flickity('previous');
    });
    $('[data-carousel-next-only-desktop]').click(function(){
        $(this).parents('[data-carousel-container]').find('[data-only-desktop-f]').flickity('next');
    });

    if ($('#shopify-section-mega-section__abonnement').length > 0) {
      //srcdoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href={{_urlEmbed}}><img src='https://img.youtube.com/vi/fJK79wXt7_U/maxresdefault.jpg' alt='Franklin'><span id='playbutton'>▶</span></a>"
      // var counter = 0;
      // lazyPlayVideo();
    }

    function lazyPlayVideo() {
      if (document.querySelector('#videoframe').contentDocument.querySelector('#playbutton') != null) {
        document.querySelector('#videoframe').contentDocument.querySelector('#playbutton').click();
      } else {
        if (counter < 20) {
          console.log('ok');
          setTimeout(lazyPlayVideo, 50);
        }
      }
    }

});

// /*================ Custom ================*/


theme.banner = new function() {
    var settings = {};

    function banner(bannerSettings) {

        var defaultSettings = {
            bannerSelector : '[data-banner]',
            selectorData: 'banner',
            prevNextButtons : false,
            wrapAround: true
        };

        settings = $.extend({}, defaultSettings, bannerSettings);

        $(settings.bannerSelector).each(function() {
            var el = $(this);
            $(this).imagesLoaded( function() {
                var elementSettings = $(el).data(settings.selectorData);
                var finalSettings = $.extend({}, settings, elementSettings);
                $(el).flickity(finalSettings);
                $(el).removeClass('slides-opacity');
            });
        });
    }
    return banner;
}
var banner = new theme.banner();



/** Collection slider **/
theme.collectionSlider = new function() {
    function collectionSlider() {
        $(function(){
            // Section obsolète
            $('[data-collection-slider]').each(function(){
                var flickitySettings = JSON.parse($(this).attr('data-collection-slider'));
                if ( matchMedia('screen and (min-width: 768px)').matches ) {
                    flickitySettings.cellAlign = 'center';
                }else{
                    //flickitySettings.pageDots = true;
                }
                var $carousel = $(this).flickity(flickitySettings);
                $('[data-carousel-prev]').each(function(){$(this).click(function(){$(this).parents('[data-carousel-container]').find('[data-collection-slider]').flickity('previous');});});
                $('[data-carousel-next]').each(function(){$(this).click(function(){$(this).parents('[data-carousel-container]').find('[data-collection-slider]').flickity('next');});});
            });
        })
    }
    return collectionSlider;
}
var collectionSlider = new theme.collectionSlider();

/** Description tabs **/
theme.descTab = new function() {
    function descTab() {
        $(function(){
            // Section obsolète
            $('[data-desctab-heading]').click(function(){
                var index = $(this).attr('data-desctab-heading');
                $('[data-desctab-heading]').each(function(){$(this).removeClass('desctab__heading--active');})
                $(this).addClass('desctab__heading--active');

                $('[data-desctab-content]').each(function(){$(this).removeClass('desctab__content--active');});
                $('[data-desctab-content="' + index + '"]').addClass('desctab__content--active');
            });
        })
    }
    return descTab;
}
var descTab = new theme.descTab();

// theme.getOriginalProduct = new function(variant_id){
//     function getOriginalProduct(variant_id){
//
//         return variant_id;
//     }
//     return getOriginalProduct;
// }
// var getOriginalProduct = new theme.getOriginalProduct();

(function() {
    // Video controllers

    // Hide GORGIAS
    // var gorgiasChatInterval = window.setInterval(function () {
    //     var iframe = document.querySelector('#gorgias-web-messenger-container');
    //     if (iframe) {
    //         var head = iframe.contentWindow.document.querySelector('head')
    //         if (head.children.length) {
    //             window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.
    //             var styles = document.createElement('style');
    //             styles.textContent = '.logo-wrapper{display: none}'
    //             head.appendChild(styles)
    //         }
    //     }
    // }, 100);

    // Footer email
    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
    $('#ContactFooter-email').keyup(function(e){
        var email = this.value;
        console.log(validateEmail(email));
        if(validateEmail(email)){
            $('#Subscribe').removeClass('button--disabled');
            $('#Subscribe').attr('disabled',false);
        }else{
            $('#Subscribe').addClass('button--disabled');
            $('#Subscribe').attr('disabled',true);
        }
    });


    // Fix flickity slider
    var touchingCarousel = false,
    touchStartCoords;
    document.body.addEventListener('touchstart', function(e) {
        if (e.target.closest('.flickity-slider')) {
            touchingCarousel = true;
        } else {
            touchingCarousel = false;
            return;
        }

        touchStartCoords = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY
        }
    });

    document.body.addEventListener('touchmove', function(e) {
        if (!(touchingCarousel && e.cancelable)) {
            return;
        }

        var moveVector = {
            x: e.touches[0].pageX - touchStartCoords.x,
            y: e.touches[0].pageY - touchStartCoords.y
        };

        if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
})();

theme.demoAsideBar = new function() {

    function demoAsideBar() {

        // init default settings
        var settings = {
            selectorTrigger: '[data-demo-aside-bar]',
            selectorTriggerFrequency: '[data-edit-frequency]',
            selectorTriggerDate: '[data-edit-date]',
            selectorTriggerProduct: '[data-edit-product]',
            selectorOverlay: '[data-rc-overlay]',
            selectorClose: '[data-rc-close-aside-bar]',
            selectorAsideBar: '[data-aside-bar]',
            selectorAsideBarFrequency: '[data-aside-bar-frequency]',
            selectorAsideBarProduct: '[data-aside-bar-product]',
            selectorAsideBarDate: '[data-aside-bar-date]',
            selectorModalTrigger: '[data-open-modal-cancel]',
            selectorModal: '[data-modal-cancel]',
        };

        $(settings.selectorTrigger).on( 'click', function() {
            $(settings.selectorOverlay).addClass('is-active');
            $(settings.selectorAsideBar).addClass('is-active');
        });

        $(settings.selectorTriggerFrequency).on( 'click', function() {
            $(settings.selectorOverlay).addClass('is-active');
            $(settings.selectorAsideBarFrequency).addClass('is-active');
        });
        $(settings.selectorTriggerDate).on( 'click', function() {
            $(settings.selectorOverlay).addClass('is-active');
            $(settings.selectorAsideBarDate).addClass('is-active');
        });
        $(settings.selectorTriggerProduct).on( 'click', function() {
            $(settings.selectorOverlay).addClass('is-active');
            $(settings.selectorAsideBarProduct).addClass('is-active');
        });
        $(settings.selectorModalTrigger).on( 'click', function() {
            $(settings.selectorOverlay).addClass('is-active');
            $(settings.selectorModal).addClass('is-active');
        });

        $(settings.selectorOverlay).on( 'click', function() {
            if ($(this).hasClass('is-active')) {
                $(settings.selectorOverlay).removeClass('is-active');
                $(settings.selectorAsideBar).removeClass('is-active');
                $(settings.selectorAsideBarFrequency).removeClass('is-active');
                $(settings.selectorAsideBarDate).removeClass('is-active');
                $(settings.selectorAsideBarProduct).removeClass('is-active');
                $(settings.selectorModal).removeClass('is-active');
            }
        });
        $(settings.selectorClose).on( 'click', function() {
            if ($(settings.selectorOverlay).hasClass('is-active')) {
                $(settings.selectorOverlay).removeClass('is-active');
                $(settings.selectorAsideBar).removeClass('is-active');
                $(settings.selectorAsideBarFrequency).removeClass('is-active');
                $(settings.selectorAsideBarDate).removeClass('is-active');
                $(settings.selectorAsideBarProduct).removeClass('is-active');
                $(settings.selectorModal).removeClass('is-active');
            }
        });

    }
    return demoAsideBar;
}

var demoAsideBar = new theme.demoAsideBar();

theme.gtmHandlers = new function() {

    function gtmHandlers() {

        var productList = 'accueil';
        if(window.location.href.indexOf('products') !== -1) productList = 'suggestion produit';
        else if(window.location.href.indexOf('collection') !== -1) productList = 'category';
        else productList = (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

        // Ajouter la position sur les produits
        var productPosition = 1;
        $('[data-product-card]').each(function(){
            $(this).attr('data-product-position', productPosition);
            productPosition++;
        })


        setTimeout(function(){
            try{
                console.log('GA', ga.getAll()[0].get('clientId'));
                setCookie('clientId', ga.getAll()[0].get('clientId'));
            }catch(e){

            }
        }, 1500);

        // Event link outbound
        $('a').click(function(e){
            var url = $(this).attr('href');
            if (typeof url !== 'undefined' && url !== false) {
              var linkCategory = ''

            console.log('link click 2', url);

            var productCard = $(this).closest('.product-card');

            if(productCard.length > 0) {
              if(document.querySelector('body').getAttribute('pooch-template') == "product") {
                detail = {
                  handle: productCard.attr('data-product-handle'),
                  creative: document.querySelector('body').getAttribute('pooch-template'),
                  list_name: "product_page_cross_sell",
                  subscription: false
                };
              } else if(document.querySelector('body').getAttribute('pooch-template') == "collection") {
                detail = {
                  handle: productCard.attr('data-product-handle'),
                  creative: 'list_click',
                  list_name: "select_item",
                  subscription: false
                };
              } else {
                detail = {
                  handle: productCard.attr('data-product-handle'),
                  creative: "plp",
                  list_name: (document.querySelector('body').getAttribute('pooch-template') == 'index') ? 'click_best_seller_bloc' : document.querySelector('body').getAttribute('pooch-template'),
                  subscription: false
                };
              }
              
              prodevent = new CustomEvent("hb_product_click", { detail: detail });
              window.dispatchEvent(prodevent);  
            }

            if($(this).hasClass('megamenu-image-container')) {
              detail = {
                handle: $(this).attr('data-product-handle'),
                creative: "plp",
                list_name: 'click_header_product',
                subscription: false
              };
              prodevent = new CustomEvent("hb_product_click", { detail: detail });
              window.dispatchEvent(prodevent);  
            }
          
            if(url.indexOf('franklinpetfood.com/') == -1 && url.indexOf('http') !== -1 && url.indexOf('www') !== -1){
                linkCategory = 'Site partenaire'
                if(url.indexOf('google') != -1) linkCategory = 'Google map';
                else if(url.indexOf('acebook') != -1 || url.indexOf('witter') != -1 || url.indexOf('nstagr') != -1) linkCategory = 'Réseaux sociaux';

                const { hostname } = new URL(url);

                gtmOutbound({linkCategory:linkCategory, url:hostname})
            }
            }

        });

        if(window.location.href.indexOf('logged=true') !== -1){
            function removeParam(parameter)
            {
                var url=document.location.href;
                var urlparts= url.split('?');

                if (urlparts.length>=2)
                {
                    var urlBase=urlparts.shift();
                    var queryString=urlparts.join("?");

                    var prefix = encodeURIComponent(parameter)+'=';
                    var pars = queryString.split(/[&;]/g);
                    for (var i= pars.length; i-->0;)
                    if (pars[i].lastIndexOf(prefix, 0)!==-1)
                    pars.splice(i, 1);
                    url = urlBase+'?'+pars.join('&');
                    window.history.pushState('',document.title,url); // added this line to push the new url directly to url bar .

                }
                return url;
            }
            removeParam('logged');
            window.dispatchEvent(new Event('gtmLogin', {}));
            let detail = {
              type: "customer_login",
              action: "login"
            };
            let customerAction = new CustomEvent("hb_customer_action", { detail: detail });
            window.dispatchEvent(customerAction);
        }

        // Event impression
        if($('[data-product-card]:not(.collection__product-card)').length > 0){
            var products = [];

            $('[data-product-card]:not(.collection__product-card)').each(function(){
                products.push({
                    id : $(this).attr('data-product-id'),
                    name : $(this).attr('data-product-name'),
                    price : parseFloat($(this).attr('data-product-price').replace('€', '').replace(',', '.')),
                    type : $(this).attr('data-product-type'),
                    list:productList,
                    espece:$(this).attr('data-product-espece'),
                    stock:$(this).attr('data-product-stock'),
                    discount: parseFloat($(this).attr('data-product-discount')) || 0,
                    position: parseInt($(this).attr('data-product-position'))
                })
            });
            gtmImpression({products:products});
        }

        // Event click product
        // $('[data-product-card]').click(function(event){
        //   if ($(event.target).closest('.bundle__product-cta, .product-card__cta').length === 0) {
        //     var product = {
        //       id : $(this).attr('data-product-id'),
        //       name : $(this).attr('data-product-name'),
        //       price : $(this).attr('data-product-price'),
        //       type : $(this).attr('data-product-type'),
        //       list:productList,
        //       espece:$(this).attr('data-product-espece'),
        //       stock:$(this).attr('data-product-stock'),
        //       discount:$(this).attr('data-product-discount'),
        //       position:$(this).attr('data-product-position')
        //     }
        //     gtmClickProduct(product);
        //   }
        // });

        $('[data-product-details-click]').click(function(event){
          if ($(event.target).closest('.bundle__product-cta, .product-card__cta').length === 0) {
            var product = {
              id : $(this).attr('data-product-id'),
              name : $(this).attr('data-product-name'),
              price : parseFloat($(this).attr('data-product-price').replace('€', '').replace(',', '.')),
              type : $(this).attr('data-product-type'),
              list:productList,
              espece:$(this).attr('data-product-espece'),
              stock:$(this).attr('data-product-stock'),
              discount: parseFloat($(this).attr('data-product-discount')) || 0,
              position: parseInt($(this).attr('data-product-position'))
            }
            gtmProductDetail(product);
          }
        });

        $('[data-product-card-click]').click(function(event){
          if ($(event.target).closest('.bundle__product-cta, .product-card__cta').length === 0) {
            var product = {
              id: $(this).attr('data-product-id'),
              name: $(this).attr('data-product-name'),
              price: parseFloat($(this).attr('data-product-price').replace('€', '').replace(',', '.')),
              type: $(this).attr('data-product-type'),
              list: productList,
              espece: $(this).attr('data-product-espece'),
              stock: $(this).attr('data-product-stock'),
              discount: parseFloat($(this).attr('data-product-discount')) || 0,
              position: parseInt($(this).attr('data-product-position'))
            }
            gtmClickProduct(product);
          }
          if($(event.target).hasClass('product-card__cta')) {
            creative = window.location.pathname.includes('blogs') ? 'blog' : 'landing';
								detail = {
									  sku: $(event.target).attr('data-variant-sku'),
									  handle: $(this).attr('data-product-handle'),
									  quantity: 1,
									  creative: creative,
									  inventory_status: 'oneoff',
									  subscription: false
								};
								cartevent = new CustomEvent("hb_add_to_cart", {
									  detail: detail
								});
								window.dispatchEvent(cartevent);
          }
        });

        // Event product details
        if($('[data-product-details]').length){
            $('[data-product-details]').each(function(){
                var product = {
                    id : $(this).attr('data-product-id'),
                    name : $(this).attr('data-product-name'),
                    price : parseFloat($(this).attr('data-product-price').replace('€', '').replace(',', '.')),
                    type : $(this).attr('data-product-type'),
                    list:productList,
                    espece:$(this).attr('data-product-espece'),
                    stock:$(this).attr('data-product-stock'),
                    discount: parseFloat($(this).attr('data-product-discount')) || 0
                }
                if($(this).attr('data-product-review')) product.review = $(this).attr('data-product-review');
                if($(this).attr('data-product-note')) product.note = $(this).attr('data-product-note');

                if(window.location.href.indexOf('/products/') !== -1){
                    if(window.location.pathname.split('/')[2] == $(this).attr('data-product-handle')){
                        product.list = 'fiche produit';
                    }
                }

                gtmProductDetail(product);
            })
        }

        // Event embasement (newsletter)
        if(window.location.href.indexOf('customer_posted=true') !== -1 && $('[data-form-status]').html().trim() == 'Vous êtes bien inscrit à la newsletter'){
            window.dispatchEvent(new Event('gtmEmbasement', {}));
        }

        // Event add a review
        if(window.location.href.indexOf('products') !== -1){
            $('.reviews-product').on("click", '.write-review-wrapper .yotpo-submit', function(){
                $('[data-product-details]').each(function(){
                    var product = {
                        id : $(this).attr('data-product-id'),
                        name : $(this).attr('data-product-name'),
                        price : parseFloat($(this).attr('data-product-price').replace('€', '').replace(',', '.')),
                        type : $(this).attr('data-product-type'),
                        list:productList,
                        espece:$(this).attr('data-product-espece'),
                        stock:$(this).attr('data-product-stock'),
                        discount: parseFloat($(this).attr('data-product-discount')) || 0
                    }
                    if($(this).attr('data-product-review')) product.review = parseInt($(this).attr('data-product-review')) + 1;
                    if($(this).attr('data-product-note')) product.note = $(this).attr('data-product-note');
                    gtmReview(product);
                });
            })
            // Event ask a question
            $('.reviews-product').on("click", '.write-question-wrapper .yotpo-submit', function(){
                gtmQuestion();
            });
        }

        // Event unsubscribe






    }
    return gtmHandlers;
}
var gtmHandlers = new theme.gtmHandlers();


theme.collectionEncarts = new function() {

    function collectionEncarts() {
        if ($('body').hasClass('template-collection')) {
            var maxHeight = -1;

            $('[data-product-card]').each(function() {
                if ($(this).height() > maxHeight) {
                    maxHeight = $(this).height();
                }
            });

            console.log(maxHeight)
            setTimeout(function(){
                /*$('.encart-image-collection').height(maxHeight);*/
            }, 500);

        }
    }

    return collectionEncarts;
}
var collectionEncarts = new theme.collectionEncarts();



//remove Yopto CSS file



document.addEventListener('DOMContentLoaded', function() {
  checkRemoveCSS();
}, false);

function checkRemoveCSS() {
  if ($('link[rel=stylesheet][href*="//staticw2.yotpo.com/ib3UZsEMCWTakCBdQIiLYciJnTn4wbwvcu2EfhwC/widget.css"]').length > 0) {
    removejscssfile("widget.css", "css");
  } else {
    setTimeout(checkRemoveCSS, 50);
  }
}

function removejscssfile(filename, filetype){
    var targetelement=(filetype=="js")? "script" : (filetype=="css")? "link" : "none" //determine element type to create nodelist from
    var targetattr=(filetype=="js")? "src" : (filetype=="css")? "href" : "none" //determine corresponding attribute to test for
    var allsuspects=document.getElementsByTagName(targetelement)
    for (var i=allsuspects.length; i>=0; i--){ //search backwards within nodelist for matching elements to remove
    if (allsuspects[i] && allsuspects[i].getAttribute(targetattr)!=null && allsuspects[i].getAttribute(targetattr).indexOf(filename)!=-1)
        allsuspects[i].parentNode.removeChild(allsuspects[i]) //remove element by calling parentNode.removeChild()
    }
}


function hideBanner() {
    if(window.location.href.indexOf('?bienvenue') > 1) {
        setCookie('hideBanner', true, 1);
        $('.announcement-bar ').addClass("hide");
        window.history.pushState({}, document.title, window.location.href.replace('?bienvenue', ''));
    }
}

hideBanner();
if(getCookie('hideBanner')){
    $('.announcement-bar ').addClass("hide");
}


// echantillons

var addToCartEchantillons =  document.querySelectorAll('[data-add-cart-echantillon]');
addToCartEchantillons.forEach((addToCartEchantillon) => {
    addToCartEchantillon.addEventListener('click', function() {
        var variant_id = this.dataset.addCartEchantillon;
        var button = this;
        CartJS.addItem(variant_id, 1, {
            "success": function(data, textStatus, jqXHR) {
                button.disabled = "disabled";
                button.classList.add("button--disabled");
                klaviyoAddedToCart();
            }
        });
    });
});

// checkout button

function resetCheckoutButtonsLoadingState() {
  try {
    var checkoutButtons = document.querySelectorAll('[data-checkout-button]');
    checkoutButtons.forEach(function(button) {
      var priceContainer = button.querySelector('.button__product-price--container');
      var loadingEl = button.querySelector('.button__product-loading');
      if (priceContainer) priceContainer.classList.remove('hide');
      if (loadingEl) loadingEl.classList.add('hide');
    });
  } catch (e) {
    // no-op
  }
}

function resyncCartFromServer() {
  var applyCart = function(cart) {
    if (typeof CartJS !== 'undefined') {
      CartJS.cart = cart;
    }
    if (typeof jQuery !== 'undefined') {
      jQuery(document).trigger('cart.ready', [cart]);
    }
    if (window.SubscriptionBooster && typeof window.SubscriptionBooster.update === 'function') {
      window.SubscriptionBooster.update(cart);
    }
  };

  if (typeof jQuery !== 'undefined') {
    jQuery.getJSON('/cart', applyCart);
    return;
  }

  fetch('/cart.json', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(applyCart)
    .catch(function() {});
}

window.addEventListener('pageshow', function() {
  resetCheckoutButtonsLoadingState();
  resyncCartFromServer();
});

window.addEventListener('focus', function() {
  resetCheckoutButtonsLoadingState();
});

document.addEventListener('visibilitychange', function() {
  if (document.visibilityState === 'visible') {
    resetCheckoutButtonsLoadingState();
  }
});

document.addEventListener('click', async function(e) {
  var checkoutButton = e.target.closest('[data-checkout-button]');
  if (!checkoutButton) return;

  e.preventDefault();

  var isSideCart = !!checkoutButton.closest('[data-side-cart]');
  window.dispatchEvent(new CustomEvent('hb_ecom_event', {
    detail: {
      type: 'begin_checkout',
      creative_id: isSideCart ? 'minicart' : 'cart'
    }
  }));

  // Show loading state
  var priceContainer = checkoutButton.querySelector('.button__product-price--container');
  var loadingEl = checkoutButton.querySelector('.button__product-loading');
  if (priceContainer) priceContainer.classList.add('hide');
  if (loadingEl) loadingEl.classList.remove('hide');

  try {
      // Get current cart data
      const cartData = await fetch('/cart.json').then(res => res.json());
      const cartTotal = cartData.total_price / 100;
      
      // Check cart for animal types
      const hasChien = cartData.items.some(item => 
        (item.product_type && item.product_type.toLowerCase().includes('chien')) || 
        (item.tags && Array.isArray(item.tags) && item.tags.some(tag => tag.toLowerCase().includes('chien'))) ||
        (item.vendor && item.vendor.toLowerCase().includes('chien')) ||
        (item.vendor && item.vendor.toLowerCase().includes('chiot'))
      );
      const hasChat = cartData.items.some(item => 
        (item.product_type && item.product_type.toLowerCase().includes('chat')) || 
        (item.tags && Array.isArray(item.tags) && item.tags.some(tag => tag.toLowerCase().includes('chat'))) ||
        (item.vendor && item.vendor.toLowerCase().includes('chat')) ||
        (item.vendor && item.vendor.toLowerCase().includes('chatton'))
      );

      // Get step values from progress price elements
      let step2Value, step3Value, step4Value;
      if (hasChat && !hasChien) {
        step2Value = parseFloat($('[data-progress-goal]').eq(0).attr('data-progress-goal-chat')) / 100;
        step3Value = parseFloat($('[data-progress-goal]').eq(1).attr('data-progress-goal-chat')) / 100;
        step4Value = parseFloat($('[data-progress-goal]').eq(2).attr('data-progress-goal-chat')) / 100;
      }
      else {
        step2Value = parseFloat($('[data-progress-goal]').eq(0).attr('data-progress-goal')) / 100;
        step3Value = parseFloat($('[data-progress-goal]').eq(1).attr('data-progress-goal')) / 100;
        step4Value = parseFloat($('[data-progress-goal]').eq(2).attr('data-progress-goal')) / 100;
      }

      let currentStep = 1;
      if (cartTotal >= step4Value) currentStep = 4;
      else if (cartTotal >= step3Value) currentStep = 3;
      else if (cartTotal >= step2Value) currentStep = 2;

      // Get all offer products
      const offerProducts = $('.product-offer__drawer--products .product-card-offer').toArray();
      const giftProductsInCart = cartData.items.filter(item => 
        offerProducts.some(product => 
          parseInt($(product).data('product-id')) === item.product_id
        )
      );

      if (currentStep === 4) {
        // Get step 2 and step 4 products
        let step2Product, step4Product;
        if (hasChien) {
          step2Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chien"][data-step="2"]').first().attr('data-variant-id');
          step4Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chien"][data-step="4"]').first().attr('data-variant-id');
        } else if (hasChat) {
          step2Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chat"][data-step="2"]').first().attr('data-variant-id');
          step4Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chat"][data-step="4"]').first().attr('data-variant-id');
        }

        // Check what types of gifts are in cart
        const hasStep2InCart = giftProductsInCart.some(item => 
          offerProducts.some(product => 
            parseInt($(product).data('product-id')) === item.product_id && 
            $(product).attr('data-step') === "2"
          )
        );
        const hasStep4InCart = giftProductsInCart.some(item => 
          offerProducts.some(product => 
            parseInt($(product).data('product-id')) === item.product_id && 
            $(product).attr('data-step') === "4"
          )
        );

        if (!hasStep2InCart && !hasStep4InCart) {
          // No gifts in cart - add one of each
          if (step2Product) {
            //await CartJS.addItem(step2Product, 1);
          }
          if (step4Product) {
            //await CartJS.addItem(step4Product, 1);
          }
          //await new Promise(resolve => setTimeout(resolve, 1000));
        } else if (hasStep2InCart && !hasStep4InCart) {
          // Only step 2 in cart - add step 4
          if (step4Product) {
            //await CartJS.addItem(step4Product, 1);
            //await new Promise(resolve => setTimeout(resolve, 500));
          }
        } else if (!hasStep2InCart && hasStep4InCart) {
          // Only step 4 in cart - add step 2
          if (step2Product) {
            //await CartJS.addItem(step2Product, 1);
            //await new Promise(resolve => setTimeout(resolve, 500));
          }
        }
      } else if (currentStep === 2 || currentStep === 3) {
        // Handle step 2/3 - add one step 2 product if no gifts in cart
        if (giftProductsInCart.length === 0) {
          let step2Product;
          if (hasChien) {
            step2Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chien"][data-step="2"]').first().attr('data-variant-id');
          } else if (hasChat) {
            step2Product = $('.product-offer__drawer--products .product-card-offer[data-product-category="chat"][data-step="2"]').first().attr('data-variant-id');
          }
          
          if (step2Product) {
            //await CartJS.addItem(step2Product, 1);
            //await new Promise(resolve => setTimeout(resolve, 500));
          }
        }
      }

      // Wait before redirecting to ensure items are added
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 1000);
      
    } catch (error) {
      console.error('Error:', error);
      // Restore button state in case of error
      if (priceContainer) priceContainer.classList.remove('hide');
      if (loadingEl) loadingEl.classList.add('hide');
    }
});

// abonnement 2 page

if (document.querySelectorAll('.abonnement-type-tags__container').length > 0) {
  document.querySelector('.abonnement-tags__title').addEventListener('click', function(){
    this.parentNode.classList.toggle('active');
  })
  document.querySelector('.abonnement-tags__validation-button').addEventListener('click', function(){
    this.parentNode.classList.remove('active');
  })
}
if (document.querySelectorAll('.abonnement-product__accordion-button').length > 0) {


  var abonnementAccordion = document.querySelectorAll('.abonnement-product__accordions-container');
  for (let x = 0; x < abonnementAccordion.length; x++) {
    var abonnementProductQuestion = abonnementAccordion[x].querySelectorAll('.abonnement-product__accordion-button');
    for (let i = 0; i < abonnementProductQuestion.length; i++) {
      abonnementProductQuestion[i].addEventListener('click', function(){
        console.log(this);
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          if (abonnementAccordion[x].querySelectorAll('.abonnement-product__accordion-button.active').length > 0) {
            if (abonnementAccordion[x].querySelector('.abonnement-product__accordion-button.active') != this) {
              abonnementAccordion[x].querySelector('.abonnement-product__accordion-button.active').nextElementSibling.style.maxHeight = 0;
              abonnementAccordion[x].querySelector('.abonnement-product__accordion-button.active').classList.remove('active');
            }
          }
        }
        if (this.classList.contains('active')) {
          this.classList.remove('active');
          this.nextElementSibling.style.maxHeight = 0;
        } else {
          this.classList.add('active');
          this.nextElementSibling.style.maxHeight = (this.nextElementSibling.scrollHeight + 12) +  "px";
          this.nextElementSibling.style.height = (this.nextElementSibling.scrollHeight + 12) +  "px";
        }
      })
    }

  }

}

// tags logic

if (document.querySelectorAll('.abonnement-type-tags__container').length > 0) {

  document.addEventListener('DOMContentLoaded', function(){
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      var checkedTypeInputs = document.querySelectorAll('.abonnement-type-tags input:checked').length;
      if (checkedTypeInputs > 0) {
        // document.querySelector('.abonnement-type-tags input:checked').checked = false;
      }
    }
    abonnementProducts();
  })

  document.querySelector('.abonnement-tags__container').addEventListener('change', function(){
    window.dispatchEvent(new Event('resize'));
    abonnementProducts();
    var checkedTypeInputs = document.querySelectorAll('.abonnement-type-tags input:checked').length;
    if (checkedTypeInputs > 0) {
      document.querySelector('.abonnement-tags__title.mobile-only').innerHTML = 'catégories ('+ checkedTypeInputs +')';
    } else {
      document.querySelector('.abonnement-tags__title.mobile-only').innerHTML = 'Choisir une catégorie';
    }
  })


  var abonnementTypeInputs = document.querySelectorAll('.abonnement-type-tags input');
  for (let i = 0; i < abonnementTypeInputs.length; i++) {
    abonnementTypeInputs[i].addEventListener('click', function(){
      cbChange(this)
    })
  }
  function cbChange(obj) {
    var cbs = document.querySelectorAll(".abonnement-type-tags input");
    for (var i = 0; i < cbs.length; i++) {
        cbs[i].checked = false;
    }
      obj.checked = true;
  }


  function abonnementProducts() {
    var tag_animal = document.querySelector('input[name="animal-tags"]:checked').value;
    var tag_animal_array = [];
    tag_animal_array.push(tag_animal.split(','))

    var tag_type = [];
    var tag_type_array = [];

    var tag_type_all = document.querySelectorAll('input.type-tag:checked');

    for (let i = 0; i < tag_type_all.length; i++) {
        var tag = tag_type_all[i].value;
        tag_type.push(tag.split(','));
    }


    tag_animal_array = tag_animal_array.flat();
    tag_type_array = tag_type.flat();

    console.log('animal tags : ' , tag_animal_array);
    console.log('type tags : ' , tag_type_array);

    // Hide category tags with no matching products for current animal filter
    var typeTagInputs = document.querySelectorAll('input.type-tag');
    var availableTypeTagInputs = [];

    for (let i = 0; i < typeTagInputs.length; i++) {
      var typeInput = typeTagInputs[i];
      var currentTypeTags = typeInput.value.split(',');
      var hasMatchForCategory = false;
      var allProductsForCategory = document.querySelectorAll('.abonnement-product');

      for (let j = 0; j < allProductsForCategory.length; j++) {
        var productForCategory = allProductsForCategory[j];
        var categoryProductTags = (productForCategory.getAttribute('data-abonnement-product-tag') || '').split(',');
        if (categoryProductTags.some(r => tag_animal_array.includes(r)) && categoryProductTags.some(r => currentTypeTags.includes(r))) {
          hasMatchForCategory = true;
          break;
        }
      }

      var categoryLabel = typeInput.nextElementSibling;
      if (hasMatchForCategory) {
        typeInput.style.display = '';
        if (categoryLabel) {
          categoryLabel.style.display = '';
        }
        availableTypeTagInputs.push(typeInput);
      } else {
        typeInput.checked = false;
        typeInput.style.display = 'none';
        if (categoryLabel) {
          categoryLabel.style.display = 'none';
        }
      }
    }

    if (availableTypeTagInputs.length > 0 && document.querySelectorAll('input.type-tag:checked').length === 0) {
      availableTypeTagInputs[0].checked = true;
      tag_type_array = availableTypeTagInputs[0].value.split(',');
    }

    // products

    var abonnement_products = document.querySelectorAll('.abonnement-product');

    for (let i = 0; i < abonnement_products.length; i++) {
        var product = abonnement_products[i];
        var product_tags = product.getAttribute('data-abonnement-product-tag');

        var product_tags_array = [];

        product_tags_array.push(product_tags.split(','));
        product_tags_array = product_tags_array.flat();
        if (tag_type_array.length > 0) {
          if (product_tags_array.some(r=> tag_animal_array.includes(r)) && product_tags_array.some(r=> tag_type_array.includes(r))) {
            product.classList.add('active');
          } else {
            product.classList.remove('active');
          }
        } else {
          if (product_tags_array.some(r=> tag_animal_array.includes(r))) {
            product.classList.add('active');
          } else {
            product.classList.remove('active');
          }
        }
        // console.log('product tags : ' , product_tags_array);

    }
  }

}

// rotate flip card product page

navigator.sayswho= (function(){
  var ua= navigator.userAgent;
  var tem;
  var M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if(/trident/i.test(M[1])){
      tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE '+(tem[1] || '');
  }
  if(M[1]=== 'Chrome'){
      tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
      if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
  }
  M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
  if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
  return M.join(' ');
})();

if (navigator.sayswho != "Safari 14" && navigator.sayswho != "Safari 13" && navigator.sayswho != "Safari 12" && navigator.sayswho != "Safari 11" && navigator.sayswho != "Safari 10") {
  setTimeout(() => {
    if (document.querySelectorAll('.flip-card').length > 0) {

      
      if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        rotate180()
        // var IntervalRotate0 = setInterval(rotate0, 2000);
        var IntervalRotate180 = setInterval(rotate180, 4000);

        const hoveredItems = [];

        document.querySelector('.product-information-content').addEventListener('mouseover', function(e){
          // clearInterval(IntervalRotate0);
          clearInterval(IntervalRotate180);
          document.querySelector('.flip-card:first-child .flip-card-inner').style.transform = 'rotateY(0deg)';
          console.log('stop')

          const pages = [];

          const PDP_SELECTOR = $('#pdp-selector').attr('data-product-handle');

          if(sessionStorage.getItem('hover_events')) {

            if(!JSON.parse(sessionStorage.getItem('hover_events'))['pages'].includes(PDP_SELECTOR)) {
              pages.push(...JSON.parse(sessionStorage.getItem('hover_events'))['pages'])
            }

            if(hoveredItems.includes($(e.target).closest('.flip-card').find('.flip-card-front p').text())) {
              return;
            } else {

              if(JSON.parse(sessionStorage.getItem('hover_events'))['pages'].includes(PDP_SELECTOR) && hoveredItems.includes($(e.target).closest('.flip-card').find('.flip-card-front p').text())) {
                return;
              } else {
  
                hoveredItems.push($(e.target).closest('.flip-card').find('.flip-card-front p').text());
  
                pages.push(PDP_SELECTOR);
                sessionStorage.setItem('hover_events', JSON.stringify({
                  pages: pages
                }));

                let detail = {
                  type: 'hover_product_USP',
                  hover_text: $(e.target).closest('.flip-card').find('.flip-card-front p').text()
                };
                if($(e.target).closest('.flip-card').find('.flip-card-front p').text()) {
                  let clickevent = new CustomEvent("hb_hover_action", { detail: detail });
                  window.dispatchEvent(clickevent);
                }
              }
            }
            
          } else {
            pages.push(PDP_SELECTOR);
            hoveredItems.push($(e.target).closest('.flip-card').find('.flip-card-front p').text());
            sessionStorage.setItem('hover_events', JSON.stringify({
              pages: pages
            }));
            let detail = {
              type: 'hover_product_USP',
              hover_text: $(e.target).closest('.flip-card').find('.flip-card-front p').text()
            };
            
            if($(e.target).closest('.flip-card').find('.flip-card-front p').text()) {
              let clickevent = new CustomEvent("hb_hover_action", { detail: detail });
              window.dispatchEvent(clickevent);
            }
          }

          
        })
      } else {
        // document.querySelector('.product-information-content').addEventListener('click', function(){
        //   clearInterval(IntervalRotate0);
        //   clearInterval(IntervalRotate180);
        //   document.querySelector('.flip-card:first-child .flip-card-inner').style.transform = 'rotateY(0deg)';
        //   console.log('stop')

        // })
        for (let i = 0; i < document.querySelectorAll('.flip-card').length; i++) {
          const element = document.querySelectorAll('.flip-card')[i];
          element.addEventListener('click', function(){
            // clearInterval(IntervalRotate180);
            document.querySelector('.flip-card:first-child .flip-card-inner').style.transform = 'rotateY(0deg)';
            if (this.querySelector('.flip-card-inner').classList.contains('active')) {
              this.querySelector('.flip-card-inner').classList.remove('active');
            } else {
              if (document.querySelectorAll('.flip-card-inner.active').length > 0) {
                if (document.querySelector('.flip-card-inner.active') != this.querySelector('.flip-card-inner')) {
                  document.querySelector('.flip-card-inner.active').classList.remove('active');
                }
              }
              this.querySelector('.flip-card-inner').classList.add('active');
            }
          })
        }
      }

      function rotate180() {
          document.querySelector('.flip-card:first-child .flip-card-inner').style.transform = 'rotateY(180deg)';
          setTimeout(() => {
            document.querySelector('.flip-card:first-child .flip-card-inner').style.transform = 'rotateY(0deg)';
          }, 2000);
      }

      // function rotate0() {
      //     document.querySelector('.flip-card:first-child .flip-card-inner').style.transform = 'rotateY(0deg)';
      //     console.log('rotate0')
      // }

    }
  }, 2000);
}
// questionnaire

// step 2




// step 4

if (document.querySelectorAll('.questionnaire-banner-step-4__inputs-container').length > 0) {
  var step4 = document.querySelector('.questionnaire-banner-step-4__inputs-container');
  step4.addEventListener('change', function(){
      var step4_inputs = step4.querySelectorAll('input:checked');
      if (step4_inputs.length >= 3) {
          step4.classList.add('disable');
      } else {
          step4.classList.remove('disable');
      }
  })
}

// abonnement upsell sidecart

if (document.querySelectorAll('.cart_upsell-achat-unique-only').length > 0) {
  var achatUniqueButton = document.querySelector('.cart_upsell-achat-unique-button');
  if (achatUniqueButton) {
    achatUniqueButton.addEventListener('click', function(){
      document.querySelector('.cart_upsell-achat-unique__abonnement-popup').classList.add('active');
      window.dispatchEvent(new Event('resize'));
      document.querySelector('.abonnement-products-popup__products-list').innerHTML = "";
      // document.querySelector('.cart_upsell-achat-unique__abonnement-popup-products--container').classList.remove('hide');
      // document.querySelector('.cart_upsell-achat-unique__abonnement-popup--container').classList.add('hide');
    })
  }

  document.querySelector('.abonnement-popup__close-button').addEventListener('click', function(){
    document.querySelector('.cart_upsell-achat-unique__abonnement-popup').classList.remove('active');
    window.dispatchEvent(new Event('resize'));
    document.querySelector('.abonnement-products-popup__products-list').innerHTML = "";
    // document.querySelector('.cart_upsell-achat-unique__abonnement-popup-products--container').classList.remove('hide');
    // document.querySelector('.cart_upsell-achat-unique__abonnement-popup--container').classList.add('hide');
  })

}


/*customElements.define(
  'yotpo-reviews-dynamics',
  class YotpoReviewsDynamics extends HTMLElement {
    constructor() {
      super();

      let selectors = {
        "yotpoAverage": "[data-yotpo-average]",
        "yotpoReviews": "[data-yotpo-reviews]",
      };

      this.selectors = selectors;

      this.reviews = {};
      this.yotpoAverage = this.querySelector(this.selectors.yotpoAverage);
      this.yotpoReviews = this.querySelector(this.selectors.yotpoReviews);
      this.init();
    }

    async init() {
      this.reviews = await this.getReview();
      this.generateAverage(this.reviews);

      var reviewsSelected = [];
      for (let index = 0; index < this.reviews.response.reviews.length; index++) {
        if (this.reviews.response.reviews[index].score == 5 && this.reviews.response.reviews[index].content.length > 60) {
          reviewsSelected.push(this.reviews.response.reviews[index]);
        }
      }
      console.log(reviewsSelected);

      this.generateReviews(reviewsSelected);
    }

    async getReview() {
      return await fetch("https://api-cdn.yotpo.com/v1/widget/ib3UZsEMCWTakCBdQIiLYciJnTn4wbwvcu2EfhwC/products/yotpo_site_reviews/reviews.json?per_page=25", {
        method: 'GET',
      })
        .then((response) => response.json())
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    generateAverage(reviews) {
      console.log(reviews);

      var totalRate = (reviews.response.bottomline.average_score).toFixed(1);
      var starsNumber = Math.round(totalRate);

      var star = `
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_7035_811)">
        <path d="M12.5009 0L16.3625 8.22984L25 9.5494L18.7514 15.9541L20.226 25L12.5009 20.7288L4.77398 25L6.25047 15.9541L0 9.5494L8.63746 8.22984L12.5009 0Z" fill="#628D83"/>
        </g>
        <defs>
        <clipPath id="clip0_7035_811">
        <rect width="25" height="25" fill="white"/>
        </clipPath>
        </defs>
      </svg>
      `
      var starsContainer = '';
      for (let i = 0; i < starsNumber; i++) {
        starsContainer += star;
      }

      // generate html
      const markup = `
        <div class="homepage-reviews-average">
        4.7/5
        </div>
        <div class="reviews-social__rating">
          ${starsContainer}
        </div>
        <div class="reviews-social__text text t-9">
          +7500 avis
        </div>
      `;

      this.yotpoAverage.insertAdjacentHTML( 'beforeend', markup );
    }

    generateReviews(reviews) {

          var starsNumber = 5;
          var star = `
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_7035_811)">
            <path d="M12.5009 0L16.3625 8.22984L25 9.5494L18.7514 15.9541L20.226 25L12.5009 20.7288L4.77398 25L6.25047 15.9541L0 9.5494L8.63746 8.22984L12.5009 0Z" fill="#628D83"/>
            </g>
            <defs>
            <clipPath id="clip0_7035_811">
            <rect width="25" height="25" fill="white"/>
            </clipPath>
            </defs>
          </svg>
          `
          var starsContainer = '';
          for (let i = 0; i < starsNumber; i++) {
            starsContainer += star;
          }

          // reviews informations
          var reviewsContainer = '';
          for (let i = 0; i < 2; i++) {
            var reviewContent = reviews[i]
            if (reviewContent == null) {
              return;
            }
            var reviewDate = reviewContent.created_at.split("T")[0].split("-");
            var reviewStarsNumber = reviewContent.score;
            var reviewStarsContainer = "";
            for (let i = 0; i < reviewStarsNumber; i++) {
              reviewStarsContainer += star;
            }
            var review = `
              <div class="abonnement-review">
                  <div class="abonnement-review__stars">
                    ${reviewStarsContainer}
                  </div>
                  <p class="abonnement-review__title">${reviewContent.title}</p>
                  <div class="abonnement-review__text">${reviewContent.content}</div>
                  <div class="abonnement-review__footer">
                      <p class="abonnement-review__author">${reviewContent.user.display_name}&nbsp;&nbsp;|</p>
                      <p class="abonnement-review__time">${reviewDate[2]}/${reviewDate[1]}/${reviewDate[0]}</p>
                  </div>
              </div>
            `

            reviewsContainer += review;
          }

          this.yotpoReviews.insertAdjacentHTML( 'beforeend', reviewsContainer );
    }

  }
);*/

// header popups

if (document.querySelectorAll('.croquettes-megamenu-popup').length > 0) {
  var headerPopupOpener = document.querySelectorAll('[data-open-popup]');
  var headerPopup = document.querySelectorAll('.croquettes-megamenu-popup');
  var headerPopupOverlay = document.querySelectorAll('.croquettes-megamenu-popup__overlay');

  for (let i = 0; i < headerPopupOpener.length; i++) {
    headerPopupOpener[i].addEventListener('click', function(e){
      e.preventDefault();
      headerPopup[i].classList.add('active');
      headerPopupOverlay[i].classList.add('active');
    })

    headerPopupOverlay[i].addEventListener('click', function(){
      headerPopup[i].classList.remove('active');
      headerPopupOverlay[i].classList.remove('active');
    })

    headerPopup[i].querySelector('.croquettes-megamenu-popup__close').addEventListener('click', function(){
      headerPopup[i].classList.remove('active');
      headerPopupOverlay[i].classList.remove('active');
    })

  }
}

// burger menu

document.addEventListener("DOMContentLoaded", function() {
  var burgerMenuAccordions = document.querySelectorAll('[data-header-side-nav] [data-accordion-trigger]');
  for (let i = 0; i < burgerMenuAccordions.length; i++) {
    const element = burgerMenuAccordions[i];
    if (element.classList.contains('should-be-open')) {
      element.click();
    }
  }
});

if (document.querySelectorAll('.announcement-bar').length > 0 && document.querySelectorAll('#shopify-section-header').length > 0) {
  var annoncementbar = document.querySelector('.announcement-bar');
  var header = document.querySelector('#shopify-section-header');

  header.prepend(annoncementbar);
}

// page collection

setTimeout(() => {
  if (window.location.href.indexOf("?bien-etre") > -1 && document.querySelectorAll("#bien-etre").length > 0) {
    const element = document.getElementById("bien-etre");
    const y = element.getBoundingClientRect().top + window.scrollY;
    if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      window.scroll({
        top: y-90,
        behavior: 'smooth'
      });
    } else {
      window.scroll({
        top: y-115,
        behavior: 'smooth'
      });
    }
  }
}, 1000);

const setAllToMaxHeight = (className) => {
  var elements = document.querySelectorAll(className);
  var arrayLength = elements.length;
  var heights = [];

  for (var i = 0; i < arrayLength; i++) {
    heights.push(elements[i].offsetHeight);
  }

  function getHighest() {
    return Math.max(...heights);
  }

  var tallest = getHighest();

  for (let i = 0; i < elements.length; i++) {
    elements[i].style.height = tallest + 'px';
  }
};


// image text dynamic number

if (document.querySelectorAll('.image-text-dynamic-number__number').length > 0) {
  (function(){

    // Declate variable
    var counter = document.querySelector(".image-text-dynamic-number__number");
    var executed = false;

    const observer = new window.IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !executed) {
        var elemStart = counter.innerText;
        var elemEnd = counter.getAttribute('data-value');
        countUp(counter, elemStart, Number(elemEnd), 5);

        executed = true;
        console.log('ENTER', executed)
        return
      }
      console.log('LEAVE')
    }, {
        root: null,
        threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
    })

    observer.observe(counter);

    function countUp(selector, min, max, duration) {
      var inter = setInterval(function() {
        selector.innerHTML = ++min;
        if(min >= max) {
          clearInterval(inter);
        }
      }, duration);
    }

  })();
}

// remove opacity from reassurance slider mobile

if (document.querySelectorAll('.reassurance__container.slides-opacity').length > 0) {
  document.addEventListener('DOMContentLoaded', function(){
      document.querySelector('.reassurance__container.slides-opacity').classList.remove('slides-opacity');
  })
}

// reassurance accordion

if (document.querySelectorAll('.reassurance-accordions__container').length > 0) {


  var reassuranceAccordionsContainer = document.querySelectorAll('.reassurance-accordions__container');
  for (let x = 0; x < reassuranceAccordionsContainer.length; x++) {
    var reassuranceAccordionOpener = reassuranceAccordionsContainer[x].querySelectorAll('.reassurance-accordion__opener');
    for (let i = 0; i < reassuranceAccordionOpener.length; i++) {
      reassuranceAccordionOpener[i].addEventListener('click', function(){
        if (this.classList.contains('active')) {
          this.classList.remove('active');
          this.nextElementSibling.style.maxHeight = 0;
        } else {
          this.classList.add('active');
          this.nextElementSibling.style.maxHeight = (this.nextElementSibling.scrollHeight + 12) +  "px";
          this.nextElementSibling.style.height = (this.nextElementSibling.scrollHeight + 12) +  "px";
        }
      })
    }

  }

}
// section bundle
customElements.define(
  'section-bundle',
  class sectionBundle extends HTMLElement {
    constructor() {
      super();
      let selectors = {
        "bundleProduct": '.bundle-product',
        "accordionButton": '.bundle__product-accordion__button',
        "productCta": '.bundle__product-cta',
        "totalCta": '.bundle__cart--button',
        "fakeCart": ".bundle__cart",
        "fakeCartItems": '.bundle__cart--product',
        "fakeCartItemsRemove": '.bundle__cart--product .remove',
        "productList": '.bundle__product-list'
      }

      this.selectors = selectors;

      this.bundleProduct = this.querySelectorAll(this.selectors.bundleProduct);
      this.accordionButton = this.querySelectorAll(this.selectors.accordionButton);
      this.productCta = this.querySelectorAll(this.selectors.productCta);
      this.totalCta = this.querySelector(this.selectors.totalCta);
      this.fakeCartItems = this.querySelectorAll(this.selectors.fakeCartItems);
      this.fakeCart = this.querySelector(this.selectors.fakeCart);
      this.fakeCartItemsRemove = this.querySelectorAll(this.selectors.fakeCartItemsRemove);
      this.bundleProductList = this.querySelector(this.selectors.productList);
      var gtmContainer = [];
      
      var pageBanner = document.querySelector('[data-section-type="join-equipe"]');

      
      window.addEventListener('scroll', () => {
        if (this.bundleProductList) {
          if (window.matchMedia("(max-width: 767px)").matches) {
            const rect = this.bundleProductList.getBoundingClientRect();
            const isVisible = rect.top <= window.innerHeight && rect.bottom >= 0;
        
            if (isVisible) {
              this.fakeCart.classList.add('visible');
            }
          } else {
            const rect = this.bundleProductList.getBoundingClientRect();
            const elementMiddle = rect.top + rect.height / 2; // Calculate the middle of the element
            const isVisible = elementMiddle >= 0 && elementMiddle <= window.innerHeight;

            if (isVisible) {
              this.fakeCart.classList.add('visible');
            }
          }
        }
      });

      this.bundleProduct.forEach(product => {
        const decrementButton = product.querySelector('.decrement');
        const incrementButton = product.querySelector('.increment');
        const quantityInput = product.querySelector('.quantity-input');

        const updateQuantity = (change) => {
          const currentValue = parseInt(quantityInput.value);
          const minValue = parseInt(quantityInput.min) || 1;
          quantityInput.value = Math.max(currentValue + change, minValue);
        };

        decrementButton.addEventListener('click', () => updateQuantity(-1));
        incrementButton.addEventListener('click', () => updateQuantity(1));
      })

      this.accordionButton.forEach(button => {
        button.addEventListener('click', function() {
          this.classList.toggle('active');
          const content = this.nextElementSibling;
          const maxHeight = this.classList.contains('active') ? `${content.scrollHeight + 12}px` : '0';
          content.style.maxHeight = maxHeight;
          content.style.height = maxHeight;
        });
      });

      this.fakeCartItemsRemove.forEach(removeButton => {
        removeButton.addEventListener('click', () => {
          const cartFullPrice = document.querySelector('.bundle__cart--price');
          const productId = removeButton.parentElement.getAttribute('data-product-id');
          const variantName = removeButton.parentElement.getAttribute('data-variant-name');
          cartFullPrice.innerHTML = (
            (Number(cartFullPrice.innerHTML) - Number(removeButton.parentElement.getAttribute('data-variant-price')))
            .toFixed(2)
          );
          let foundMatch = false;
          // à terminer
          gtmContainer.forEach((product, index) => {
              console.log(`Checking productId: ${product.productId} against productId: ${productId} and variantName : ${product.productVariant} against variantName : ${variantName}`);
              if (String(product.productId) === String(productId) && String(product.productVariant) === String(variantName)) {
                  gtmContainer.splice(index, 1);
                  foundMatch = true;
                  console.log(`Removed product with ID ${productId}`);
              }
          });
          
          removeButton.parentElement.querySelector('span').remove();
          removeButton.parentElement.querySelector('img').remove();
          removeButton.parentElement.removeAttribute('data-variant-id');
          removeButton.parentElement.removeAttribute('data-product-id');
          removeButton.parentElement.removeAttribute('data-variant-name');
          removeButton.parentElement.removeAttribute('data-quantity-id');
          removeButton.parentElement.removeAttribute('data-variant-price');
          removeButton.parentElement.classList.remove('full');
          if (this.querySelectorAll('.bundle__cart--product.full').length == 0) {
            removeButton.parentElement.parentElement.parentElement.classList.remove('active');
            if (window.innerWidth > 800) {
              // pageBanner.removeAttribute('hidden');
            }
          }
          // gtmContainer
        })
      });

      if (this.totalCta) {
        this.totalCta.addEventListener('click', () => {
          var totalItems = [];
          for (let i = 0; i < this.fakeCartItems.length; i++) {
            var fakeCartItem = this.fakeCartItems[i];
            if (fakeCartItem.classList.contains('full')) {
              var id = fakeCartItem.getAttribute('data-variant-id');
              var quantity = fakeCartItem.getAttribute('data-quantity-id');
              var data = '';
          
              data = {
                'id': id,
                'quantity': quantity
              };
          
              totalItems.push(data);
            }
          }
        
          CartJS.addItems(totalItems, {
            "success": async function(data, textStatus, jqXHR) {
              console.log('data', data);
              console.log('gtmContainer before processing:', gtmContainer);

              // Process each product separately
              gtmContainer.forEach(product => {
                  // Format single product for GTM
                  const formattedProduct = [{
                      productId: product.productId,
                      productName: product.productName,
                      productPrice: parseFloat(product.productPrice),
                      ProductType: product.ProductType || "",
                      productList: product.productList || "",
                      espece: product.espece || "Chat et chien",
                      productVariant: product.productVariant || "",
                      quantity: parseInt(product.quantity),
                      discount: parseFloat(product.discount || 0)
                  }];

                  // Trigger GTM event for each product individually
                  setTimeout(() => {
                      var params = {
                          cartId: CartJS.cart.token,
                          cartItem: CartJS.cart.item_count,
                          cartTotal: CartJS.cart.total_price
                      };

                      gtmAddToCart(params, formattedProduct);
                  }, 500);
              });
            },
            "error": function(jqXHR, textStatus, errorThrown) {
              console.log('error', textStatus);
            }
          });
        })
      }

      this.productCta.forEach(button => {
        button.addEventListener('click', () => {
          const variantId = button.closest('.bundle-product').querySelector('.bundle__product-variant input:checked').value;
          const productId = button.closest('.bundle-product').getAttribute('data-product-id');
          const variantName = button.closest('.bundle-product').querySelector('input:checked + label').getAttribute('data-variant-title');
          const quantity = button.closest('.bundle-product').querySelector('.quantity-input').value;
          const variantPrice = Number(button.closest('.bundle-product').querySelector('.bundle__product-variant input:checked').getAttribute('data-variant-price')) * quantity;
          const image = button.closest('.bundle-product').querySelector('.carousel-cell:first-child').getAttribute('src');
          
          const items = [{ id: variantId, quantity, image, variantPrice }];
    
          if (!this.fakeCartItems.length > 0) {
            CartJS.addItems(items, {
              success: async (data) => {
                console.log('data', data);
                
                // Format product for GTM
                const gtmProduct = {
                    productId: button.closest('.bundle-product').getAttribute('data-product-id'),
                    productName: button.closest('.bundle-product').getAttribute('data-product-name'),
                    productPrice: parseFloat(button.closest('.bundle-product').querySelector('.bundle__product-variant input:checked').getAttribute('data-variant-price')),
                    ProductType: button.closest('.bundle-product').getAttribute('data-product-type'),
                    productList: (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
                    espece: button.closest('.bundle-product').getAttribute('data-product-espece'),
                    productVariant: button.closest('.bundle-product').querySelector('.bundle__product-variant input:checked + label').getAttribute('data-variant-title'),
                    quantity: parseInt(quantity),
                    discount: parseFloat(button.closest('.bundle-product').getAttribute('data-product-discount') || 0)
                };

                setTimeout(() => {
                    var params = {
                        cartId: CartJS.cart.token,
                        cartItem: CartJS.cart.item_count,
                        cartTotal: CartJS.cart.total_price
                    };

                    gtmAddToCart(params, [gtmProduct]);
                }, 500);
              },
              error: (jqXHR, textStatus, errorThrown) => {
                // Handle error
                console.log('error', textStatus);
              }
            });
          } else {
            var added = false;
            const fullPrice = Number(document.querySelector('.bundle__cart--price').innerHTML);
            const alreadyExistedElement = document.querySelector('.bundle__cart--product.full[data-variant-id="'+ variantId +'"]');
            if (alreadyExistedElement) {
              var alreadyExistedQuantity = alreadyExistedElement.getAttribute('data-quantity-id');
              var alreadyExistedPrice = alreadyExistedElement.getAttribute('data-variant-price');

              alreadyExistedElement.setAttribute('data-quantity-id', Number(alreadyExistedQuantity) + Number(quantity));
              alreadyExistedElement.setAttribute('data-variant-price', (Number(alreadyExistedPrice) + Number(variantPrice)).toFixed(2));
              alreadyExistedElement.querySelector('span').innerHTML = '(' + (Number(alreadyExistedQuantity) + Number(quantity)) + ')';
              document.querySelector('.bundle__cart--price').innerHTML = (fullPrice + variantPrice).toFixed(2);
              var bundleProductContainer = $(button).parent().parent().parent();

              var gtmProduct = {
                quantity: parseInt(quantity),
                conditionnement: bundleProductContainer.find('.bundle__product-variant input:checked + label').attr('data-variant-conditionnement'),
                taille: bundleProductContainer.find('.bundle__product-variant input:checked + label .bundle__product-variant-option0-title').text(),
                productVariant: bundleProductContainer.find('.bundle__product-variant input:checked + label').attr('data-variant-title'),
                addToCartType: 'Ajout au panier d\'un achat unique',
                productBrand: 'FranklinPetFood',
                affiliation: "Shopify Store",
                productId: bundleProductContainer.find('[data-popup-product-id]').attr('data-popup-product-id'),
                productName: bundleProductContainer.attr('data-product-name'), // Use .text() instead of innerHTML
                productPrice: parseFloat(bundleProductContainer.find('.bundle__product-variant input:checked + label .bundle__product-variant-price').text().replaceAll(' ', '').replace('€', '').replace(',', '.')),
                ProductType: bundleProductContainer.attr('data-product-type'),
                productList: (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
                espece: bundleProductContainer.attr('data-product-espece'),
                stock: bundleProductContainer.attr('data-product-stock'),
                discount: parseFloat(bundleProductContainer.attr('data-product-discount')) || 0,
              };
            
              if(bundleProductContainer.attr('data-product-review')) gtmProduct.review = bundleProductContainer.attr('data-product-review');
              if(bundleProductContainer.attr('data-product-note')) gtmProduct.note = bundleProductContainer.attr('data-product-note');

              gtmContainer.push(gtmProduct);
            } else {
              if (this.querySelectorAll('.bundle__cart--product.full').length == 4) {
                button.querySelector('.bundle__product-cta__tooltiptext').removeAttribute('hidden');
                setTimeout(() => {
                  button.querySelector('.bundle__product-cta__tooltiptext').setAttribute('hidden', 'hidden');
                }, 2000);
              } else {
                this.fakeCartItems.forEach(item => {
                  if (!item.classList.contains('full') && added == false) {
                    item.insertAdjacentHTML('beforeend', `
                      <span>(${quantity})</span>
                      <img src="${image}" alt="product-image" />
                    `)
                    item.classList.add('full');
                    item.parentElement.parentElement.classList.add('active');
                    if (window.innerWidth > 800) {
                      // pageBanner.setAttribute('hidden', 'hidden');
                    }
                    item.setAttribute('data-variant-id', variantId);
                    item.setAttribute('data-product-id', productId);
                    item.setAttribute('data-variant-name', variantName);
                    item.setAttribute('data-quantity-id', quantity);
                    item.setAttribute('data-variant-price', variantPrice);
                    added = true;
                    
                    var bundleProductContainer = $(button).parent().parent().parent();
    
                    var gtmProduct = {
                      quantity: parseInt(quantity),
                      conditionnement: bundleProductContainer.find('.bundle__product-variant input:checked + label').attr('data-variant-conditionnement'),
                      taille: bundleProductContainer.find('.bundle__product-variant input:checked + label .bundle__product-variant-option0-title').text(),
                      productVariant: bundleProductContainer.find('.bundle__product-variant input:checked + label').attr('data-variant-title'),
                      addToCartType: 'Ajout au panier d\'un achat unique',
                      productBrand: 'FranklinPetFood',
                      affiliation: "Shopify Store",
                      productId: bundleProductContainer.find('[data-popup-product-id]').attr('data-popup-product-id'),
                      productName: bundleProductContainer.attr('data-product-name'), // Use .text() instead of innerHTML
                      productPrice: parseFloat(bundleProductContainer.find('.bundle__product-variant input:checked + label .bundle__product-variant-price').text().replaceAll(' ', '').replace('€', '').replace(',', '.')),
                      ProductType: bundleProductContainer.attr('data-product-type'),
                      productList: (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
                      espece: bundleProductContainer.attr('data-product-espece'),
                      stock: bundleProductContainer.attr('data-product-stock'),
                      discount: parseFloat(bundleProductContainer.attr('data-product-discount')) || 0,
                    };
                  
                    if(bundleProductContainer.attr('data-product-review')) gtmProduct.review = bundleProductContainer.attr('data-product-review');
                    if(bundleProductContainer.attr('data-product-note')) gtmProduct.note = bundleProductContainer.attr('data-product-note');
    
                    gtmContainer.push(gtmProduct);
                  }
                });
                document.querySelector('.bundle__cart--price').innerHTML = (fullPrice + variantPrice).toFixed(2);
              }
            }
          }
        });
      })


    }
  }
)


// faq image

if (document.querySelectorAll('.faq-image__container').length > 0) {

  var faqImageAccordionOpener = document.querySelectorAll('.faq-image__accordion-block__title');
  for (let i = 0; i < faqImageAccordionOpener.length; i++) {
    faqImageAccordionOpener[i].addEventListener('click', function(){
      if (this.classList.contains('active')) {
        this.classList.remove('active');
        this.nextElementSibling.style.maxHeight = 0;
      } else {
        this.classList.add('active');
        this.nextElementSibling.style.maxHeight = (this.nextElementSibling.scrollHeight + 12) +  "px";
        this.nextElementSibling.style.height = (this.nextElementSibling.scrollHeight + 12) +  "px";
      }
    })
  }

}

// collection match perfect

setTimeout(() => {
  if (window.location.href.indexOf("/match-parfait?section=") > -1) {
    const CurrectAnchor = window.location.href.split('?section=')[1];
    const Anchorelement = document.querySelector('[data-anchor-id="' + CurrectAnchor + '"');
    const y = Anchorelement.getBoundingClientRect().top + window.scrollY;
    if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      window.scroll({
        top: y-90,
        behavior: 'smooth'
      });
    } else {
      window.scroll({
        top: y-115,
        behavior: 'smooth'
      });
    }
  }
}, 700);

// product page

if (document.querySelectorAll('.lion-points-x3').length > 0) {
  setTimeout(() => {
    var frankisX3 = document.querySelectorAll('.lion-points-x3');
    for (let i = 0; i < frankisX3.length; i++) {
      const _frankisX3 = frankisX3[i];
      var frankis = document.querySelector('[data-lion-points-for-product-id]');
      var frankisNum = Number(frankis.innerHTML);
      
      _frankisX3.textContent = (frankisNum * 3);
    }
  
    var editFrankisX3 = function() {
      for (let i = 0; i < frankisX3.length; i++) {
        const _frankisX3 = frankisX3[i];
        var frankis = document.querySelector('[data-lion-points-for-product-id]');
        var frankisNum = Number(frankis.innerHTML);
        
        _frankisX3.textContent = (frankisNum * 3);
      }
    }
    var observer = new MutationObserver(function(e) {
        editFrankisX3();
    });
  
    observer.observe(document.querySelector('[data-lion-points-for-product-id]'), {
        characterData: true,
        childList: true
    });
    
  }, 1000); 
}

// slider video

if (document.querySelectorAll('.slider-video__slide-video__container').length > 0) {
  var slideVideos = document.querySelectorAll('.slider-video__slide-video__container');
  window.addEventListener('load', function() {
    window.dispatchEvent(new Event('resize'));
  })

  for (let i = 0; i < slideVideos.length; i++) {
    const slideVideo = slideVideos[i];
    slideVideo.addEventListener('click', function(){
      if (document.querySelectorAll('.slider-video__slide-video__container.playing').length > 0) {
        if (document.querySelector('.slider-video__slide-video__container.playing') != this) {
          document.querySelector('.slider-video__slide-video__container.playing video').pause();
          document.querySelector('.slider-video__slide-video__container.playing video').currentTime = 0;
          document.querySelector('.slider-video__slide-video__container.playing').classList.remove('playing');
        }
      }
      if (slideVideo.querySelector('video').paused) {
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        slideVideo.querySelector('video').play();
        }
        slideVideo.classList.add('playing');
      } else {
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        slideVideo.querySelector('video').pause();
        }
        slideVideo.classList.remove('playing');
      }
      
    })
    slideVideo.querySelector('video').addEventListener('ended', function(){
      slideVideo.classList.remove('playing');
    })
  }
}


// product slider video

if (document.querySelectorAll('.product__slide.is-video').length > 0) {
  var productSlideVideo = document.querySelectorAll('.product__slide.is-video');

  for (let i = 0; i < productSlideVideo.length; i++) {
    const video = productSlideVideo[i];
    document.addEventListener('DOMContentLoaded', function(){
      video.querySelector('video').setAttribute('controlsList', 'nofullscreen nodownload noremoteplayback noplaybackrate');
      video.querySelector('video').setAttribute('disablepictureinpicture', '')
    })

    video.querySelector('video').addEventListener('click', function(){
      if (this.paused) {
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        this.play();
        }
        this.parentElement.classList.remove('not-playing');
      } else {
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        this.pause();
        }
        this.parentElement.classList.add('not-playing');
      }
    })

    video.querySelector('video').addEventListener('ended', function(){
      this.parentElement.classList.add('not-playing');
    })

    var triggered = 0;
    if (triggered == 0) {
      var observer = new MutationObserver(function(e) {
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          if (video.classList.contains('is-selected')) {
            // video.querySelector('video').play();
          } else {
            video.querySelector('video').pause();
            video.querySelector('video').currentTime = 0;
            video.querySelector('.has-video').classList.add('not-playing');
          }
        }
        triggered = 1;
      });
      observer.observe(video, {
          attributes: true
      });
    }
  }
}


// annoncement bar

var annoncementBarCarousel = document.querySelector('.announcement-bar .carousel');

if (annoncementBarCarousel !== null && annoncementBarCarousel !== undefined) {
  setTimeout(() => {
    annoncementBarCarousel.style.opacity = 1;
    annoncementBarCarousel.style.maxHeight = "unset";
  }, 500);
  
}

// blog recherche

let blogSearch = document.querySelector('.template-blog__search-container')
if (blogSearch !== null && blogSearch !== undefined) {
  let blogSearchInput = blogSearch.querySelector('input[type="text"]');
  let resultContainer = blogSearch.querySelector('.template-blog__search-results');
  let cleanInput = blogSearch.querySelector('.clean-input');
  let suggestions = resultContainer.innerHTML;
  document.addEventListener('click', e => {
    if (!blogSearch.querySelector('form input').contains(e.target)) {
      blogSearchInput.value = '';
      resultContainer.classList.remove('active');
      cleanInput.classList.remove('active');
    } else {
      resultContainer.classList.add('active');
    }
  });
  blogSearchInput.addEventListener('input', function(){
    if (blogSearchInput.value != "") {
      fetch(window.Shopify.routes.root + "search/suggest.json?q="+ blogSearchInput.value +"&resources[type]=article&resources[options][fields]=title")
      .then((response) => response.json())
      .then((suggestions) => {
        if (suggestions && suggestions.status != 422) {
          const articlesSuggestions = suggestions.resources.results.articles;
          resultContainer.innerHTML = "";
          if (articlesSuggestions.length > 0) {
            console.log(articlesSuggestions);
            resultContainer.classList.add('active');
            cleanInput.classList.add('active');
            for (let i = 0; i < articlesSuggestions.length; i++) {
              const article = articlesSuggestions[i];
              const pageUrl = window.location.href;
              const articleTag = article.tags;

              let articleTagLowerCase = articleTag.map(function(a) {
                a = a.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                return a;
              });
              
              if (pageUrl.indexOf("/tagged/") != -1) {
                let pageTag = pageUrl.split('/tagged/')[1];
                if (pageTag.includes('?')) {
                  pageTag = pageTag.split('?')[0];
                }
                console.log(articleTagLowerCase,pageTag )
                if (articleTagLowerCase.indexOf(pageTag) >= 0) {
                  let resultHtml = `
                    <a href="${article.url}">${article.title}</a>
                  `
                  resultContainer.innerHTML += resultHtml;
                }
              } else {
                let resultHtml = `
                  <a href="${article.url}">${article.title}</a>
                `
                resultContainer.innerHTML += resultHtml;
              }
            }
            
          } else {
            resultContainer.classList.remove('active');
          } 
        } else {
          resultContainer.innerHTML = "";
          resultContainer.classList.remove('active');
          cleanInput.classList.remove('active');
        } 
      }
    );
    } else {
      resultContainer.innerHTML = suggestions;
      cleanInput.classList.remove('active');
    }
  })
  blogSearchInput.addEventListener('keydown', function(event){
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  })
}

// product page, back in stock button
// Select the BIS trigger element
var klaviyo_bis_trigger = document.querySelector('a.product-add-to-cart.klaviyo-bis-trigger');

if (klaviyo_bis_trigger) {
  // Container that holds the normal ATC + subscription CTAs
  var productButtonsContainer = klaviyo_bis_trigger.closest('.product-buttons__container');

  // Function to check the display property and ensure CTAs container is visible when BIS is shown
  function checkDisplayAndRunCode() {
    if (!productButtonsContainer) return;

    var isVisible = getComputedStyle(klaviyo_bis_trigger).display !== 'none';

    if (isVisible) {
      productButtonsContainer.classList.remove('hide');
    }
  }

  // Create an observer instance
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'style') {
        checkDisplayAndRunCode();
      }
    });
  });

  // Configuration of the observer
  var config = { attributes: true, attributeFilter: ['style'] };

  // Pass the target node and observer configuration
  observer.observe(klaviyo_bis_trigger, config);

  // Initial check
  checkDisplayAndRunCode();
}


// accordion

var quizAccordionTitles = document.querySelectorAll('.quiz-banner__encart-text--accordion-title');
if (quizAccordionTitles.length > 0 && window.innerWidth <= 800) {
  quizAccordionTitles.forEach(title => {
    title.addEventListener('click', () => {
      var quizAccordionDescription = title.nextElementSibling;
      console.log(quizAccordionDescription)
      if (!title.classList.contains('active')) {
        title.classList.add('active');
        quizAccordionDescription.style.maxHeight = (quizAccordionDescription.scrollHeight + 32) +  "px";
        quizAccordionDescription.style.height = (quizAccordionDescription.scrollHeight + 12) +  "px";
      } else {
        title.classList.remove('active');
        quizAccordionDescription.style.maxHeight = 0;
      }
    })
  });
}
// product card cta
var productCardCta = document.querySelectorAll('.product-card__cta');
if (productCardCta.length > 0) {
  productCardCta.forEach(button => {
    button.addEventListener('click', () => {
      // FKLN-387: slider/collection AJOUTER opens side quick-buy drawer instead
      if (button.hasAttribute('data-collection-quick-buy')) return;

      const variantSpan = button.querySelector('span[data-variant-id]');
      if (!variantSpan) return;

      const variantId = variantSpan.getAttribute('data-variant-id');
      const quantity = 1;
      const items = [{ id: variantId, quantity }];
  
      CartJS.addItems(items, {
        success: async (data) => {
          console.log('data', data);
          
          // Format product for GTM
          const gtmProduct = {
            productId: button.closest('.product-card').getAttribute('data-product-id'),
            productName: button.closest('.product-card').getAttribute('data-product-name'),
            productPrice: parseFloat(button.closest('.product-card').getAttribute('data-product-price').replace('€', '').replace(',', '.')),
            ProductType: button.closest('.product-card').getAttribute('data-product-type'),
            productList: (window.location.href.split('?')[0].split('/').filter(part => part).pop()).replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
            espece: button.closest('.product-card').getAttribute('data-product-espece'),
            productVariant: variantSpan.getAttribute('data-variant-title'),
            quantity: parseInt(quantity),
            discount: parseFloat(button.closest('.product-card').getAttribute('data-product-discount')) || 0
          };

          setTimeout(() => {
            var params = {
              cartId: CartJS.cart.token,
              cartItem: CartJS.cart.item_count,
              cartTotal: CartJS.cart.total_price
            };

            gtmAddToCart(params, [gtmProduct]);
          }, 500);
        },
        error: (jqXHR, textStatus, errorThrown) => {
          // Handle error
          console.log('error', textStatus);
        }
      });
    });
  })
}
// product page - calculation de poids

const poidsDeChienInputs = document.querySelector('.product__option.poids_de_chien');

if (poidsDeChienInputs) {
  document.addEventListener('DOMContentLoaded', function(){
    dynamiqueNumbersPoids();
  });
  
  poidsDeChienInputs.addEventListener('change', function(){
    dynamiqueNumbersPoids();
  });

  function dynamiqueNumbersPoids() {
    const value = poidsDeChienInputs.querySelector('input:checked').value;
    const calculation = document.querySelectorAll('.product__option.pots .calculation span');
    if (value == '< 10 kg') {
      if (calculation[0]) {
        calculation[0].innerHTML = '50';
      }
      if (calculation[1]) {
        calculation[1].innerHTML = '100';
      }
      if (calculation[2]) {
        calculation[2].innerHTML = '150';
      }
    } else if (value == '10 - 25 kg') {
      if (calculation[0]) {
        calculation[0].innerHTML = '25';
      }
      if (calculation[1]) {
        calculation[1].innerHTML = '50';
      }
      if (calculation[2]) {
        calculation[2].innerHTML = '75';
      }
    } else if (value == '25 - 50 kg') {
      if (calculation[0]) {
        calculation[0].innerHTML = '16';
      }
      if (calculation[1]) {
        calculation[1].innerHTML = '33';
      }
      if (calculation[2]) {
        calculation[2].innerHTML = '50';
      }
    } else if (value == '> 50 kg') {
      if (calculation[0]) {
        calculation[0].innerHTML = '13';
      }
      if (calculation[1]) {
        calculation[1].innerHTML = '25';
      }
      if (calculation[2]) {
        calculation[2].innerHTML = '38';
      }
    }
  }
}

// reassurance section

customElements.define(
  'button-show-hidden-elements',
  class buttonShowHiddenElements extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const hiddenElements = this.parentElement.parentElement.querySelector('.reassurance__container.only-desktop');
      if (hiddenElements) {
        this.addEventListener('click', () => {
          hiddenElements.classList.add('show-hidden-elements');
          this.setAttribute('hidden', 'hidden');
        })
      }
    }
  }
)

// buy button options - page produit

const FRANKLIN_PURCHASE_OPTION_KEY = 'franklin_purchase_option';

function normalizePurchaseQueryValue(value) {
  if (value == null) {
    return '';
  }

  var normalized = String(value).replace(/\+/g, ' ');

  try {
    normalized = decodeURIComponent(normalized);
  } catch (error) {}

  return normalized.trim();
}

function matchPurchaseQueryPair(pair, urlParams) {
  const containsMatch = pair.match(/^(.+?)\s+contains\s+(.+)$/i);

  if (containsMatch) {
    const key = containsMatch[1].trim();
    const val = containsMatch[2].trim();
    const queryVal = normalizePurchaseQueryValue(urlParams.get(key)).toLowerCase();
    const needle = normalizePurchaseQueryValue(val).toLowerCase();

    return Boolean(needle) && queryVal.includes(needle);
  }

  const separatorIndex = pair.indexOf('=');
  if (separatorIndex === -1) {
    return false;
  }

  const key = pair.slice(0, separatorIndex).trim();
  const val = pair.slice(separatorIndex + 1).trim();
  return normalizePurchaseQueryValue(urlParams.get(key)) === normalizePurchaseQueryValue(val);
}

function matchPurchaseQueryRules(rulesString, urlParams) {
  if (!rulesString) {
    return false;
  }

  return rulesString
    .split(/\r?\n/)
    .map((rule) => rule.trim())
    .filter(Boolean)
    .some((rule) => {
      return rule.split('&').every((pair) => matchPurchaseQueryPair(pair.trim(), urlParams));
    });
}

function resolvePurchaseOptionFromUrl(urlParams, subscriptionRules, onetimeRules) {
  if (matchPurchaseQueryRules(subscriptionRules, urlParams)) {
    return 'subscription';
  }

  if (matchPurchaseQueryRules(onetimeRules, urlParams)) {
    return 'one-time';
  }

  return null;
}

function persistPurchaseOptionFromUrl(subscriptionRules, onetimeRules) {
  const resolved = resolvePurchaseOptionFromUrl(
    new URLSearchParams(window.location.search),
    subscriptionRules,
    onetimeRules
  );

  if (!resolved) {
    return;
  }

  try {
    sessionStorage.setItem(FRANKLIN_PURCHASE_OPTION_KEY, resolved);
  } catch (error) {}
}

function getPersistedPurchaseOption(fallback) {
  try {
    const stored = sessionStorage.getItem(FRANKLIN_PURCHASE_OPTION_KEY);
    if (stored === 'subscription' || stored === 'one-time') {
      return stored;
    }
  } catch (error) {}

  return fallback;
}

if (window.themeSettings && window.themeSettings.purchaseUtm) {
  const { subscriptionRules, onetimeRules } = window.themeSettings.purchaseUtm;
  persistPurchaseOptionFromUrl(subscriptionRules, onetimeRules);
}

customElements.define(
  'buy-buttons-container',
  class buyButtonsContainer extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    resolvePurchaseOptionFromUtm() {
      const urlParams = new URLSearchParams(window.location.search);
      const subscriptionRules = this.dataset.utmSubscriptionRules || '';
      const onetimeRules = this.dataset.utmOnetimeRules || '';
      const fallback = this.dataset.fallbackPurchaseOption || 'one-time';
      const fromUrl = resolvePurchaseOptionFromUrl(urlParams, subscriptionRules, onetimeRules);

      if (fromUrl) {
        try {
          sessionStorage.setItem(FRANKLIN_PURCHASE_OPTION_KEY, fromUrl);
        } catch (error) {}
        return fromUrl;
      }

      return getPersistedPurchaseOption(fallback);
    }

    applyPurchaseOption(option) {
      const oneTimeInput = this.querySelector('#one-time');
      const subscriptionInput = this.querySelector('#subscription');

      if (!oneTimeInput || !subscriptionInput) {
        return;
      }

      if (option === 'subscription') {
        subscriptionInput.checked = true;
        oneTimeInput.checked = false;
      } else {
        oneTimeInput.checked = true;
        subscriptionInput.checked = false;
      }

      this.syncPurchaseOption();
    }

    init() {
      this.syncPurchaseOption = () => {
        const oneTime = document.querySelector('[data-add-to-cart]');
        const subscription = document.querySelector('[data-subscription-activate]');
        const productSelect = document.querySelector('[data-product-select]');
        const checkedInput = this.querySelector('input[name="buy-options"]:checked');

        if (!checkedInput || !oneTime || !subscription) {
          return;
        }

        let variantAvailable = true;
        if (productSelect && productSelect.options.length > 0) {
          const selectedOption = productSelect.options[productSelect.selectedIndex];
          if (selectedOption) {
            variantAvailable = selectedOption.getAttribute('data-variant-available') === 'true';
          }
        }

        if (checkedInput.value === 'one-time') {
          oneTime.classList.remove('hidden');
          subscription.classList.add('hidden');
        } else {
          if (!variantAvailable) {
            oneTime.classList.add('hidden');
            subscription.classList.add('hidden');
            return;
          }

          oneTime.classList.add('hidden');
          subscription.classList.remove('hidden');
        }
      };

      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="buy-options"]')) {
          return;
        }

        this.syncPurchaseOption();

        const checkedInput = this.querySelector('input[name="buy-options"]:checked');
        if (!checkedInput) {
          return;
        }

        let detail = {
          type: 'pdp_product_update',
          name: 'view_subscription_choice',
          click_text: checkedInput.value === 'one-time' ? 'one-time' : 'subscription',
          click_link: '/'
        };
        let clickevent = new CustomEvent("hb_navigation_click", { detail: detail });
        window.dispatchEvent(clickevent);
      });

      const purchaseOption = this.resolvePurchaseOptionFromUtm();
      this.applyPurchaseOption(purchaseOption);
    }
  }
)

// header menu mobile

customElements.define(
  'data-menu-container',
  class dataMenuContainer extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const menuOpener = this.querySelector('[data-menu-open]');
      const menuPanel = this.querySelector('[data-menu-panel]');
      const menuClose = this.querySelector('[data-menu-close]');

      menuOpener.addEventListener('click', () => {
        menuPanel.classList.add('open');
      })
      menuClose.addEventListener('click', () => {
        menuPanel.classList.remove('open');
      })
    }
  }
)

// collection guide

customElements.define(
  'guide-popup-opener',
  class guidePopupOpener extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const popup = document.querySelector('.collection-guide-popup');
      const link = this.getAttribute('data-popup-url');
      const animalType = this.getAttribute('data-popup-animal-type');
      const tag = this.getAttribute('data-popup-tag');
      
      this.addEventListener('click', () => {
        if (popup) {
          const popupButton = popup.querySelector('.collection-guide-popup__button');
          const popupImageChien = popup.querySelector('.collection-guide-popup__image.chien');
          const popupImageChat = popup.querySelector('.collection-guide-popup__image.chat');
          
          popup.classList.remove('hide');
          popupButton.setAttribute('data-href', link);
          popupButton.setAttribute('data-tag', tag);
          if (animalType == 'chien') {
            popupImageChien.classList.remove('hide');
            popupImageChat.classList.add('hide');
          } else {
            popupImageChien.classList.add('hide');
            popupImageChat.classList.remove('hide');
          }
        }
      })
      if (window.location.hash == '#guide') {
        this.click();
      }
    }
  }
)

customElements.define(
  'guide-popup',
  class guidePopup extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const closeButton = this.querySelector('.collection-guide-popup__close');
      const downloadButton = this.querySelector('.collection-guide-popup__button');
      const fnameInput = this.querySelector('input[name="fname"]');
      const lnameInput = this.querySelector('input[name="lname"]');
      const emailInput = this.querySelector('input[name="email"]');
      
      closeButton.addEventListener('click', () => {
        this.classList.add('hide');
      });

      const validateInputs = () => {
        const isFnameNotEmpty = fnameInput.value.trim() !== "";
        const isLnameNotEmpty = lnameInput.value.trim() !== "";
        const isEmailValid = this.validateEmail(emailInput.value);
      
        // Enable download button if all conditions are met
        if (isFnameNotEmpty && isLnameNotEmpty && isEmailValid) {
          downloadButton.classList.remove('disabled');
        } else {
          downloadButton.classList.add('disabled');
        }
      };
      
      // Attach event listeners to all inputs
      fnameInput.addEventListener('input', validateInputs);
      lnameInput.addEventListener('input', validateInputs);
      emailInput.addEventListener('input', validateInputs);
      
      downloadButton.addEventListener('click', () => {
        const popup = this;
        const downloadButtonUrl = downloadButton.getAttribute('data-href');
        const email = emailInput.value;
        const fname = fnameInput.value;
        const lname = lnameInput.value;
        const tag = downloadButton.getAttribute('data-tag');
        const tag_client = 'client_downloaded_guide';

        this.download(email, fname, lname,  downloadButtonUrl, tag, tag_client, popup);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "download_guide",
          customer_data: {
            email: email
          }
        })

        let s2sevent = new CustomEvent("hb_s2s_event", { 
          detail: { 
            type: 'download_guide', 
            email: email
          } 
        });
        window.dispatchEvent(s2sevent);

      });
    }

    validateEmail(email) {
      // Regular expression for basic email format validation
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
      // Check if email is not blank and matches the pattern
      return email.trim() !== "" && emailPattern.test(email);
    }

    download(email, fname, lname, downloadButtonUrl, tag, tag_client, popup) {
      let data_make = {
        'email': email,
        'fname': fname,
        'lname': lname,
        'downloadButtonUrl': downloadButtonUrl,
        'tag': tag,
        'tag_client': tag_client
      };
      
      fetch("https://hook.eu1.make.com/ognmjuqum17nodrfh8lrvwifpxr2fsfi", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data_make)
      })
      .then(response => {

      })
      .catch((error) => {
        console.error('Error:', error);
      });

      window.open(downloadButtonUrl, '_blank');
      popup.classList.add('hide');
    }
  }
);

const articleContentH2 = document.querySelectorAll('.article_content h2');
if (articleContentH2.length > 0) {
  document.addEventListener('DOMContentLoaded', function(){
    for (let i = 0; i < articleContentH2.length; i++) {
      const _h2 = articleContentH2[i];
      _h2.setAttribute('id', `${i+1}`);
    }
  })
}

customElements.define(
  'share-mobile',
  class shareMobile extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const shareButton = this;

      // Check if the Web Share API is supported
      if (navigator.share) {
          // Show the button only on supported devices
          shareButton.style.display = "block";

          // Add a click event listener
          shareButton.addEventListener("click", async () => {
              try {
                  await navigator.share({
                      title: 'Your Page Title',
                      text: 'Check out this amazing page!',
                      url: window.location.href // Share the current page URL
                  });
                  console.log('Content shared successfully');
              } catch (error) {
                  console.error('Error sharing content:', error);
              }
          });
      }
    }
  }
)

// article page
if (document.querySelectorAll('.carousel').length > 0) {
  document.addEventListener('DOMContentLoaded', function () {
    const articleContainer = document.querySelectorAll('.carousel');

    // Create an IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Trigger the resize event
          window.dispatchEvent(new Event('resize'));
        }
      });
    });

    // Start observing the article container
    articleContainer.forEach(element => {
      observer.observe(element);
    });
  });
}

const articlePush = document.querySelector('.article-push.only-mobile');
if (articlePush) {
  // Add scroll event listener to the window
  window.addEventListener('scroll', () => {
    // Check if the user has scrolled at least one full screen height
    if (window.scrollY >= window.innerHeight) {
      articlePush.classList.add('active'); // Add the 'active' class
    }
  });

  // Add click event listener to the close button
  articlePush.querySelector('.close-button').addEventListener('click', () => {
    articlePush.remove();
  });
}

// Select the element
const articleLinkBack = document.querySelector('.article_link_back');

if (articleLinkBack) {
  // Create a dummy spacer element to detect when the sticky element becomes stuck
  const spacer = document.createElement('div');
  spacer.style.position = 'absolute';
  spacer.style.top = `${articleLinkBack.offsetTop}px`;
  spacer.style.height = '1px';
  document.body.appendChild(spacer);

  const observer = new IntersectionObserver(
    ([entry]) => {
      // Add or remove the `is-stuck` class based on intersection
      if (!entry.isIntersecting) {
        articleLinkBack.classList.add('is-stuck');
      } else {
        articleLinkBack.classList.remove('is-stuck');
      }
    },
    {
      root: null, // Observe in the viewport
      threshold: 0, // Trigger when the spacer leaves the viewport
    }
  );

  observer.observe(spacer);
}

// lecture vocal articles

const readButton = document.getElementById('readBtnVocal');
const contentContainer = document.querySelector('.article_content.rte');

if (readButton) {
    const exclusionContainer = contentContainer.querySelector('.article_summary_products-suggestion');
    // Combine all text excluding the specified element
    const combinedText = Array.from(contentContainer.childNodes)
        .filter(node =>
            node.nodeType === Node.TEXT_NODE ||
            (node.nodeType === Node.ELEMENT_NODE && !exclusionContainer.contains(node))
        )
        .map(node => node.textContent.trim())
        .filter(text => text) // Filter out empty strings
        .join(' '); // Join all text with a space

    // Initialize variables for speech synthesis
    let utterance = null;
    let isReading = false;

    // Helper function to set the voice
    const setVoice = (utterance) => {
        const voices = speechSynthesis.getVoices();
        const thomasVoice = voices.find(voice => voice.name === 'Thomas' && voice.lang === 'fr-FR');
        utterance.voice = thomasVoice || voices.find(voice => voice.lang === 'fr-FR') || voices[0];
    };

    // Define the toggle function
    const toggleReading = () => {
        if (!utterance) {
            // Create a new SpeechSynthesisUtterance instance
            utterance = new SpeechSynthesisUtterance(combinedText);
            utterance.lang = 'fr-FR'; // Set language, adjust as needed
            utterance.rate = 1; // Set rate (0.1 to 10, default is 1)
            utterance.pitch = 1.5; // Set pitch (0 to 2, default is 1)

            // Set the voice to "Thomas" or default
            setVoice(utterance);

            // Reset isReading when the speech ends
            utterance.onend = () => {
                isReading = false;
                utterance = null;
                readButton.textContent = 'Écouter';
            };
        }

        if (isReading) {
            speechSynthesis.pause();
            isReading = false;
            readButton.textContent = 'Écouter';
        } else {
            // If paused, resume; otherwise, start speaking
            if (speechSynthesis.paused) {
                speechSynthesis.resume();
            } else {
                speechSynthesis.speak(utterance);
            }
            isReading = true;
            readButton.textContent = 'Pause';
        }
    };

    // Add event listener to the button
    readButton.addEventListener('click', toggleReading);

    // Stop speaking and clear state on page reload
    window.addEventListener('beforeunload', () => {
        speechSynthesis.cancel();
    });

    // Ensure voices are loaded before using them
    if (speechSynthesis.getVoices().length === 0) {
        speechSynthesis.onvoiceschanged = () => setVoice(null);
    }
}

window.ongoingRequests = new Set();

$(document).on('click', '.product-card-offer', function(e) {
  // Don't trigger if clicking the actual button (to avoid double triggers)
  if (!$(e.target).closest('.product-card-offer__button').length) {
      // Find the button inside this card and click it
      $(this).find('.product-card-offer__button').click();
  }
});

// Keep your original button click handler exactly as is
$(document).on('click', '.product-card-offer__button:not([disabled])', function(e) {
  e.preventDefault(); 
  
  var $button = $(this);
  var $container = $button.closest('.product-card-offer');
  var variantId = $button.data('variant-id');
  var productType = $button.data('product-type');
  var category = $container.data('product-category');
  var drawerSidecard = document.querySelector('.product-offer__drawer');

  let tier = $container.attr('data-step') == '2' ? 1 : 2;
  
  if (window.ongoingRequests.has(variantId)) {
      return;
  }
  window.ongoingRequests.add(variantId);
  
  // Show loading state
  $button.prop('disabled', true);
  $container.addClass('disable');
  $('[data-cart-loader]').css('display', 'block');
  
  if (productType) {
      CartJS.addItem(variantId, 1, {
          "Type": productType,
          "__free_gift": "tier_" + tier
      });
  } else {
      CartJS.addItem(variantId, 1, {
        "__free_gift": "tier_" + tier
    });
  }
  
  // Disable all products of same category
  $('.product-card-offer[data-product-category="' + category + '"]').each(function() {
      $(this).addClass('disable');
      $(this).find('.product-card-offer__button').prop('disabled', true);
  });
  
  setTimeout(() => {
      window.ongoingRequests.delete(variantId);
      $('[data-cart-loader]').css('display', 'none');
      drawerSidecard.classList.remove('open');
  }, 1000);
});

document.addEventListener('DOMContentLoaded', function() {
  // Check if URL has the parameter
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('open_sidecard')) {
      // Find and click the cart icon to open the sidecard
      const cartIcon = document.querySelector('[data-cart-toggle]');
      if (cartIcon) {
          cartIcon.click();
      }
  }

  function promoScrollListener() {

    const promoPositions = [];

    $(window).on('resize scroll', function() {
  
      $('.encart__article').each(function(){

        if(!promoPositions.includes(parseInt($(this).attr('data-position')))) {
          if(isInViewport(this)) {
  
            promoPositions.push(parseInt($(this).attr('data-position')));

            const imageFileName = $(this).find("img").attr('src').split('/').pop().split('?')[0];
    
            let detail = {
              promo_id: $(this).find("a").attr('href'),
              promo_name: "internal_promo_click_collection",
              promo_type: "promo_view",
              promo_position: parseInt($(this).attr('data-position')),
              creative_id: imageFileName,
            }
          
            let clickevent = new CustomEvent("hb_promo_click", { detail: detail });
            window.dispatchEvent(clickevent);
    
          }
        }
     });
    });
  }

  if($('.encart__article').length) {
    promoScrollListener();
  }

  function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    var html = document.documentElement;
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth)
    );
  }

  document.querySelector('.side-nav__customized-block').addEventListener('click', function() { 

    const imageFileName = $(this).find("img").attr('src').split('/').pop().split('?')[0];

    let detail = {
      promo_id: $(this).attr('href'),
      promo_name: "internal_promo_click_navigation",
      promo_type: "promo_click",
      creative_id: imageFileName,
    }

    let clickevent = new CustomEvent("hb_promo_click", { detail: detail });
      window.dispatchEvent(clickevent);
    });

});
if($('.encart__article').length) {
  $('.encart__article').click(function() {

    const imageFileName = $(this).find("img").attr('src').split('/').pop().split('?')[0];

    let detail = {
      promo_id: $(this).find("a").attr('href'),
      promo_name: "internal_promo_click_collection",
      promo_type: "promo_click",
      promo_position: parseInt($(this).attr('data-position')),
      creative_id: imageFileName,
    }
  
    let clickevent = new CustomEvent("hb_promo_click", { detail: detail });
    window.dispatchEvent(clickevent);
  
  });
}

// Mobile menu sublink accordion
document.addEventListener('DOMContentLoaded', function() {
  const sublinkAccordions = document.querySelectorAll('[data-sublink-accordion]');
  
  sublinkAccordions.forEach(accordion => {
    accordion.addEventListener('click', function(e) {
      const panel = this.closest('.side-nav__sublink-parent').querySelector('[data-sublink-panel]');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      if (panel) {
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          panel.classList.remove('open');
        } else {
          this.setAttribute('aria-expanded', 'true');
          panel.classList.add('open');
        }
      }
    });
  });
});
